// This file is auto-generated by @hey-api/openapi-ts

import {
    type Client,
    type Options as ClientOptions,
    formDataBodySerializer,
    type TDataShape,
} from "@hey-api/client-fetch";
import { client as _heyApiClient } from "./client.gen";
import type {
    ActivateMutationData,
    ActivateMutationError,
    ActivateOriginData,
    ActivateOriginError,
    ActivateProjectData,
    ActivateProjectError,
    ActivateServiceData,
    ActivateServiceError,
    ActivateWorkRequestClassData,
    ActivateWorkRequestClassError,
    AddAnimalProjectsData,
    AddAnimalProjectsError,
    AddAnimalsToWorkRequestData,
    AddAnimalsToWorkRequestError,
    AddAnimalWeightData,
    AddAnimalWeightError,
    AddAssessmentSheetData,
    AddAssessmentSheetError,
    AddAssessmentSheetResponse,
    AddCageAlarmData,
    AddCageAlarmError,
    AddCageAlarmResponse,
    AddCageProjectsData,
    AddCageProjectsError,
    AddCagesToWorkRequestData,
    AddCagesToWorkRequestError,
    AddColorRuleData,
    AddColorRuleError,
    AddDeviceData,
    AddDeviceError,
    AddDeviceEventData,
    AddDeviceEventError,
    AddDeviceEventResponse,
    AddDeviceResponse,
    AddIndependentDocumentData,
    AddIndependentDocumentError,
    AddLicenseGuidanceData,
    AddLicenseGuidanceError,
    AddMutationTypeGradeData,
    AddMutationTypeGradeError,
    AddProcedureAssignmentData,
    AddProcedureAssignmentError,
    AddPupProjectsData,
    AddPupProjectsError,
    AddPupWeightData,
    AddPupWeightError,
    AddTanksToWorkRequestData,
    AddTanksToWorkRequestError,
    AddToRequestSelectionData,
    AddToRequestSelectionError,
    AddUserCertificateData,
    AddUserCertificateError,
    AddUserCertificateResponse,
    AddUserToProjectData,
    AddUserToProjectError,
    AddWellplateData,
    AddWellplateError,
    ApplyAnimalQuickselectActionsData,
    ApplyAnimalQuickselectActionsError,
    ApplyAnimalQuickselectActionsResponse,
    ApplyCageQuickselectActionsData,
    ApplyCageQuickselectActionsError,
    ApplyCageQuickselectActionsResponse,
    ApplyDrugPackageQuickselectActionsData,
    ApplyDrugPackageQuickselectActionsError,
    ApplyDrugPackageQuickselectActionsResponse,
    ApplyEmbryoQuickselectActionsData,
    ApplyEmbryoQuickselectActionsError,
    ApplyEmbryoQuickselectActionsResponse,
    ApplyLicenseAssignmentsData,
    ApplyLicenseAssignmentsError,
    ApplySpermQuickselectActionsData,
    ApplySpermQuickselectActionsError,
    ApplySpermQuickselectActionsResponse,
    AssignLitterEartagData,
    AssignLitterEartagError,
    AssignLitterEartagResponse,
    BlockStrainData,
    BlockStrainError,
    ClearAnimalSelectionData,
    ClearAnimalSelectionError,
    ClearCageSelectionData,
    ClearCageSelectionError,
    ClearGlobalSelectionData,
    ClearGlobalSelectionError,
    ClearTankSelectionData,
    ClearTankSelectionError,
    CloseBirthData,
    CloseBirthError,
    CloseCageAlarmData,
    CloseCageAlarmError,
    CloseCageData,
    CloseCageError,
    CompleteCrossingData,
    CompleteCrossingError,
    ConnectCageData,
    ConnectCageError,
    CreateAnnouncementData,
    CreateAnnouncementError,
    CreateBirthData,
    CreateBirthError,
    CreateBudgetData,
    CreateBudgetError,
    CreateBudgetResponse,
    CreateCompetenceData,
    CreateCompetenceError,
    CreateCompetenceResponse,
    CreateCryotankData,
    CreateCryotankError,
    CreateDrugData,
    CreateDrugError,
    CreateDrugPackagesData,
    CreateDrugPackagesError,
    CreateDrugRegisterData,
    CreateDrugRegisterError,
    CreateDrugRequestData,
    CreateDrugRequestError,
    CreateDrugResponse2,
    CreateEartagsAndCagenumbersData,
    CreateEartagsAndCagenumbersError,
    CreateEartagsAndCagenumbersResponse,
    CreateInvoiceBatchData,
    CreateInvoiceBatchError,
    CreateInvoiceBatchResponse,
    CreateLocationData,
    CreateLocationError,
    CreateLocationResponse,
    CreateMutationData,
    CreateMutationError,
    CreateMutationResponse,
    CreateNewUserData,
    CreateNewUserError,
    CreateNewUserResponse,
    CreateOrderRequestData,
    CreateOrderRequestError,
    CreateOriginData,
    CreateOriginError,
    CreateOriginResponse,
    CreateProjectBudgetData,
    CreateProjectBudgetError,
    CreateProjectBudgetResponse2,
    CreateProjectData,
    CreateProjectError,
    CreateProjectResponse,
    CreateServiceData,
    CreateServiceError,
    CreateServiceRequestData,
    CreateServiceRequestError,
    CreateServiceResponse,
    CreateSeverityAssessmentTemplateData,
    CreateSeverityAssessmentTemplateError,
    CreateSeverityAssessmentTemplateResponse,
    CreateSeverityLevelData,
    CreateSeverityLevelError,
    CreateSeverityLevelResponse,
    CreateSpeciesData,
    CreateSpeciesError,
    CreateSpeciesResponse,
    CreateStrainData,
    CreateStrainError,
    CreateStrainResponse,
    CreateSystemStatusRecordData,
    CreateSystemStatusRecordError,
    CreateWorkRequestClassData,
    CreateWorkRequestClassError,
    CreateWorkRequestClassResponse,
    CreateWorkRequestData,
    CreateWorkRequestError,
    DeactivateMutationData,
    DeactivateMutationError,
    DeactivateOriginData,
    DeactivateOriginError,
    DeactivateProjectData,
    DeactivateProjectError,
    DeactivateServiceData,
    DeactivateServiceError,
    DeactivateWorkRequestClassData,
    DeactivateWorkRequestClassError,
    DeleteAnimalWeightData,
    DeleteAnimalWeightError,
    DeleteAnnouncementData,
    DeleteAnnouncementError,
    DeleteAssessmentSheetData,
    DeleteAssessmentSheetError,
    DeleteBirthData,
    DeleteBirthError,
    DeleteColorRuleData,
    DeleteColorRuleError,
    DeleteCompetenceData,
    DeleteCompetenceError,
    DeleteCrossingData,
    DeleteCrossingError,
    DeleteCryotankData,
    DeleteCryotankError,
    DeleteDocumentData,
    DeleteDocumentError,
    DeleteDrugData,
    DeleteDrugError,
    DeleteDrugPackageData,
    DeleteDrugPackageError,
    DeleteDrugRegisterData,
    DeleteDrugRegisterError,
    DeleteLicenseData,
    DeleteLicenseError,
    DeleteLocationData,
    DeleteLocationError,
    DeleteMutationTypeGradeData,
    DeleteMutationTypeGradeError,
    DeleteOrderRequestData,
    DeleteOrderRequestError,
    DeleteOriginData,
    DeleteOriginError,
    DeleteProjectData,
    DeleteProjectError,
    DeletePupWeightData,
    DeletePupWeightError,
    DeleteReportData,
    DeleteReportError,
    DeleteReportResponse,
    DeleteServiceData,
    DeleteServiceError,
    DeleteSeverityLevelData,
    DeleteSeverityLevelError,
    DeleteSpeciesData,
    DeleteSpeciesError,
    DeleteSpeciesResponse,
    DeleteUserData,
    DeleteUserError,
    DeleteWellplateData,
    DeleteWellplateError,
    DeleteWorkRequestClassData,
    DeleteWorkRequestClassError,
    DisableClientData,
    DisableClientError,
    DisableUserData,
    DisableUserError,
    DiscardCrossingData,
    DiscardCrossingError,
    DisconnectCageData,
    DisconnectCageError,
    EnableClientData,
    EnableClientError,
    EnableUserData,
    EnableUserError,
    ExecuteAnimalExportQuickselectActionsData,
    ExecuteAnimalExportQuickselectActionsError,
    ExecuteAnimalExportQuickselectActionsResponse,
    ExecuteStudQuickselectActionsData,
    ExecuteStudQuickselectActionsError,
    ExecuteStudQuickselectActionsResponse,
    ExecuteTankQuickselectActionsData,
    ExecuteTankQuickselectActionsError,
    ExecuteTankQuickselectActionsResponse,
    ExportOrderRequestAnimalsData,
    ExportOrderRequestAnimalsError,
    GenerateRackPositionsData,
    GenerateRackPositionsError,
    GenerateRackPositionsResponse,
    GetActionLogData,
    GetActionLogError,
    GetActionLogResponse,
    GetActiveOwnersData,
    GetActiveOwnersError,
    GetActiveOwnersResponse,
    GetAgeLevelsData,
    GetAgeLevelsError,
    GetAgeLevelsResponse,
    GetAliasesData,
    GetAliasesError,
    GetAliasesResponse,
    GetAnimalCohortIdData,
    GetAnimalCohortIdError,
    GetAnimalCohortIdResponse2,
    GetAnimalDetailDataData,
    GetAnimalDetailDataError,
    GetAnimalDetailDataResponse,
    GetAnimalEartagData,
    GetAnimalEartagError,
    GetAnimalEartagResponse2,
    GetAnimalExportQuickselectActionsSeedData,
    GetAnimalExportQuickselectActionsSeedError,
    GetAnimalExportQuickselectActionsSeedResponse,
    GetAnimalGenerationData,
    GetAnimalGenerationError,
    GetAnimalGenerationResponse2,
    GetAnimalGeneticBackgroundData,
    GetAnimalGeneticBackgroundError,
    GetAnimalGeneticBackgroundResponse2,
    GetAnimalIncompatibleSanitaryStatusLocationsData,
    GetAnimalIncompatibleSanitaryStatusLocationsError,
    GetAnimalIncompatibleSanitaryStatusLocationsResponse,
    GetAnimalLabIdData,
    GetAnimalLabIdError,
    GetAnimalLabIdResponse2,
    GetAnimalMedicalConditionDialogSeedData,
    GetAnimalMedicalConditionDialogSeedError,
    GetAnimalMedicalConditionDialogSeedResponse,
    GetAnimalMutationDialogSeedData,
    GetAnimalMutationDialogSeedError,
    GetAnimalMutationDialogSeedResponse,
    GetAnimalOwnerDialogSeedData,
    GetAnimalOwnerDialogSeedError,
    GetAnimalOwnerDialogSeedResponse,
    GetAnimalPedigreeDialogDataData,
    GetAnimalPedigreeDialogDataError,
    GetAnimalPedigreeDialogDataResponse,
    GetAnimalPlugDateDialogSeedData,
    GetAnimalPlugDateDialogSeedError,
    GetAnimalPlugDateDialogSeedResponse,
    GetAnimalProjectsData,
    GetAnimalProjectsError,
    GetAnimalProjectsResponse,
    GetAnimalQuickselectSeedData,
    GetAnimalQuickselectSeedError,
    GetAnimalQuickselectSeedResponse,
    GetAnimalResponsibleDialogSeedData,
    GetAnimalResponsibleDialogSeedError,
    GetAnimalResponsibleDialogSeedResponse,
    GetAnimalRfIdData,
    GetAnimalRfIdError,
    GetAnimalRfIdResponse2,
    GetAnimalSexData,
    GetAnimalSexError,
    GetAnimalSexMoveSacrificeDialogSeedData,
    GetAnimalSexMoveSacrificeDialogSeedError,
    GetAnimalSexMoveSacrificeDialogSeedResponse,
    GetAnimalSexResponse,
    GetAnimalSpeciesDialogSeedData,
    GetAnimalSpeciesDialogSeedError,
    GetAnimalSpeciesDialogSeedResponse,
    GetAnimalStrainDialogSeedData,
    GetAnimalStrainDialogSeedError,
    GetAnimalStrainDialogSeedResponse,
    GetAnimalStudStatusDialogSeedData,
    GetAnimalStudStatusDialogSeedError,
    GetAnimalStudStatusDialogSeedResponse,
    GetAnimalWeightDialogSeedData,
    GetAnimalWeightDialogSeedError,
    GetAnimalWeightDialogSeedResponse,
    GetAnnouncementData,
    GetAnnouncementError,
    GetAnnouncementResponse,
    GetAvailableRepetitionsData,
    GetAvailableRepetitionsError,
    GetAvailableRepetitionsResponse,
    GetAvailableReportsData,
    GetAvailableReportsError,
    GetAvailableReportsResponse,
    GetBackgroundTaskStatusData,
    GetBackgroundTaskStatusError,
    GetBackgroundTaskStatusResponse,
    GetBirthCommentData,
    GetBirthCommentError,
    GetBirthCommentResponse,
    GetBirthDialogDataData,
    GetBirthDialogDataError,
    GetBirthDialogDataResponse,
    GetBreedingCageDetailDataData,
    GetBreedingCageDetailDataError,
    GetBreedingCageDetailDataResponse,
    GetBreedingPerformanceDetailsData,
    GetBreedingPerformanceDetailsError,
    GetBreedingPerformanceDetailsResponse,
    GetBuildingMapRackDetailsData,
    GetBuildingMapRackDetailsError,
    GetBuildingMapRackDetailsResponse,
    GetCageAlarmsData,
    GetCageAlarmsError,
    GetCageAlarmsResponse,
    GetCageAlarmTypesData,
    GetCageAlarmTypesError,
    GetCageAlarmTypesResponse,
    GetCageCategoryData,
    GetCageCategoryError,
    GetCageCategoryResponse2,
    GetCageHardwareStatusData,
    GetCageHardwareStatusError,
    GetCageHardwareStatusResponse,
    GetCageLabelData,
    GetCageLabelError,
    GetCageLabelPrinterPreferenceData,
    GetCageLabelPrinterPreferenceError,
    GetCageLabelPrinterPreferenceResponse,
    GetCageLabelResponse2,
    GetCageLayoutData,
    GetCageLayoutError,
    GetCageLayoutResponse,
    GetCageLocationData,
    GetCageLocationError,
    GetCageLocationResponse2,
    GetCageNumberData,
    GetCageNumberError,
    GetCageNumberResponse2,
    GetCageOwnerData,
    GetCageOwnerError,
    GetCageOwnerResponse2,
    GetCagePositionData,
    GetCagePositionError,
    GetCagePositionResponse2,
    GetCageProjectsData,
    GetCageProjectsError,
    GetCageProjectsResponse,
    GetCageQuickselectSeedData,
    GetCageQuickselectSeedError,
    GetCageQuickselectSeedResponse,
    GetCageResponsibleData,
    GetCageResponsibleError,
    GetCageResponsibleResponse2,
    GetCarnegieStagesForSettingData,
    GetCarnegieStagesForSettingError,
    GetCarnegieStagesForSettingResponse,
    GetColonyPedigreeData,
    GetColonyPedigreeError,
    GetColonyPedigreeResponse,
    GetColumnSelectParamsData,
    GetColumnSelectParamsError,
    GetColumnSelectParamsResponse,
    GetCommentWidgetSeedData,
    GetCommentWidgetSeedError,
    GetCommentWidgetSeedResponse,
    GetCompetenceDetailsData,
    GetCompetenceDetailsError,
    GetCompetenceDetailsResponse,
    GetContainerDetailsData,
    GetContainerDetailsError,
    GetContainerDetailsResponse,
    GetCrossingDetailDataData,
    GetCrossingDetailDataError,
    GetCrossingDetailDataResponse,
    GetCryotankDetailsData,
    GetCryotankDetailsError,
    GetCryotankDetailsResponse,
    GetCryotankNodeDisplayHintsForSettingData,
    GetCryotankNodeDisplayHintsForSettingError,
    GetCryotankNodeDisplayHintsForSettingResponse,
    GetCryotanksForSettingData,
    GetCryotanksForSettingError,
    GetCryotanksForSettingResponse,
    GetDefaultWeanSuffixData,
    GetDefaultWeanSuffixError,
    GetDefaultWeanSuffixResponse,
    GetDocumentWidgetSeedData,
    GetDocumentWidgetSeedError,
    GetDocumentWidgetSeedResponse,
    GetDrugDetailsData,
    GetDrugDetailsError,
    GetDrugDetailsResponse,
    GetDrugPackageDetailsData,
    GetDrugPackageDetailsError,
    GetDrugPackageDetailsResponse,
    GetDrugPackageQuickselectSeedData,
    GetDrugPackageQuickselectSeedError,
    GetDrugPackageQuickselectSeedResponse,
    GetDrugPackagesForSettingData,
    GetDrugPackagesForSettingError,
    GetDrugPackagesForSettingResponse,
    GetDrugRegisterDetailsData,
    GetDrugRegisterDetailsError,
    GetDrugRegisterDetailsResponse,
    GetDrugRequestDetailsData,
    GetDrugRequestDetailsError,
    GetDrugRequestDetailsResponse,
    GetDrugsForProcedureForSettingData,
    GetDrugsForProcedureForSettingError,
    GetDrugsForProcedureForSettingResponse,
    GetEmbryoDetailsData,
    GetEmbryoDetailsError,
    GetEmbryoDetailsResponse,
    GetEmbryoHistoryData,
    GetEmbryoHistoryError,
    GetEmbryoHistoryResponse,
    GetEmbryoQuickselectSeedData,
    GetEmbryoQuickselectSeedError,
    GetEmbryoQuickselectSeedResponse,
    GetExistingAssessmentSheetData,
    GetExistingAssessmentSheetError,
    GetExistingAssessmentSheetResponse,
    GetExistingDeviceDialogSeedData,
    GetExistingDeviceDialogSeedError,
    GetExistingDeviceDialogSeedResponse,
    GetExistingDeviceEventDialogSeedData,
    GetExistingDeviceEventDialogSeedError,
    GetExistingDeviceEventDialogSeedResponse,
    GetExistingUserCertificateDialogSeedData,
    GetExistingUserCertificateDialogSeedError,
    GetExistingUserCertificateDialogSeedResponse,
    GetExistingUserDetailsSeedData,
    GetExistingUserDetailsSeedError,
    GetExistingUserDetailsSeedResponse,
    GetFilterParametersData,
    GetFilterParametersError,
    GetFilterParametersResponse,
    GetFosterMotherSuffixesData,
    GetFosterMotherSuffixesError,
    GetFosterMotherSuffixesResponse,
    GetFosterMothersByStrainIdData,
    GetFosterMothersByStrainIdError,
    GetFosterMothersByStrainIdResponse,
    GetIncompatibleSanitaryStatusLocationsData,
    GetIncompatibleSanitaryStatusLocationsError,
    GetIncompatibleSanitaryStatusLocationsResponse,
    GetIndependentDocumentDetailsData,
    GetIndependentDocumentDetailsError,
    GetIndependentDocumentDetailsResponse,
    GetInvoiceBatchSeedData,
    GetInvoiceBatchSeedError,
    GetInvoiceBatchSeedResponse,
    GetLastTagsData,
    GetLastTagsError,
    GetLastTagsResponse,
    GetLdapUserDetailsData,
    GetLdapUserDetailsError,
    GetLdapUserDetailsResponse,
    GetLicenseClassificationOptionsData,
    GetLicenseClassificationOptionsError,
    GetLicenseClassificationOptionsResponse,
    GetLicenseDetailsSeedData,
    GetLicenseDetailsSeedError,
    GetLicenseDetailsSeedResponse,
    GetLicenseOptionsData,
    GetLicenseOptionsError,
    GetLicenseOptionsResponse,
    GetLicenseSignOffData,
    GetLicenseSignOffError,
    GetLicenseSignOffResponse,
    GetLitterAssignEartagDialogSeedData,
    GetLitterAssignEartagDialogSeedError,
    GetLitterAssignEartagDialogSeedResponse,
    GetLitterWeanDialogSeedData,
    GetLitterWeanDialogSeedError,
    GetLitterWeanDialogSeedResponse,
    GetLocationDetailsData,
    GetLocationDetailsError,
    GetLocationDetailsResponse,
    GetMutationDialogSeedData,
    GetMutationDialogSeedError,
    GetMutationDialogSeedResponse,
    GetMutationGradesData,
    GetMutationGradesError,
    GetMutationGradesResponse,
    GetMutationTypeUnassignedGradesData,
    GetMutationTypeUnassignedGradesError,
    GetMutationTypeUnassignedGradesResponse,
    GetNewAssessmentSheetData,
    GetNewAssessmentSheetError,
    GetNewAssessmentSheetResponse,
    GetNewDeviceDialogSeedData,
    GetNewDeviceDialogSeedError,
    GetNewDeviceDialogSeedResponse,
    GetNewDeviceEventDialogSeedData,
    GetNewDeviceEventDialogSeedError,
    GetNewDeviceEventDialogSeedResponse,
    GetNewMutationDialogSeedData,
    GetNewMutationDialogSeedError,
    GetNewMutationDialogSeedResponse,
    GetNewStrainDialogSeedData,
    GetNewStrainDialogSeedError,
    GetNewStrainDialogSeedResponse,
    GetNewUserCertificateDialogSeedData,
    GetNewUserCertificateDialogSeedError,
    GetNewUserCertificateDialogSeedResponse,
    GetNewUserDetailsSeedData,
    GetNewUserDetailsSeedError,
    GetNewUserDetailsSeedResponse,
    GetNewWorkRequestDialogSeedData,
    GetNewWorkRequestDialogSeedError,
    GetNewWorkRequestDialogSeedResponse,
    GetNextFreeCagenumberSuffixData,
    GetNextFreeCagenumberSuffixError,
    GetNextFreeCagenumberSuffixResponse,
    GetNextFreeEartagData,
    GetNextFreeEartagError,
    GetNextFreeEartagResponse,
    GetNextFreeEmbryoStrawLabelsData,
    GetNextFreeEmbryoStrawLabelsError,
    GetNextFreeEmbryoStrawLabelsResponse,
    GetNextFreeSpermStrawLabelsData,
    GetNextFreeSpermStrawLabelsError,
    GetNextFreeSpermStrawLabelsResponse,
    GetOocyteDonorsByStrainForSettingData,
    GetOocyteDonorsByStrainForSettingError,
    GetOocyteDonorsByStrainForSettingResponse,
    GetOrderRequestAnimalExportDataData,
    GetOrderRequestAnimalExportDataError,
    GetOrderRequestAnimalExportDataResponse,
    GetOrderRequestAnimalFilterData,
    GetOrderRequestAnimalFilterError,
    GetOrderRequestAnimalFilterResponse,
    GetOrderRequestDetailsData,
    GetOrderRequestDetailsError,
    GetOrderRequestDetailsResponse,
    GetOriginDetailsSeedData,
    GetOriginDetailsSeedError,
    GetOriginDetailsSeedResponse,
    GetOriginsForSettingData,
    GetOriginsForSettingError,
    GetOriginsForSettingResponse,
    GetOwnersForGroupWidgetData,
    GetOwnersForGroupWidgetError,
    GetOwnersForGroupWidgetResponse,
    GetPickerCageData,
    GetPickerCageError,
    GetPickerCageListData,
    GetPickerCageListError,
    GetPickerCageListResponse,
    GetPickerCageResponse,
    GetPickerLocationData,
    GetPickerLocationError,
    GetPickerLocationListData,
    GetPickerLocationListError,
    GetPickerLocationListResponse,
    GetPickerLocationResponse,
    GetPickerTankListData,
    GetPickerTankListError,
    GetPickerTankListResponse,
    GetPossibleFilterValuesData,
    GetPossibleFilterValuesError,
    GetPrefixesData,
    GetPrefixesError,
    GetPrefixesResponse,
    GetProceduresForClassificationData,
    GetProceduresForClassificationError,
    GetProceduresForClassificationResponse,
    GetProjectDetailsData,
    GetProjectDetailsError,
    GetProjectDetailsResponse2,
    GetProjectsForSettingData,
    GetProjectsForSettingError,
    GetProjectsForSettingResponse,
    GetPupCohortIdData,
    GetPupCohortIdError,
    GetPupCohortIdResponse,
    GetPupDetailDataData,
    GetPupDetailDataError,
    GetPupDetailDataResponse,
    GetPupEartagData,
    GetPupEartagError,
    GetPupEartagResponse,
    GetPupGenerationData,
    GetPupGenerationError,
    GetPupGenerationResponse,
    GetPupGeneticBackgroundData,
    GetPupGeneticBackgroundError,
    GetPupGeneticBackgroundResponse,
    GetPupIncompatibleSanitaryStatusLocationsData,
    GetPupIncompatibleSanitaryStatusLocationsError,
    GetPupIncompatibleSanitaryStatusLocationsResponse,
    GetPupLabIdData,
    GetPupLabIdError,
    GetPupLabIdResponse,
    GetPupMedicalConditionDialogSeedData,
    GetPupMedicalConditionDialogSeedError,
    GetPupMedicalConditionDialogSeedResponse,
    GetPupMutationDialogSeedData,
    GetPupMutationDialogSeedError,
    GetPupMutationDialogSeedResponse,
    GetPupOwnerDialogSeedData,
    GetPupOwnerDialogSeedError,
    GetPupOwnerDialogSeedResponse,
    GetPupPedigreeDialogDataData,
    GetPupPedigreeDialogDataError,
    GetPupPedigreeDialogDataResponse,
    GetPupProjectsData,
    GetPupProjectsError,
    GetPupProjectsResponse,
    GetPupResponsibleDialogSeedData,
    GetPupResponsibleDialogSeedError,
    GetPupResponsibleDialogSeedResponse,
    GetPupSexMoveSacrificeDialogSeedData,
    GetPupSexMoveSacrificeDialogSeedError,
    GetPupSexMoveSacrificeDialogSeedResponse,
    GetPupSpeciesDialogSeedData,
    GetPupSpeciesDialogSeedError,
    GetPupSpeciesDialogSeedResponse,
    GetPupStrainDialogSeedData,
    GetPupStrainDialogSeedError,
    GetPupStrainDialogSeedResponse,
    GetPupWeightDialogSeedData,
    GetPupWeightDialogSeedError,
    GetPupWeightDialogSeedResponse,
    GetReportDetailsData,
    GetReportDetailsError,
    GetReportDetailsResponse,
    GetResponsiblesData,
    GetResponsiblesError,
    GetResponsiblesResponse,
    GetServiceDetailsData,
    GetServiceDetailsError,
    GetServiceDetailsResponse,
    GetServiceRequestDetailsData,
    GetServiceRequestDetailsError,
    GetServiceRequestDetailsResponse,
    GetServiceRequestLicensesForSettingData,
    GetServiceRequestLicensesForSettingError,
    GetServiceRequestLicensesForSettingResponse,
    GetSessionTimeData,
    GetSessionTimeError,
    GetSessionTimeResponse,
    GetSetLicenseDialogOptionsData,
    GetSetLicenseDialogOptionsError,
    GetSetLicenseDialogOptionsResponse,
    GetSeverityAssessmentTemplateDetailsData,
    GetSeverityAssessmentTemplateDetailsError,
    GetSeverityAssessmentTemplateDetailsResponse,
    GetSeverityLevelDetailsData,
    GetSeverityLevelDetailsError,
    GetSeverityLevelDetailsResponse,
    GetSeverityLevelOptionsData,
    GetSeverityLevelOptionsError,
    GetSeverityLevelOptionsResponse,
    GetSpeciesDetailsData,
    GetSpeciesDetailsError,
    GetSpeciesDetailsResponse,
    GetSpeciesDialogSeedData,
    GetSpeciesDialogSeedError,
    GetSpeciesDialogSeedResponse,
    GetSpermDetailsData,
    GetSpermDetailsError,
    GetSpermDetailsResponse,
    GetSpermHistoryData,
    GetSpermHistoryError,
    GetSpermHistoryResponse,
    GetSpermQualitiesForSettingData,
    GetSpermQualitiesForSettingError,
    GetSpermQualitiesForSettingResponse,
    GetSpermQuickselectSeedData,
    GetSpermQuickselectSeedError,
    GetSpermQuickselectSeedResponse,
    GetStockCageDetailDataData,
    GetStockCageDetailDataError,
    GetStockCageDetailDataResponse,
    GetStrainBlockDetailsData,
    GetStrainBlockDetailsError,
    GetStrainBlockDetailsResponse,
    GetStrainDatabaseFieldValuesData,
    GetStrainDatabaseFieldValuesError,
    GetStrainDatabaseFieldValuesResponse,
    GetStrainDatabaseValuesData,
    GetStrainDatabaseValuesError,
    GetStrainDatabaseValuesResponse,
    GetStrainDialogSeedData,
    GetStrainDialogSeedError,
    GetStrainDialogSeedResponse,
    GetStrainIdsByNameData,
    GetStrainIdsByNameError,
    GetStrainIdsByNameResponse,
    GetStrainsBySexForOwnersData,
    GetStrainsBySexForOwnersError,
    GetStrainsBySexForOwnersResponse,
    GetStrainsByUsageForOwnersData,
    GetStrainsByUsageForOwnersError,
    GetStrainsByUsageForOwnersResponse,
    GetStrainsForFilterData,
    GetStrainsForFilterError,
    GetStrainsForFilterResponse,
    GetStrainsForSettingData,
    GetStrainsForSettingError,
    GetStrainsForSettingResponse,
    GetStrawDetailsData,
    GetStrawDetailsError,
    GetStrawDetailsResponse,
    GetStrawLabelData,
    GetStrawLabelError,
    GetStrawLabelResponse,
    GetStudQuickselectActionsSeedData,
    GetStudQuickselectActionsSeedError,
    GetStudQuickselectActionsSeedResponse,
    GetTankDetailsData,
    GetTankDetailsError,
    GetTankDetailsResponse,
    GetTankImportDialogDataData,
    GetTankImportDialogDataError,
    GetTankImportDialogDataResponse,
    GetTankLabelData,
    GetTankLabelError,
    GetTankLabelResponse,
    GetTankLocationLabelDialogDataData,
    GetTankLocationLabelDialogDataError,
    GetTankLocationLabelDialogDataResponse,
    GetTankMedicalConditionDialogSeedData,
    GetTankMedicalConditionDialogSeedError,
    GetTankMedicalConditionDialogSeedResponse,
    GetTankQuickselectActionsSeedData,
    GetTankQuickselectActionsSeedError,
    GetTankQuickselectActionsSeedResponse,
    GetTotpSecretData,
    GetTotpSecretError,
    GetTotpSecretResponse,
    GetUnknownCagesData,
    GetUnknownCagesError,
    GetUnknownCagesResponse,
    GetUserStatusData,
    GetUserStatusError,
    GetUserStatusResponse,
    GetUsersForSettingData,
    GetUsersForSettingError,
    GetUsersForSettingResponse,
    GetVersionData,
    GetVersionError,
    GetVersionResponse,
    GetWebAuthnRegistrationOptionsData,
    GetWebAuthnRegistrationOptionsError,
    GetWellplatePickerOptionsData,
    GetWellplatePickerOptionsError,
    GetWellplatePickerOptionsResponse,
    GetWellplatesDialogSeedData,
    GetWellplatesDialogSeedError,
    GetWellplatesDialogSeedResponse,
    GetWellplatesExportSeedData,
    GetWellplatesExportSeedError,
    GetWellplatesExportSeedResponse,
    GetWorkRequestAdditionalFieldsData,
    GetWorkRequestAdditionalFieldsError,
    GetWorkRequestAdditionalFieldsResponse,
    GetWorkRequestClassDetailsData,
    GetWorkRequestClassDetailsError,
    GetWorkRequestClassDetailsResponse,
    GetWorkRequestClassDialogSeedData,
    GetWorkRequestClassDialogSeedError,
    GetWorkRequestClassDialogSeedResponse,
    GetWorkRequestClassPlannedProceduresData,
    GetWorkRequestClassPlannedProceduresError,
    GetWorkRequestClassPlannedProceduresResponse,
    GetWorkRequestDetailsData,
    GetWorkRequestDetailsError,
    GetWorkRequestDetailsResponse,
    GetWorkRequestLocationDialogSeedData,
    GetWorkRequestLocationDialogSeedError,
    GetWorkRequestLocationDialogSeedResponse,
    GetWorkRequestPriorityDialogSeedData,
    GetWorkRequestPriorityDialogSeedError,
    GetWorkRequestPriorityDialogSeedResponse,
    GetWorkRequestProjectData,
    GetWorkRequestProjectError,
    GetWorkRequestProjectResponse,
    GetWorkRequestResponsibleDialogSeedData,
    GetWorkRequestResponsibleDialogSeedError,
    GetWorkRequestResponsibleDialogSeedResponse,
    GetWorkRequestStatusDialogSeedData,
    GetWorkRequestStatusDialogSeedError,
    GetWorkRequestStatusDialogSeedResponse,
    HighlightWorkrequestCagesData,
    HighlightWorkrequestCagesError,
    ImportAnimalCagesData,
    ImportAnimalCagesError,
    ImportAnimalCagesResponse,
    ImportEmbryosData,
    ImportEmbryosError,
    ImportEmbryosResponse,
    ImportOrderRequestCatalogItemsData,
    ImportOrderRequestCatalogItemsError,
    ImportOrderRequestCatalogItemsResponse,
    ImportSpermData,
    ImportSpermError,
    ImportSpermResponse,
    ImportTanksData,
    ImportTanksError,
    ImportTanksResponse,
    InvalidateWellplatePositionData,
    InvalidateWellplatePositionError,
    IsPositionOccupiedData,
    IsPositionOccupiedError,
    IsPositionOccupiedResponse,
    KeepCrossingData,
    KeepCrossingError,
    ListLdapUsersData,
    ListLdapUsersError,
    ListLdapUsersResponse,
    MarkCommentHiddenData,
    MarkCommentHiddenError,
    MarkCommentHiddenResponse,
    MarkCommentVisibleData,
    MarkCommentVisibleError,
    MarkCommentVisibleResponse,
    MoveAnimalToExistingCageData,
    MoveAnimalToExistingCageError,
    MoveAnimalToNewCageData,
    MoveAnimalToNewCageError,
    MoveBuildingMapCageData,
    MoveBuildingMapCageError,
    MoveBuildingMapTankData,
    MoveBuildingMapTankError,
    NoteAnimalInActionLogData,
    NoteAnimalInActionLogError,
    NoteCageInActionLogData,
    NoteCageInActionLogError,
    NotePupInActionLogData,
    NotePupInActionLogError,
    ObtainDvcPositionData,
    ObtainDvcPositionError,
    PairLabelData,
    PairLabelError,
    PerformWorkRequestMoveCageData,
    PerformWorkRequestMoveCageError,
    PostCommentData,
    PostCommentError,
    PostCommentResponse2,
    PostTecniplastDvcHookData,
    PostTecniplastDvcHookError,
    PrintCrossingLabelData,
    PrintCrossingLabelError,
    ReAuthenticateData,
    ReAuthenticateError,
    ReAuthenticateResponse,
    ReactivateSessionData,
    ReactivateSessionError,
    ReactivateSessionResponse,
    RegisterWebAuthnDeviceData,
    RegisterWebAuthnDeviceError,
    RemoveAnimalFromWorkRequestData,
    RemoveAnimalFromWorkRequestError,
    RemoveAnimalProjectsData,
    RemoveAnimalProjectsError,
    RemoveCageFromWorkRequestData,
    RemoveCageFromWorkRequestError,
    RemoveCageProjectsData,
    RemoveCageProjectsError,
    RemoveDocumentSubjectsData,
    RemoveDocumentSubjectsError,
    RemoveFetusFlagForPupsData,
    RemoveFetusFlagForPupsError,
    RemoveFilterPresetData,
    RemoveFilterPresetError,
    RemoveProcedureAssignmentData,
    RemoveProcedureAssignmentError,
    RemovePupFromWorkRequestData,
    RemovePupFromWorkRequestError,
    RemovePupProjectsData,
    RemovePupProjectsError,
    RemoveTankFromWorkRequestData,
    RemoveTankFromWorkRequestError,
    RemoveTotpSecretData,
    RemoveTotpSecretError,
    RemoveUserFromProjectData,
    RemoveUserFromProjectError,
    RemoveWebAuthnDeviceData,
    RemoveWebAuthnDeviceError,
    ReopenCageData,
    ReopenCageError,
    ReopenWellplateData,
    ReopenWellplateError,
    RepeatCrossingData,
    RepeatCrossingError,
    RepeatCrossingResponse,
    ReprocessInvoiceBatchData,
    ReprocessInvoiceBatchError,
    ReprocessInvoiceBatchResponse,
    ResetFilterData,
    ResetFilterError,
    ResurrectAnimalData,
    ResurrectAnimalError,
    ResurrectPupData,
    ResurrectPupError,
    SacrificeAnimalData,
    SacrificeAnimalError,
    SacrificePupData,
    SacrificePupError,
    SaveLicenseSignOffData,
    SaveLicenseSignOffError,
    SaveSystemStatusSettingsData,
    SaveSystemStatusSettingsError,
    ScheduleReportData,
    ScheduleReportError,
    ScheduleReportResponse,
    SendCageLabelToPrinterData,
    SendCageLabelToPrinterError,
    SetAnimalAsStudData,
    SetAnimalAsStudError,
    SetAnimalCohortIdData,
    SetAnimalCohortIdError,
    SetAnimalEartagData,
    SetAnimalEartagError,
    SetAnimalGenerationData,
    SetAnimalGenerationError,
    SetAnimalGeneticBackgroundData,
    SetAnimalGeneticBackgroundError,
    SetAnimalLabIdData,
    SetAnimalLabIdError,
    SetAnimalMedicalConditionsData,
    SetAnimalMedicalConditionsError,
    SetAnimalMutationsData,
    SetAnimalMutationsError,
    SetAnimalOwnerData,
    SetAnimalOwnerError,
    SetAnimalOwnerResponse,
    SetAnimalPlugDateData,
    SetAnimalPlugDateError,
    SetAnimalResponsibleData,
    SetAnimalResponsibleError,
    SetAnimalRfIdData,
    SetAnimalRfIdError,
    SetAnimalSexData,
    SetAnimalSexError,
    SetAnimalSpeciesData,
    SetAnimalSpeciesError,
    SetAnimalStrainData,
    SetAnimalStrainError,
    SetAnimalStudStatusData,
    SetAnimalStudStatusError,
    SetCageCategoryData,
    SetCageCategoryError,
    SetCageLabelData,
    SetCageLabelError,
    SetCageLocationData,
    SetCageLocationError,
    SetCageLocationResponse2,
    SetCageNumberData,
    SetCageNumberError,
    SetCageOwnerData,
    SetCageOwnerError,
    SetCagePositionData,
    SetCagePositionError,
    SetCageResponsibleData,
    SetCageResponsibleError,
    SetColumnSelectionData,
    SetColumnSelectionError,
    SetDrugPackageStatusData,
    SetDrugPackageStatusError,
    SetDrugRequestStatusData,
    SetDrugRequestStatusError,
    SetFilterData,
    SetFilterError,
    SetFilterPreferencesData,
    SetFilterPreferencesError,
    SetFilterPresetData,
    SetFilterPresetError,
    SetInvoiceBatchStatusData,
    SetInvoiceBatchStatusError,
    SetInvoiceDiscountData,
    SetInvoiceDiscountError,
    SetInvoiceStatusData,
    SetInvoiceStatusError,
    SetOrderRequestStatusData,
    SetOrderRequestStatusError,
    SetPupCohortIdData,
    SetPupCohortIdError,
    SetPupEartagData,
    SetPupEartagError,
    SetPupGenerationData,
    SetPupGenerationError,
    SetPupGeneticBackgroundData,
    SetPupGeneticBackgroundError,
    SetPupLabIdData,
    SetPupLabIdError,
    SetPupMedicalConditionsData,
    SetPupMedicalConditionsError,
    SetPupMutationsData,
    SetPupMutationsError,
    SetPupOwnerData,
    SetPupOwnerError,
    SetPupResponsibleData,
    SetPupResponsibleError,
    SetPupSexData,
    SetPupSexError,
    SetPupSpeciesData,
    SetPupSpeciesError,
    SetPupStrainData,
    SetPupStrainError,
    SetSamlRemoteUserIdData,
    SetSamlRemoteUserIdError,
    SetServiceRequestStatusData,
    SetServiceRequestStatusError,
    SetStrawLabelData,
    SetStrawLabelError,
    SetTankMedicalConditionsData,
    SetTankMedicalConditionsError,
    SetTotpSecretData,
    SetTotpSecretError,
    SetUserLevelData,
    SetUserLevelError,
    SetUserPasswordData,
    SetUserPasswordError,
    SetUserPermissionsByLocationData,
    SetUserPermissionsByLocationError,
    SetUserPermissionsByOwnerData,
    SetUserPermissionsByOwnerError,
    SetUserStatusData,
    SetUserStatusError,
    SetWellplateClosedData,
    SetWellplateClosedError,
    SetWellplateExportedData,
    SetWellplateExportedError,
    SetWellplateReadyData,
    SetWellplateReadyError,
    SetWorkRequestAdditionalFieldsData,
    SetWorkRequestAdditionalFieldsError,
    SetWorkRequestApprovedData,
    SetWorkRequestApprovedError,
    SetWorkRequestClassData,
    SetWorkRequestClassError,
    SetWorkRequestDueDateData,
    SetWorkRequestDueDateError,
    SetWorkRequestLocationData,
    SetWorkRequestLocationError,
    SetWorkRequestPriorityData,
    SetWorkRequestPriorityError,
    SetWorkRequestProjectData,
    SetWorkRequestProjectError,
    SetWorkRequestRejectedData,
    SetWorkRequestRejectedError,
    SetWorkRequestResponsibleData,
    SetWorkRequestResponsibleError,
    SetWorkRequestStatusData,
    SetWorkRequestStatusError,
    SignOffDrugPackageData,
    SignOffDrugPackageError,
    StoreDocumentData,
    StoreDocumentError,
    StoreDocumentResponse,
    SwapBuildingMapCagesData,
    SwapBuildingMapCagesError,
    SwapBuildingMapTanksData,
    SwapBuildingMapTanksError,
    TurnCageLedOffData,
    TurnCageLedOffError,
    TurnCageLedOnData,
    TurnCageLedOnError,
    TurnLabelLedOffData,
    TurnLabelLedOffError,
    TurnLabelLedOnData,
    TurnLabelLedOnError,
    UnblockStrainData,
    UnblockStrainError,
    UnpairLabelData,
    UnpairLabelError,
    UnsetAnimalReferenceWeightData,
    UnsetAnimalReferenceWeightError,
    UnsetPupReferenceWeightData,
    UnsetPupReferenceWeightError,
    UpdateAgeLevelData,
    UpdateAgeLevelError,
    UpdateAnimalBirthDateData,
    UpdateAnimalBirthDateError,
    UpdateAnimalHousingCostsData,
    UpdateAnimalHousingCostsError,
    UpdateAnimalSacrificeDateData,
    UpdateAnimalSacrificeDateError,
    UpdateAnnouncementData,
    UpdateAnnouncementError,
    UpdateAssessmentSheetData,
    UpdateAssessmentSheetError,
    UpdateBillingTypeCostElementData,
    UpdateBillingTypeCostElementError,
    UpdateBirthCommentData,
    UpdateBirthCommentError,
    UpdateBudgetsData,
    UpdateBudgetsError,
    UpdateCageCategoriesData,
    UpdateCageCategoriesError,
    UpdateCageHousingCostsData,
    UpdateCageHousingCostsError,
    UpdateClinicalSignCategoriesData,
    UpdateClinicalSignCategoriesError,
    UpdateClinicalSignsData,
    UpdateClinicalSignsError,
    UpdateColorRuleData,
    UpdateColorRuleError,
    UpdateCommentAttributeListData,
    UpdateCommentAttributeListError,
    UpdateCompetenceData,
    UpdateCompetenceError,
    UpdateCompetenceResponse,
    UpdateCompetentUserAssignmentData,
    UpdateCompetentUserAssignmentError,
    UpdateCostElementsData,
    UpdateCostElementsError,
    UpdateCrossingData,
    UpdateCrossingError,
    UpdateCryotankData,
    UpdateCryotankError,
    UpdateCryotankPathColorData,
    UpdateCryotankPathColorError,
    UpdateDateInData,
    UpdateDateInError,
    UpdateDateOutData,
    UpdateDateOutError,
    UpdateDeviceCategoriesData,
    UpdateDeviceCategoriesError,
    UpdateDeviceData,
    UpdateDeviceError,
    UpdateDeviceEventCategoriesData,
    UpdateDeviceEventCategoriesError,
    UpdateDeviceEventData,
    UpdateDeviceEventError,
    UpdateDrugCategoriesData,
    UpdateDrugCategoriesError,
    UpdateDrugData,
    UpdateDrugError,
    UpdateDrugPackageData,
    UpdateDrugPackageError,
    UpdateDrugRegisterData,
    UpdateDrugRegisterError,
    UpdateDrugRequestData,
    UpdateDrugRequestError,
    UpdateDvcCageData,
    UpdateDvcCageError,
    UpdateExistingUserData,
    UpdateExistingUserError,
    UpdateFacilitiesData,
    UpdateFacilitiesError,
    UpdateGeneticBackgroundsData,
    UpdateGeneticBackgroundsError,
    UpdateGradesData,
    UpdateGradesError,
    UpdateIndependentDocumentData,
    UpdateIndependentDocumentError,
    UpdateInternalOrderCostsData,
    UpdateInternalOrderCostsError,
    UpdateLabelData,
    UpdateLabelError,
    UpdateLicenseDetailsData,
    UpdateLicenseDetailsError,
    UpdateLicenseDetailsResponse,
    UpdateLicenseTypesData,
    UpdateLicenseTypesError,
    UpdateLitterBirthDateData,
    UpdateLitterBirthDateError,
    UpdateLocationDetailsData,
    UpdateLocationDetailsError,
    UpdateMedicalConditionsData,
    UpdateMedicalConditionsError,
    UpdateMutationData,
    UpdateMutationError,
    UpdateMutationTypesData,
    UpdateMutationTypesError,
    UpdateOrderRequestCatalogItemsData,
    UpdateOrderRequestCatalogItemsError,
    UpdateOrderRequestCatalogsData,
    UpdateOrderRequestCatalogsError,
    UpdateOrderRequestData,
    UpdateOrderRequestError,
    UpdateOriginData,
    UpdateOriginError,
    UpdatePriceCategoriesData,
    UpdatePriceCategoriesError,
    UpdatePriceExternalOrdersData,
    UpdatePriceExternalOrdersError,
    UpdatePricePeriodsData,
    UpdatePricePeriodsError,
    UpdatePriceProceduresData,
    UpdatePriceProceduresError,
    UpdatePriceSpecialServicesData,
    UpdatePriceSpecialServicesError,
    UpdateProceduresData,
    UpdateProceduresError,
    UpdateProjectCategoriesData,
    UpdateProjectCategoriesError,
    UpdateProjectData,
    UpdateProjectError,
    UpdatePupBirthDateData,
    UpdatePupBirthDateError,
    UpdatePupQuantityData,
    UpdatePupQuantityError,
    UpdatePupSacrificeDateData,
    UpdatePupSacrificeDateError,
    UpdateReportData,
    UpdateReportError,
    UpdateReportResponse,
    UpdateSacrificeMethodsData,
    UpdateSacrificeMethodsError,
    UpdateSacrificeReasonsData,
    UpdateSacrificeReasonsError,
    UpdateServiceCategoriesData,
    UpdateServiceCategoriesError,
    UpdateServiceData,
    UpdateServiceError,
    UpdateServiceRequestData,
    UpdateServiceRequestError,
    UpdateSeverityAssessmentTemplateData,
    UpdateSeverityAssessmentTemplateError,
    UpdateSeverityAssessmentTemplatesData,
    UpdateSeverityAssessmentTemplatesError,
    UpdateSeverityAssessmentTimePointsData,
    UpdateSeverityAssessmentTimePointsError,
    UpdateSeverityLevelData,
    UpdateSeverityLevelError,
    UpdateSpeciesData,
    UpdateSpeciesError,
    UpdateStrainData,
    UpdateStrainDatabaseFieldsData,
    UpdateStrainDatabaseFieldsError,
    UpdateStrainDatabaseFieldValuesData,
    UpdateStrainDatabaseFieldValuesError,
    UpdateStrainError,
    UpdateTankLabelData,
    UpdateTankLabelError,
    UpdateTankLocationLabelData,
    UpdateTankLocationLabelError,
    UpdateUsedWellplateData,
    UpdateUsedWellplateError,
    UpdateUserCertificateData,
    UpdateUserCertificateError,
    UpdateUserCertificateTypesData,
    UpdateUserCertificateTypesError,
    UpdateUserDetailsFromLdapData,
    UpdateUserDetailsFromLdapError,
    UpdateWellplateData,
    UpdateWellplateError,
    UpdateWorkRequestClassData,
    UpdateWorkRequestClassError,
    UpdateWorkRequestStatusesData,
    UpdateWorkRequestStatusesError,
    UploadOrderRequestCatalogImportFileData,
    UploadOrderRequestCatalogImportFileError,
    UploadOrderRequestCatalogImportFileResponse,
    ValidateGlobalWorkRequestSelectionData,
    ValidateGlobalWorkRequestSelectionError,
    ValidateGlobalWorkRequestSelectionResponse,
    WeanLitterData,
    WeanLitterError,
    WeanLitterResponse,
    WriteExceptionData,
    WriteExceptionError,
} from "./types.gen";

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<
    TData,
    ThrowOnError
> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Get Action Log
 * Get action log listing.
 */
export const getActionLog = <ThrowOnError extends boolean = true>(
    options?: Options<GetActionLogData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<GetActionLogResponse, GetActionLogError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/action_log",
        ...options,
    });
};

/**
 * Clear Animal Selection Endpoint
 * Clear selection of animals and pups.
 */
export const clearAnimalSelection = <ThrowOnError extends boolean = true>(
    options?: Options<ClearAnimalSelectionData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).put<unknown, ClearAnimalSelectionError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/action_log/clear_animal_selection",
        ...options,
    });
};

/**
 * Clear Cage Selection Endpoint
 * Clear selection of cages.
 */
export const clearCageSelection = <ThrowOnError extends boolean = true>(
    options?: Options<ClearCageSelectionData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).put<unknown, ClearCageSelectionError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/action_log/clear_cage_selection",
        ...options,
    });
};

/**
 * Clear Tank Selection Endpoint
 * Clear selection of tanks.
 */
export const clearTankSelection = <ThrowOnError extends boolean = true>(
    options?: Options<ClearTankSelectionData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).put<unknown, ClearTankSelectionError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/action_log/clear_tank_selection",
        ...options,
    });
};

/**
 * Clear Global Selection Endpoint
 * Clear global selection of animals, pups, cages and tanks.
 */
export const clearGlobalSelection = <ThrowOnError extends boolean = true>(
    options?: Options<ClearGlobalSelectionData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).put<unknown, ClearGlobalSelectionError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/action_log/clear_global_selection",
        ...options,
    });
};

/**
 * Create Eartags And Cagenumbers
 * Generate ear tags and cage numbers for the given cages and included animals.
 */
export const createEartagsAndCagenumbers = <ThrowOnError extends boolean = true>(
    options: Options<CreateEartagsAndCagenumbersData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<
        CreateEartagsAndCagenumbersResponse,
        CreateEartagsAndCagenumbersError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animal_import/create_eartags_and_cagenumbers",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Last Tags
 * Get the last used cagenumber and eartag suffixes.
 */
export const getLastTags = <ThrowOnError extends boolean = true>(options: Options<GetLastTagsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetLastTagsResponse, GetLastTagsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animal_import/get_last_tags",
        ...options,
    });
};

/**
 * Import Animal Cages
 * Import given animals and cages.
 */
export const importAnimalCages = <ThrowOnError extends boolean = true>(
    options: Options<ImportAnimalCagesData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<ImportAnimalCagesResponse, ImportAnimalCagesError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animal_import/import_animal_cages",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Animal Detail Data Endpoint
 * Get data for animal detail dialog.
 */
export const getAnimalDetailData = <ThrowOnError extends boolean = true>(
    options: Options<GetAnimalDetailDataData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetAnimalDetailDataResponse, GetAnimalDetailDataError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/details",
        ...options,
    });
};

/**
 * Get Animal Pedigree Dialog Data Endpoint
 * Get data for animal pedigree dialog.
 */
export const getAnimalPedigreeDialogData = <ThrowOnError extends boolean = true>(
    options: Options<GetAnimalPedigreeDialogDataData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetAnimalPedigreeDialogDataResponse,
        GetAnimalPedigreeDialogDataError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/pedigree",
        ...options,
    });
};

/**
 * Get Animal Cohort Id Endpoint
 * Get the cohort id for an animal.
 */
export const getAnimalCohortId = <ThrowOnError extends boolean = true>(
    options: Options<GetAnimalCohortIdData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetAnimalCohortIdResponse2, GetAnimalCohortIdError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/cohort_id",
        ...options,
    });
};

/**
 * Set Animal Cohort Id Endpoint
 * Set the cohort id for an animal.
 */
export const setAnimalCohortId = <ThrowOnError extends boolean = true>(
    options: Options<SetAnimalCohortIdData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetAnimalCohortIdError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/cohort_id",
        ...options,
    });
};

/**
 * Get Animal Eartag Endpoint
 * Get eartag for an animal.
 */
export const getAnimalEartag = <ThrowOnError extends boolean = true>(
    options: Options<GetAnimalEartagData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetAnimalEartagResponse2, GetAnimalEartagError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/eartag",
        ...options,
    });
};

/**
 * Set Animal Eartag Endpoint
 * Set eartag for an animal.
 */
export const setAnimalEartag = <ThrowOnError extends boolean = true>(
    options: Options<SetAnimalEartagData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetAnimalEartagError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/eartag",
        ...options,
    });
};

/**
 * Get Animal Generation Endpoint
 * Get generation for an animal.
 */
export const getAnimalGeneration = <ThrowOnError extends boolean = true>(
    options: Options<GetAnimalGenerationData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetAnimalGenerationResponse2, GetAnimalGenerationError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/generation",
        ...options,
    });
};

/**
 * Set Animal Generation Endpoint
 * Set generation for an animal.
 */
export const setAnimalGeneration = <ThrowOnError extends boolean = true>(
    options: Options<SetAnimalGenerationData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetAnimalGenerationError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/generation",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Animal Genetic Background Endpoint
 * Get genetic background for an animal.
 */
export const getAnimalGeneticBackground = <ThrowOnError extends boolean = true>(
    options: Options<GetAnimalGeneticBackgroundData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetAnimalGeneticBackgroundResponse2,
        GetAnimalGeneticBackgroundError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/genetic_background",
        ...options,
    });
};

/**
 * Set Animal Genetic Background Endpoint
 * Set genetic background for an animal.
 */
export const setAnimalGeneticBackground = <ThrowOnError extends boolean = true>(
    options: Options<SetAnimalGeneticBackgroundData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetAnimalGeneticBackgroundError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/genetic_background",
        ...options,
    });
};

/**
 * Remove Animal Projects Endpoint
 * Remove projects from an animal
 */
export const removeAnimalProjects = <ThrowOnError extends boolean = true>(
    options: Options<RemoveAnimalProjectsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, RemoveAnimalProjectsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/projects",
        ...options,
    });
};

/**
 * Get Animal Projects Endpoint
 * Get all projects assigned to an animal
 */
export const getAnimalProjects = <ThrowOnError extends boolean = true>(
    options: Options<GetAnimalProjectsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetAnimalProjectsResponse, GetAnimalProjectsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/projects",
        ...options,
    });
};

/**
 * Add Animal Projects Endpoint
 * Assign projects to an animal
 */
export const addAnimalProjects = <ThrowOnError extends boolean = true>(
    options: Options<AddAnimalProjectsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, AddAnimalProjectsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/projects",
        ...options,
    });
};

/**
 * Get Animal Incompatible Sanitary Status Locations Endpoint
 * Get incompatible sanitary status locations for animals based on given new cage or rack id.
 */
export const getAnimalIncompatibleSanitaryStatusLocations = <ThrowOnError extends boolean = true>(
    options: Options<GetAnimalIncompatibleSanitaryStatusLocationsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetAnimalIncompatibleSanitaryStatusLocationsResponse,
        GetAnimalIncompatibleSanitaryStatusLocationsError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/incompatible_sanitary_status_locations",
        ...options,
    });
};

/**
 * Get Animal Lab Id Endpoint
 * Get lab id for an animal.
 */
export const getAnimalLabId = <ThrowOnError extends boolean = true>(
    options: Options<GetAnimalLabIdData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetAnimalLabIdResponse2, GetAnimalLabIdError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/lab_id",
        ...options,
    });
};

/**
 * Set Animal Lab Id Endpoint
 * Set lab id for an animal.
 */
export const setAnimalLabId = <ThrowOnError extends boolean = true>(
    options: Options<SetAnimalLabIdData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetAnimalLabIdError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/lab_id",
        ...options,
    });
};

/**
 * Get Animal Rfid Endpoint
 * Get RFID for an animal.
 */
export const getAnimalRfId = <ThrowOnError extends boolean = true>(
    options: Options<GetAnimalRfIdData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetAnimalRfIdResponse2, GetAnimalRfIdError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/rfid",
        ...options,
    });
};

/**
 * Set Animal Rfid Endpoint
 * Set RFID for an animal.
 */
export const setAnimalRfId = <ThrowOnError extends boolean = true>(
    options: Options<SetAnimalRfIdData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetAnimalRfIdError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/rfid",
        ...options,
    });
};

/**
 * Get Animal Medical Condition Dialog Seed Endpoint
 * Get details for the animal SetMedicalConditions-Dialog.
 */
export const getAnimalMedicalConditionDialogSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetAnimalMedicalConditionDialogSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetAnimalMedicalConditionDialogSeedResponse,
        GetAnimalMedicalConditionDialogSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/medical_condition_dialog",
        ...options,
    });
};

/**
 * Set Animal Medical Conditions Endpoint
 * Set medical conditions for an animal.
 */
export const setAnimalMedicalConditions = <ThrowOnError extends boolean = true>(
    options: Options<SetAnimalMedicalConditionsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetAnimalMedicalConditionsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/medical_conditions",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Animal Mutation Dialog Seed Endpoint
 * Get details for the animal SetMutation-Dialog.
 */
export const getAnimalMutationDialogSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetAnimalMutationDialogSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetAnimalMutationDialogSeedResponse,
        GetAnimalMutationDialogSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/mutation_dialog",
        ...options,
    });
};

/**
 * Set Animal Mutations Endpoint
 * Set mutations for an animal.
 */
export const setAnimalMutations = <ThrowOnError extends boolean = true>(
    options: Options<SetAnimalMutationsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetAnimalMutationsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/mutations",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Animal Owner Dialog Seed Endpoint
 * Get details for the animal SetOwner-Dialog.
 */
export const getAnimalOwnerDialogSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetAnimalOwnerDialogSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetAnimalOwnerDialogSeedResponse,
        GetAnimalOwnerDialogSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/owner_dialog",
        ...options,
    });
};

/**
 * Set Animal Owner Endpoint
 * Set owner for an animal.
 */
export const setAnimalOwner = <ThrowOnError extends boolean = true>(
    options: Options<SetAnimalOwnerData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<SetAnimalOwnerResponse, SetAnimalOwnerError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/owner",
        ...options,
    });
};

/**
 * Get Animal Responsible Dialog Seed Endpoint
 * Get details for the animal SetResponsible-Dialog.
 */
export const getAnimalResponsibleDialogSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetAnimalResponsibleDialogSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetAnimalResponsibleDialogSeedResponse,
        GetAnimalResponsibleDialogSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/responsible_dialog",
        ...options,
    });
};

/**
 * Set Animal Responsible Endpoint
 * Set responsible for an animal.
 */
export const setAnimalResponsible = <ThrowOnError extends boolean = true>(
    options: Options<SetAnimalResponsibleData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetAnimalResponsibleError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/responsible",
        ...options,
    });
};

/**
 * Get Animal Stud Status Dialog Seed Endpoint
 * Get details for the animal SetStudStatus-Dialog.
 */
export const getAnimalStudStatusDialogSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetAnimalStudStatusDialogSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetAnimalStudStatusDialogSeedResponse,
        GetAnimalStudStatusDialogSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/stud_status_dialog",
        ...options,
    });
};

/**
 * Set Animal Stud Status Endpoint
 * Set stud_status for an animal.
 */
export const setAnimalStudStatus = <ThrowOnError extends boolean = true>(
    options: Options<SetAnimalStudStatusData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetAnimalStudStatusError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/stud_status",
        ...options,
    });
};

/**
 * Get Animal Sex Move Sacrifice Dialog Seed Endpoint
 * Get details for the animal SetSexMoveSacrifice-Dialog.
 */
export const getAnimalSexMoveSacrificeDialogSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetAnimalSexMoveSacrificeDialogSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetAnimalSexMoveSacrificeDialogSeedResponse,
        GetAnimalSexMoveSacrificeDialogSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/sex_move_sacrifice_dialog",
        ...options,
    });
};

/**
 * Note Animal In Action Log Endpoint
 * Add note for an animal to action log.
 */
export const noteAnimalInActionLog = <ThrowOnError extends boolean = true>(
    options: Options<NoteAnimalInActionLogData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, NoteAnimalInActionLogError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/note_in_action_log",
        ...options,
    });
};

/**
 * Resurrect Animal Endpoint
 * Resurrect an animal.
 */
export const resurrectAnimal = <ThrowOnError extends boolean = true>(
    options: Options<ResurrectAnimalData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, ResurrectAnimalError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/resurrect",
        ...options,
    });
};

/**
 * Sacrifice Animal Endpoint
 * Sacrifice an animal.
 */
export const sacrificeAnimal = <ThrowOnError extends boolean = true>(
    options: Options<SacrificeAnimalData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SacrificeAnimalError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/sacrifice",
        ...options,
    });
};

/**
 * Set Animal As Stud Endpoint
 * Set animal as stud.
 */
export const setAnimalAsStud = <ThrowOnError extends boolean = true>(
    options: Options<SetAnimalAsStudData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetAnimalAsStudError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/set_as_stud",
        ...options,
    });
};

/**
 * Update Animal Birth Date Endpoint
 * Update birthdate for an animal.
 */
export const updateAnimalBirthDate = <ThrowOnError extends boolean = true>(
    options: Options<UpdateAnimalBirthDateData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdateAnimalBirthDateError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/birth_date",
        ...options,
    });
};

/**
 * Update Animal Sacrifice Date Endpoint
 * Update sacrifice date for an animal.
 */
export const updateAnimalSacrificeDate = <ThrowOnError extends boolean = true>(
    options: Options<UpdateAnimalSacrificeDateData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdateAnimalSacrificeDateError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/sacrifice_date",
        ...options,
    });
};

/**
 * Get Animal Sex Endpoint
 * Get sex of an animal.
 */
export const getAnimalSex = <ThrowOnError extends boolean = true>(options: Options<GetAnimalSexData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetAnimalSexResponse, GetAnimalSexError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/sex",
        ...options,
    });
};

/**
 * Set Animal Sex Endpoint
 * Set sex of an animal.
 */
export const setAnimalSex = <ThrowOnError extends boolean = true>(options: Options<SetAnimalSexData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<unknown, SetAnimalSexError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/sex",
        ...options,
    });
};

/**
 * Move Animal To Existing Cage Endpoint
 */
export const moveAnimalToExistingCage = <ThrowOnError extends boolean = true>(
    options: Options<MoveAnimalToExistingCageData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, MoveAnimalToExistingCageError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/move_to_existing_cage",
        ...options,
    });
};

/**
 * Move Animal To New Cage Endpoint
 * Move an animal to a new cage.
 */
export const moveAnimalToNewCage = <ThrowOnError extends boolean = true>(
    options: Options<MoveAnimalToNewCageData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, MoveAnimalToNewCageError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/move_to_new_cage",
        ...options,
    });
};

/**
 * Get Animal Species Dialog Seed Endpoint
 * Get details for the animal SetSpecies-Dialog.
 */
export const getAnimalSpeciesDialogSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetAnimalSpeciesDialogSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetAnimalSpeciesDialogSeedResponse,
        GetAnimalSpeciesDialogSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/species_dialog",
        ...options,
    });
};

/**
 * Set Animal Species Endpoint
 * Set species for an animal.
 */
export const setAnimalSpecies = <ThrowOnError extends boolean = true>(
    options: Options<SetAnimalSpeciesData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetAnimalSpeciesError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/species",
        ...options,
    });
};

/**
 * Get Animal Strain Dialog Seed Endpoint
 * Get details for the animal SetStrain-Dialog.
 */
export const getAnimalStrainDialogSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetAnimalStrainDialogSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetAnimalStrainDialogSeedResponse,
        GetAnimalStrainDialogSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/strain_dialog",
        ...options,
    });
};

/**
 * Set Animal Strain Endpoint
 * Set strain for animal.
 */
export const setAnimalStrain = <ThrowOnError extends boolean = true>(
    options: Options<SetAnimalStrainData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetAnimalStrainError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/strain",
        ...options,
    });
};

/**
 * Get Animal Plug Date Dialog Seed Endpoint
 * Get details for the animal setPlugDate-Dialog.
 */
export const getAnimalPlugDateDialogSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetAnimalPlugDateDialogSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetAnimalPlugDateDialogSeedResponse,
        GetAnimalPlugDateDialogSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/plug_date_dialog_seed",
        ...options,
    });
};

/**
 * Set Animal Plug Date Endpoint
 * Set plug-date for animal.
 */
export const setAnimalPlugDate = <ThrowOnError extends boolean = true>(
    options: Options<SetAnimalPlugDateData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, SetAnimalPlugDateError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/plug_date",
        ...options,
    });
};

/**
 * Get Animal Weight Dialog Seed Endpoint
 * Get details for the animal setWeight-Dialog.
 */
export const getAnimalWeightDialogSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetAnimalWeightDialogSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetAnimalWeightDialogSeedResponse,
        GetAnimalWeightDialogSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/weight_dialog_seed",
        ...options,
    });
};

/**
 * Set Animal Weight Endpoint
 * Set weight for animal.
 */
export const addAnimalWeight = <ThrowOnError extends boolean = true>(
    options: Options<AddAnimalWeightData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, AddAnimalWeightError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/weight",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Unset Animal Reference Weight Endpoint
 * Unset reference weight for animal.
 */
export const unsetAnimalReferenceWeight = <ThrowOnError extends boolean = true>(
    options: Options<UnsetAnimalReferenceWeightData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, UnsetAnimalReferenceWeightError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/reference-weight",
        ...options,
    });
};

/**
 * Delete Animal Weight Endpoint
 * Delete weight for animal.
 */
export const deleteAnimalWeight = <ThrowOnError extends boolean = true>(
    options: Options<DeleteAnimalWeightData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, DeleteAnimalWeightError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/{animal_id}/weight/{weight_id}",
        ...options,
    });
};

/**
 * Get Next Free Eartag
 * Get next unused eartag with the given prefix
 */
export const getNextFreeEartag = <ThrowOnError extends boolean = true>(
    options: Options<GetNextFreeEartagData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetNextFreeEartagResponse, GetNextFreeEartagError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/next_free_eartag",
        ...options,
    });
};

/**
 * Default Wean Suffix
 * Get next unused eartag with the given prefix.
 *
 * Replaces the former "ajax_wean_get_suffix.py" script.
 */
export const getDefaultWeanSuffix = <ThrowOnError extends boolean = true>(
    options: Options<GetDefaultWeanSuffixData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetDefaultWeanSuffixResponse, GetDefaultWeanSuffixError, ThrowOnError>(
        {
            security: [
                {
                    scheme: "bearer",
                    type: "http",
                },
            ],
            url: "/animals/default_wean_suffix",
            ...options,
        },
    );
};

/**
 * Get Litter Assign Eartag Dialog Seed Endpoint
 */
export const getLitterAssignEartagDialogSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetLitterAssignEartagDialogSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetLitterAssignEartagDialogSeedResponse,
        GetLitterAssignEartagDialogSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/get_litter_assign_eartag_dialog_seed",
        ...options,
    });
};

/**
 * Assign Litter Eartag Endpoint
 */
export const assignLitterEartag = <ThrowOnError extends boolean = true>(
    options: Options<AssignLitterEartagData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<AssignLitterEartagResponse, AssignLitterEartagError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/assign_litter_eartag",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Litter Wean Dialog Seed Endpoint
 */
export const getLitterWeanDialogSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetLitterWeanDialogSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetLitterWeanDialogSeedResponse,
        GetLitterWeanDialogSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/litter_wean_dialog_seed",
        ...options,
    });
};

/**
 * Wean Litter Endpoint
 */
export const weanLitter = <ThrowOnError extends boolean = true>(options: Options<WeanLitterData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<WeanLitterResponse, WeanLitterError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/wean_litter",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Quickselect Seed
 * Get seed for animal quickselect.
 */
export const getAnimalQuickselectSeed = <ThrowOnError extends boolean = true>(
    options?: Options<GetAnimalQuickselectSeedData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).post<
        GetAnimalQuickselectSeedResponse,
        GetAnimalQuickselectSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/quickselect/seed",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Apply Quickselect
 */
export const applyAnimalQuickselectActions = <ThrowOnError extends boolean = true>(
    options: Options<ApplyAnimalQuickselectActionsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<
        ApplyAnimalQuickselectActionsResponse,
        ApplyAnimalQuickselectActionsError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/quickselect/apply",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Stud Quickselect Endpoint
 */
export const getStudQuickselectActionsSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetStudQuickselectActionsSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<
        GetStudQuickselectActionsSeedResponse,
        GetStudQuickselectActionsSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/stud_quickselect:get_actions_seed",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Post Stud Quickselect Endpoint
 */
export const executeStudQuickselectActions = <ThrowOnError extends boolean = true>(
    options: Options<ExecuteStudQuickselectActionsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<
        ExecuteStudQuickselectActionsResponse,
        ExecuteStudQuickselectActionsError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/stud_quickselect:execute_actions",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Animal Export Quickselect Endpoint
 */
export const getAnimalExportQuickselectActionsSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetAnimalExportQuickselectActionsSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<
        GetAnimalExportQuickselectActionsSeedResponse,
        GetAnimalExportQuickselectActionsSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/animal_export_quickselect:get_actions_seed",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Post Animal Export Quickselect Endpoint
 */
export const executeAnimalExportQuickselectActions = <ThrowOnError extends boolean = true>(
    options: Options<ExecuteAnimalExportQuickselectActionsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<
        ExecuteAnimalExportQuickselectActionsResponse,
        ExecuteAnimalExportQuickselectActionsError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/animals/animal_export_quickselect:execute_actions",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Status Endpoint
 * Get status of a background task as SSE.
 */
export const getBackgroundTaskStatus = <ThrowOnError extends boolean = true>(
    options: Options<GetBackgroundTaskStatusData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetBackgroundTaskStatusResponse,
        GetBackgroundTaskStatusError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/background_tasks/{task_id}",
        ...options,
    });
};

/**
 * Get New Invoice Batch Seed Endpoint
 * Get the seed data to create a new batch of invoices.
 */
export const getInvoiceBatchSeed = <ThrowOnError extends boolean = true>(
    options?: Options<GetInvoiceBatchSeedData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<GetInvoiceBatchSeedResponse, GetInvoiceBatchSeedError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/batch_invoices/batch/new",
        ...options,
    });
};

/**
 * Post New Invoice Batch Seed Endpoint
 * Create a new batch of invoices.
 */
export const createInvoiceBatch = <ThrowOnError extends boolean = true>(
    options: Options<CreateInvoiceBatchData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<CreateInvoiceBatchResponse, CreateInvoiceBatchError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/batch_invoices/batch/new",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Put Invoice Status Endpoint
 * Change the status of an invoice.
 */
export const setInvoiceStatus = <ThrowOnError extends boolean = true>(
    options: Options<SetInvoiceStatusData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetInvoiceStatusError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/batch_invoices/invoice/{invoice_id}/status",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Put Invoice Batch Status Endpoint
 * Change the status of a whole invoice batch.
 */
export const setInvoiceBatchStatus = <ThrowOnError extends boolean = true>(
    options: Options<SetInvoiceBatchStatusData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetInvoiceBatchStatusError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/batch_invoices/batch/{invoice_batch_id}/status",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Put Invoice Discount Endpoint
 * Apply a discount to an invoice.
 */
export const setInvoiceDiscount = <ThrowOnError extends boolean = true>(
    options: Options<SetInvoiceDiscountData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetInvoiceDiscountError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/batch_invoices/invoice/{invoice_id}/discount",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Reprocess Invoice Batch Endpoint
 * Trigger processing of a batch again.
 */
export const reprocessInvoiceBatch = <ThrowOnError extends boolean = true>(
    options: Options<ReprocessInvoiceBatchData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<
        ReprocessInvoiceBatchResponse,
        ReprocessInvoiceBatchError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/batch_invoices/batch/{invoice_batch_id}/reprocess",
        ...options,
    });
};

/**
 * Create Birth Endpoint
 * Create birth.
 */
export const createBirth = <ThrowOnError extends boolean = true>(options: Options<CreateBirthData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, CreateBirthError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/births",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Close
 * Close birth by setting wean date to the most recent wean date (for partially weaned litter).
 */
export const closeBirth = <ThrowOnError extends boolean = true>(options: Options<CloseBirthData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<unknown, CloseBirthError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/births/{birth_id}/close",
        ...options,
    });
};

/**
 * Delete
 * Delete birth.
 */
export const deleteBirth = <ThrowOnError extends boolean = true>(options: Options<DeleteBirthData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<unknown, DeleteBirthError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/births/{birth_id}/delete",
        ...options,
    });
};

/**
 * Update Litter Birth Date Endpoint
 * Update date for a birth and related animals/pups.
 */
export const updateLitterBirthDate = <ThrowOnError extends boolean = true>(
    options: Options<UpdateLitterBirthDateData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdateLitterBirthDateError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/births/{birth_id}/litter_birth_date",
        ...options,
    });
};

/**
 * Update Pup Quantity
 * Update number of pups for given birth (ID).
 */
export const updatePupQuantity = <ThrowOnError extends boolean = true>(
    options: Options<UpdatePupQuantityData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdatePupQuantityError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/births/{birth_id}/pup_quantity",
        ...options,
    });
};

/**
 * Remove Fetus Flag For Pups
 * Remove fetus flags from pups related to given birth (ID).
 */
export const removeFetusFlagForPups = <ThrowOnError extends boolean = true>(
    options: Options<RemoveFetusFlagForPupsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, RemoveFetusFlagForPupsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/births/{birth_id}/remove_fetus_flag_for_pups",
        ...options,
    });
};

/**
 * Get Comment Endpoint
 * Get comment for given cage (ID).
 */
export const getBirthComment = <ThrowOnError extends boolean = true>(
    options: Options<GetBirthCommentData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetBirthCommentResponse, GetBirthCommentError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/births/{birth_id}/comment",
        ...options,
    });
};

/**
 * Update Comment Endpoint
 * Update comment for given birth (ID).
 */
export const updateBirthComment = <ThrowOnError extends boolean = true>(
    options: Options<UpdateBirthCommentData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdateBirthCommentError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/births/{birth_id}/comment",
        ...options,
    });
};

/**
 * Create Budget Endpoint
 * Create a budget.
 */
export const createBudget = <ThrowOnError extends boolean = true>(options: Options<CreateBudgetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateBudgetResponse, CreateBudgetError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/budgeting/budget",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Update Budgets Endpoint
 * Update the budgets.
 */
export const updateBudgets = <ThrowOnError extends boolean = true>(
    options: Options<UpdateBudgetsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, UpdateBudgetsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/budgeting/budgets",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Update Price Periods
 * Change data of multiple price periods at once and roll back on error.
 */
export const updatePricePeriods = <ThrowOnError extends boolean = true>(
    options: Options<UpdatePricePeriodsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, UpdatePricePeriodsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/budgeting/price_periods",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Update Price Categories
 * Change data of multiple price categories at once and roll back on error.
 */
export const updatePriceCategories = <ThrowOnError extends boolean = true>(
    options: Options<UpdatePriceCategoriesData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, UpdatePriceCategoriesError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/budgeting/price_categories",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Update Price External Order Endpoint
 * Change data of multiple external order prices at once and roll back on error.
 */
export const updatePriceExternalOrders = <ThrowOnError extends boolean = true>(
    options: Options<UpdatePriceExternalOrdersData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, UpdatePriceExternalOrdersError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/budgeting/price_external_order",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Update Price Procedure Endpoint
 * Change data of multiple procedures prices at once and roll back on error.
 */
export const updatePriceProcedures = <ThrowOnError extends boolean = true>(
    options: Options<UpdatePriceProceduresData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, UpdatePriceProceduresError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/budgeting/price_procedure",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Update Price Special Service Endpoint
 * Change data of multiple special services prices at once and roll back on error.
 */
export const updatePriceSpecialServices = <ThrowOnError extends boolean = true>(
    options: Options<UpdatePriceSpecialServicesData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, UpdatePriceSpecialServicesError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/budgeting/price_special_service",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Update Animal Housing Costs
 * Change data of multiple animal housing cost at once and roll back on error.
 */
export const updateAnimalHousingCosts = <ThrowOnError extends boolean = true>(
    options: Options<UpdateAnimalHousingCostsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, UpdateAnimalHousingCostsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/budgeting/price_animal_housing",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Update Cage Housing Costs
 * Change data of multiple cage housing cost at once and roll back on error.
 */
export const updateCageHousingCosts = <ThrowOnError extends boolean = true>(
    options: Options<UpdateCageHousingCostsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, UpdateCageHousingCostsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/budgeting/price_cage_housing",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Delete Announcement Enpoint
 * Delete an announcement by ID.
 */
export const deleteAnnouncement = <ThrowOnError extends boolean = true>(
    options: Options<DeleteAnnouncementData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, DeleteAnnouncementError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/announcements/{announcement_id}",
        ...options,
    });
};

/**
 * Get Announcement
 * Get an announcement by ID.
 *
 * :param announcement_id: The database ID of the announcement.
 */
export const getAnnouncement = <ThrowOnError extends boolean = true>(
    options: Options<GetAnnouncementData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetAnnouncementResponse, GetAnnouncementError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/announcements/{announcement_id}",
        ...options,
    });
};

/**
 * Update Announcement Endpoint
 * Update an announcement by ID.
 */
export const updateAnnouncement = <ThrowOnError extends boolean = true>(
    options: Options<UpdateAnnouncementData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, UpdateAnnouncementError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/announcements/{announcement_id}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Create Announcement Endpoint
 * Create a new announcement.
 */
export const createAnnouncement = <ThrowOnError extends boolean = true>(
    options: Options<CreateAnnouncementData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, CreateAnnouncementError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/announcements",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Disable Client Id
 * Disable a api client by id.
 */
export const disableClient = <ThrowOnError extends boolean = true>(
    options: Options<DisableClientData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, DisableClientError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/client/{client_id}/enabled",
        ...options,
    });
};

/**
 * Enable Client Id
 * Enable a api client by id.
 */
export const enableClient = <ThrowOnError extends boolean = true>(options: Options<EnableClientData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<unknown, EnableClientError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/client/{client_id}/enabled",
        ...options,
    });
};

/**
 * Disable User Id
 * Disable a api user by id.
 */
export const disableUser = <ThrowOnError extends boolean = true>(options: Options<DisableUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<unknown, DisableUserError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/user/{user_id}/enabled",
        ...options,
    });
};

/**
 * Enable User Id
 * Enable a api user by id.
 */
export const enableUser = <ThrowOnError extends boolean = true>(options: Options<EnableUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<unknown, EnableUserError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/user/{user_id}/enabled",
        ...options,
    });
};

/**
 * Delete User Id
 * Delete a api user by id.
 */
export const deleteUser = <ThrowOnError extends boolean = true>(options: Options<DeleteUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<unknown, DeleteUserError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/api/user/{user_id}",
        ...options,
    });
};

/**
 * Get Rack Details Endpoint
 */
export const getBuildingMapRackDetails = <ThrowOnError extends boolean = true>(
    options: Options<GetBuildingMapRackDetailsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetBuildingMapRackDetailsResponse,
        GetBuildingMapRackDetailsError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/building_map/rack",
        ...options,
    });
};

/**
 * Move Cage Endpoint
 */
export const moveBuildingMapCage = <ThrowOnError extends boolean = true>(
    options: Options<MoveBuildingMapCageData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, MoveBuildingMapCageError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/building_map/move_cage",
        ...options,
    });
};

/**
 * Swap Cages Endpoint
 */
export const swapBuildingMapCages = <ThrowOnError extends boolean = true>(
    options: Options<SwapBuildingMapCagesData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, SwapBuildingMapCagesError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/building_map/swap_cages",
        ...options,
    });
};

/**
 * Move Tank Endpoint
 */
export const moveBuildingMapTank = <ThrowOnError extends boolean = true>(
    options: Options<MoveBuildingMapTankData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, MoveBuildingMapTankError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/building_map/move_tank",
        ...options,
    });
};

/**
 * Swap Tanks Endpoint
 */
export const swapBuildingMapTanks = <ThrowOnError extends boolean = true>(
    options: Options<SwapBuildingMapTanksData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, SwapBuildingMapTanksError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/building_map/swap_tanks",
        ...options,
    });
};

/**
 * Get Cage Alarms Endpoint
 * Get cage alarms.
 */
export const getCageAlarms = <ThrowOnError extends boolean = true>(
    options: Options<GetCageAlarmsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetCageAlarmsResponse, GetCageAlarmsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/alarms/{cage_id}",
        ...options,
    });
};

/**
 * Add Cage Alarm Endpoint
 * Add a cage alarm.
 */
export const addCageAlarm = <ThrowOnError extends boolean = true>(options: Options<AddCageAlarmData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AddCageAlarmResponse, AddCageAlarmError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/alarms/{cage_id}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Cage Alarm Types Endpoint
 * Get cage alarm types.
 */
export const getCageAlarmTypes = <ThrowOnError extends boolean = true>(
    options?: Options<GetCageAlarmTypesData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<GetCageAlarmTypesResponse, GetCageAlarmTypesError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/alarms/types",
        ...options,
    });
};

/**
 * Close Cage Alarm Endpoint
 * Close a cage alarm.
 */
export const closeCageAlarm = <ThrowOnError extends boolean = true>(
    options: Options<CloseCageAlarmData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, CloseCageAlarmError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/alarms/{alarm_id}",
        ...options,
    });
};

/**
 * Get Cage Hardware Status
 */
export const getCageHardwareStatus = <ThrowOnError extends boolean = true>(
    options: Options<GetCageHardwareStatusData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetCageHardwareStatusResponse,
        GetCageHardwareStatusError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/hardware/status",
        ...options,
    });
};

/**
 * Galilei Unpair Label
 * Unpair a label with a Galilei CageTalker.
 */
export const unpairLabel = <ThrowOnError extends boolean = true>(options: Options<UnpairLabelData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<unknown, UnpairLabelError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/hardware/galilei_cage_talker/{cage_id}",
        ...options,
    });
};

/**
 * Galilei Post Label
 * Pair a label with a Galilei CageTalker.
 */
export const pairLabel = <ThrowOnError extends boolean = true>(options: Options<PairLabelData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, PairLabelError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/hardware/galilei_cage_talker/{cage_id}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Galilei Update Cage Label
 * Update the label on a Galilei CageTalker.
 */
export const updateLabel = <ThrowOnError extends boolean = true>(options: Options<UpdateLabelData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdateLabelError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/hardware/galilei_cage_talker/{cage_id}",
        ...options,
    });
};

/**
 * Galilei Turn Label Led Off
 * Turn the LED on a Galilei CageTalker label off.
 */
export const turnLabelLedOff = <ThrowOnError extends boolean = true>(
    options: Options<TurnLabelLedOffData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, TurnLabelLedOffError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/hardware/galilei_cage_talker/{cage_id}/led",
        ...options,
    });
};

/**
 * Galilei Turn Label Led On
 * Turn the LED on a Galilei CageTalker label on.
 */
export const turnLabelLedOn = <ThrowOnError extends boolean = true>(
    options: Options<TurnLabelLedOnData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, TurnLabelLedOnError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/hardware/galilei_cage_talker/{cage_id}/led",
        ...options,
    });
};

/**
 * Tecniplast Get Unknown Cages
 * Get a list of unknown (empty) cages from the Tecniplast DVC.
 */
export const getUnknownCages = <ThrowOnError extends boolean = true>(
    options?: Options<GetUnknownCagesData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<GetUnknownCagesResponse, GetUnknownCagesError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/hardware/tecniplast_dvc/unknown_cages",
        ...options,
    });
};

/**
 * Tecniplast Obtain Dvc Position
 * Obtain a position in the Tecniplast DVC for a cage.
 */
export const obtainDvcPosition = <ThrowOnError extends boolean = true>(
    options: Options<ObtainDvcPositionData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, ObtainDvcPositionError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/hardware/tecniplast_dvc/{cage_id}/obtain_dvc_position",
        ...options,
    });
};

/**
 * Tecniplast Update Dvc Cage
 * Update the cage in the Tecniplast DVC.
 */
export const updateDvcCage = <ThrowOnError extends boolean = true>(
    options: Options<UpdateDvcCageData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdateDvcCageError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/hardware/tecniplast_dvc/{cage_id}/update_dvc_cage",
        ...options,
    });
};

/**
 * Tecniplast Disconnect Dvc Cage
 * Disconnect a cage from the Tecniplast DVC.
 */
export const disconnectCage = <ThrowOnError extends boolean = true>(
    options: Options<DisconnectCageData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, DisconnectCageError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/hardware/tecniplast_dvc/{cage_id}",
        ...options,
    });
};

/**
 * Tecniplast Connect Dvc Cage
 * Connect a cage to the Tecniplast DVC.
 */
export const connectCage = <ThrowOnError extends boolean = true>(options: Options<ConnectCageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, ConnectCageError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/hardware/tecniplast_dvc/{cage_id}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Tecniplast Turn Cage Led Off
 * Turn the LED off for a cage in the Tecniplast DVC.
 */
export const turnCageLedOff = <ThrowOnError extends boolean = true>(
    options: Options<TurnCageLedOffData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, TurnCageLedOffError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/hardware/tecniplast_dvc/{cage_id}/led",
        ...options,
    });
};

/**
 * Tecniplast Turn Cage Led On
 * Turn the LED on for a cage in the Tecniplast DVC.
 */
export const turnCageLedOn = <ThrowOnError extends boolean = true>(
    options: Options<TurnCageLedOnData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, TurnCageLedOnError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/hardware/tecniplast_dvc/{cage_id}/led",
        ...options,
    });
};

/**
 * Post Tecniplast Hook
 * Receive a hook call from the Tecniplast DVC.
 */
export const postTecniplastDvcHook = <ThrowOnError extends boolean = true>(
    options: Options<PostTecniplastDvcHookData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, PostTecniplastDvcHookError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/hardware/tecniplast_dvc/hook",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Breeding Cage Detail Data Endpoint
 * Get data for breeding cage detail dialog.
 */
export const getBreedingCageDetailData = <ThrowOnError extends boolean = true>(
    options: Options<GetBreedingCageDetailDataData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetBreedingCageDetailDataResponse,
        GetBreedingCageDetailDataError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/{cage_id}/breeding_cage_details",
        ...options,
    });
};

/**
 * Get Stock Cage Detail Data Endpoint
 * Get data for stock cage detail dialog.
 */
export const getStockCageDetailData = <ThrowOnError extends boolean = true>(
    options: Options<GetStockCageDetailDataData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetStockCageDetailDataResponse,
        GetStockCageDetailDataError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/{cage_id}/stock_cage_details",
        ...options,
    });
};

/**
 * Get Birth Dialog Data Endpoint
 * Get data for birth dialog.
 */
export const getBirthDialogData = <ThrowOnError extends boolean = true>(
    options: Options<GetBirthDialogDataData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetBirthDialogDataResponse, GetBirthDialogDataError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/{cage_id}/birth_dialog",
        ...options,
    });
};

/**
 * Get Next Free Cagenumber Suffix
 * Get next unused cagenumber suffix with the given prefix.
 */
export const getNextFreeCagenumberSuffix = <ThrowOnError extends boolean = true>(
    options: Options<GetNextFreeCagenumberSuffixData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetNextFreeCagenumberSuffixResponse,
        GetNextFreeCagenumberSuffixError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/next_free_cagenumber_suffix",
        ...options,
    });
};

/**
 * Get Quickselect Seed
 * Get seed for cage quickselect.
 */
export const getCageQuickselectSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetCageQuickselectSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<
        GetCageQuickselectSeedResponse,
        GetCageQuickselectSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/quickselect/seed",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Apply Quickselect
 * Apply Quickselect actions for selected cage IDs.
 */
export const applyCageQuickselectActions = <ThrowOnError extends boolean = true>(
    options: Options<ApplyCageQuickselectActionsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<
        ApplyCageQuickselectActionsResponse,
        ApplyCageQuickselectActionsError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/quickselect/apply",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Close Cage Endpoint
 * Close a cage.
 */
export const closeCage = <ThrowOnError extends boolean = true>(options: Options<CloseCageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<unknown, CloseCageError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/{cage_id}/close",
        ...options,
    });
};

/**
 * Note Cage In Action Log Endpoint
 * Add note for a cage to action log.
 */
export const noteCageInActionLog = <ThrowOnError extends boolean = true>(
    options: Options<NoteCageInActionLogData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, NoteCageInActionLogError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/{cage_id}/note_in_action_log",
        ...options,
    });
};

/**
 * Reopen Cage Endpoint
 * Reopen a cage.
 */
export const reopenCage = <ThrowOnError extends boolean = true>(options: Options<ReopenCageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<unknown, ReopenCageError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/{cage_id}/resurrect",
        ...options,
    });
};

/**
 * Get Category Endpoint
 * Get category for a cage.
 */
export const getCageCategory = <ThrowOnError extends boolean = true>(
    options: Options<GetCageCategoryData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetCageCategoryResponse2, GetCageCategoryError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/{cage_id}/category",
        ...options,
    });
};

/**
 * Set Category Endpoint
 * Set category for a cage.
 */
export const setCageCategory = <ThrowOnError extends boolean = true>(
    options: Options<SetCageCategoryData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetCageCategoryError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/{cage_id}/category",
        ...options,
    });
};

/**
 * Update Date In Endpoint
 * Update date in for an animal in cage.
 */
export const updateDateIn = <ThrowOnError extends boolean = true>(options: Options<UpdateDateInData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdateDateInError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/{cage_id}/date_in",
        ...options,
    });
};

/**
 * Update Date Out Endpoint
 * Update date out for an animal in cage.
 */
export const updateDateOut = <ThrowOnError extends boolean = true>(
    options: Options<UpdateDateOutData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdateDateOutError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/{cage_id}/date_out",
        ...options,
    });
};

/**
 * Get Incompatible Sanitary Status Locations Endpoint
 * Get incompatible sanitary status locations for cages based on given new cage or rack id.
 */
export const getIncompatibleSanitaryStatusLocations = <ThrowOnError extends boolean = true>(
    options: Options<GetIncompatibleSanitaryStatusLocationsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetIncompatibleSanitaryStatusLocationsResponse,
        GetIncompatibleSanitaryStatusLocationsError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/incompatible_sanitary_status_locations",
        ...options,
    });
};

/**
 * Get Label Endpoint
 * Get label for a cage.
 */
export const getCageLabel = <ThrowOnError extends boolean = true>(options: Options<GetCageLabelData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCageLabelResponse2, GetCageLabelError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/{cage_id}/label",
        ...options,
    });
};

/**
 * Set Label Endpoint
 * Set category for a cage.
 */
export const setCageLabel = <ThrowOnError extends boolean = true>(options: Options<SetCageLabelData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<unknown, SetCageLabelError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/{cage_id}/label",
        ...options,
    });
};

/**
 * Get Layout Endpoint
 * Get layout for a cage.
 */
export const getCageLayout = <ThrowOnError extends boolean = true>(
    options: Options<GetCageLayoutData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetCageLayoutResponse, GetCageLayoutError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/{cage_id}/layout",
        ...options,
    });
};

/**
 * Get Location Endpoint
 * Get location for a cage.
 */
export const getCageLocation = <ThrowOnError extends boolean = true>(
    options: Options<GetCageLocationData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetCageLocationResponse2, GetCageLocationError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/{cage_id}/location",
        ...options,
    });
};

/**
 * Set Location Endpoint
 * Set category for a cage.
 */
export const setCageLocation = <ThrowOnError extends boolean = true>(
    options: Options<SetCageLocationData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<SetCageLocationResponse2, SetCageLocationError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/{cage_id}/location",
        ...options,
    });
};

/**
 * Get Number Endpoint
 * Get number for a cage.
 */
export const getCageNumber = <ThrowOnError extends boolean = true>(
    options: Options<GetCageNumberData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetCageNumberResponse2, GetCageNumberError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/{cage_id}/number",
        ...options,
    });
};

/**
 * Set Number Endpoint
 * Set number for a cage.
 */
export const setCageNumber = <ThrowOnError extends boolean = true>(
    options: Options<SetCageNumberData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetCageNumberError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/{cage_id}/number",
        ...options,
    });
};

/**
 * Get Owner Endpoint
 * Get owner for a cage.
 */
export const getCageOwner = <ThrowOnError extends boolean = true>(options: Options<GetCageOwnerData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCageOwnerResponse2, GetCageOwnerError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/{cage_id}/owner",
        ...options,
    });
};

/**
 * Set Owner Endpoint
 * Set owner for a cage.
 */
export const setCageOwner = <ThrowOnError extends boolean = true>(options: Options<SetCageOwnerData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<unknown, SetCageOwnerError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/{cage_id}/owner",
        ...options,
    });
};

/**
 * Get Position Endpoint
 * Get position for a cage.
 */
export const getCagePosition = <ThrowOnError extends boolean = true>(
    options: Options<GetCagePositionData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetCagePositionResponse2, GetCagePositionError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/{cage_id}/position",
        ...options,
    });
};

/**
 * Set Position Endpoint
 * Set position for a cage.
 */
export const setCagePosition = <ThrowOnError extends boolean = true>(
    options: Options<SetCagePositionData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetCagePositionError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/{cage_id}/position",
        ...options,
    });
};

/**
 * Get Responsible Endpoint
 * Get responsible for a cage.
 */
export const getCageResponsible = <ThrowOnError extends boolean = true>(
    options: Options<GetCageResponsibleData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetCageResponsibleResponse2, GetCageResponsibleError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/{cage_id}/responsible",
        ...options,
    });
};

/**
 * Set Responsible Endpoint
 * Set responsible for a cage.
 */
export const setCageResponsible = <ThrowOnError extends boolean = true>(
    options: Options<SetCageResponsibleData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetCageResponsibleError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/{cage_id}/responsible",
        ...options,
    });
};

/**
 * Remove Cage Projects Endpoint
 * Remove projects from a cage
 */
export const removeCageProjects = <ThrowOnError extends boolean = true>(
    options: Options<RemoveCageProjectsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, RemoveCageProjectsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/{cage_id}/projects",
        ...options,
    });
};

/**
 * Get Cage Projects Endpoint
 * Get all projects assigned to a cage
 */
export const getCageProjects = <ThrowOnError extends boolean = true>(
    options: Options<GetCageProjectsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetCageProjectsResponse, GetCageProjectsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/{cage_id}/projects",
        ...options,
    });
};

/**
 * Add Cage Projects Endpoint
 * Assign projects to a cage
 */
export const addCageProjects = <ThrowOnError extends boolean = true>(
    options: Options<AddCageProjectsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, AddCageProjectsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cages/{cage_id}/projects",
        ...options,
    });
};

/**
 * Update Cage Categories
 * Change data of multiple cage categories at once and roll back on error.
 */
export const updateCageCategories = <ThrowOnError extends boolean = true>(
    options: Options<UpdateCageCategoriesData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, UpdateCageCategoriesError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cage_categories",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Mark Comment Hidden
 * Mark a comment as hidden.
 */
export const markCommentHidden = <ThrowOnError extends boolean = true>(
    options: Options<MarkCommentHiddenData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<MarkCommentHiddenResponse, MarkCommentHiddenError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/comments/{comment_id}/visible",
        ...options,
    });
};

/**
 * Mark Comment Visible
 * Mark a comment as visible.
 */
export const markCommentVisible = <ThrowOnError extends boolean = true>(
    options: Options<MarkCommentVisibleData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<MarkCommentVisibleResponse, MarkCommentVisibleError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/comments/{comment_id}/visible",
        ...options,
    });
};

/**
 * Get Comment Widget Seed
 * Get a seed for the comment widget.
 */
export const getCommentWidgetSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetCommentWidgetSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<
        GetCommentWidgetSeedResponse,
        GetCommentWidgetSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/comments/seed",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Post Comment
 * Post a comment.
 *
 * Return the comment ID and a new seed for the comment widget.
 */
export const postComment = <ThrowOnError extends boolean = true>(options: Options<PostCommentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostCommentResponse2, PostCommentError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/comments",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Update Attributes
 * Update the comment attribute list.
 */
export const updateCommentAttributeList = <ThrowOnError extends boolean = true>(
    options: Options<UpdateCommentAttributeListData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdateCommentAttributeListError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/comments/attributes",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Update Cost Elements
 * Change data of multiple cost elements at once and roll back on error.
 */
export const updateCostElements = <ThrowOnError extends boolean = true>(
    options: Options<UpdateCostElementsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, UpdateCostElementsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cost_elements",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Update Billing Type Cost Element
 * Add cost element associated to billing type and roll back on error.
 */
export const updateBillingTypeCostElement = <ThrowOnError extends boolean = true>(
    options: Options<UpdateBillingTypeCostElementData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, UpdateBillingTypeCostElementError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cost_elements/{cost_element_id}/billing_types/{billing_type_id}",
        ...options,
    });
};

/**
 * Get Cryotanks For Setting
 * Get cryotanks to specify where to place cryopreserved content.
 */
export const getCryotanksForSetting = <ThrowOnError extends boolean = true>(
    options?: Options<GetCryotanksForSettingData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<
        GetCryotanksForSettingResponse,
        GetCryotanksForSettingError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cryotanks/for_setting",
        ...options,
    });
};

/**
 * Get Cryotank Details
 * Get cryotank details.
 */
export const getCryotankDetails = <ThrowOnError extends boolean = true>(
    options: Options<GetCryotankDetailsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetCryotankDetailsResponse, GetCryotankDetailsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cryotanks/{cryotank_id}/details",
        ...options,
    });
};

/**
 * Get Container Details
 * Get data of a container inside a cryotank to display in the cryotank browser.
 */
export const getContainerDetails = <ThrowOnError extends boolean = true>(
    options: Options<GetContainerDetailsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetContainerDetailsResponse, GetContainerDetailsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cryotanks/{cryotank_id}/container_details",
        ...options,
    });
};

/**
 * Get Straw Details
 * Get content data of a straw inside a cryotank.
 */
export const getStrawDetails = <ThrowOnError extends boolean = true>(
    options: Options<GetStrawDetailsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetStrawDetailsResponse, GetStrawDetailsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cryotanks/{cryotank_id}/straw_details",
        ...options,
    });
};

/**
 * Get Straw Label
 * Get straw label of a known cryotank content (a frozen embryo group or sperm volume)
 */
export const getStrawLabel = <ThrowOnError extends boolean = true>(
    options: Options<GetStrawLabelData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetStrawLabelResponse, GetStrawLabelError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cryotanks/cryotank_content/{cryotank_content_id}/straw_label",
        ...options,
    });
};

/**
 * Set Straw Label
 * Set straw label of a known cryotank content (a frozen embryo group or sperm volume)
 */
export const setStrawLabel = <ThrowOnError extends boolean = true>(
    options: Options<SetStrawLabelData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetStrawLabelError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cryotanks/cryotank_content/{cryotank_content_id}",
        ...options,
    });
};

/**
 * Get Display Hints For Setting
 * Get possible display hint that control the rendering of the cryotank nodes.
 */
export const getCryotankNodeDisplayHintsForSetting = <ThrowOnError extends boolean = true>(
    options?: Options<GetCryotankNodeDisplayHintsForSettingData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<
        GetCryotankNodeDisplayHintsForSettingResponse,
        GetCryotankNodeDisplayHintsForSettingError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cryotanks/display_hints/for_setting",
        ...options,
    });
};

/**
 * Create Cryotank
 * Create new cryotank.
 */
export const createCryotank = <ThrowOnError extends boolean = true>(
    options: Options<CreateCryotankData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, CreateCryotankError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cryotanks",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Delete Cryotank
 * Delete a cryotank.
 */
export const deleteCryotank = <ThrowOnError extends boolean = true>(
    options: Options<DeleteCryotankData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, DeleteCryotankError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cryotanks/{cryotank_id}",
        ...options,
    });
};

/**
 * Update Cryotank
 * Update data of existing cryotank.
 */
export const updateCryotank = <ThrowOnError extends boolean = true>(
    options: Options<UpdateCryotankData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdateCryotankError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cryotanks/{cryotank_id}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Update Cryotank Path Color
 * Update the color of one node inside the cryotank.
 */
export const updateCryotankPathColor = <ThrowOnError extends boolean = true>(
    options: Options<UpdateCryotankPathColorData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdateCryotankPathColorError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/cryotanks/{cryotank_id}/path_color",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Update Device Categories Endpoint
 * Update the device categories.
 */
export const updateDeviceCategories = <ThrowOnError extends boolean = true>(
    options: Options<UpdateDeviceCategoriesData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, UpdateDeviceCategoriesError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/devices/device_categories",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Update Device Event Categories Endpoint
 * Update the device categories.
 */
export const updateDeviceEventCategories = <ThrowOnError extends boolean = true>(
    options: Options<UpdateDeviceEventCategoriesData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, UpdateDeviceEventCategoriesError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/devices/device_event_categories",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get New Device Endpoint
 * Get a device.
 */
export const getNewDeviceDialogSeed = <ThrowOnError extends boolean = true>(
    options?: Options<GetNewDeviceDialogSeedData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<
        GetNewDeviceDialogSeedResponse,
        GetNewDeviceDialogSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/devices/device/new",
        ...options,
    });
};

/**
 * Get Existing Device Endpoint
 * Get a device.
 */
export const getExistingDeviceDialogSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetExistingDeviceDialogSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetExistingDeviceDialogSeedResponse,
        GetExistingDeviceDialogSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/devices/device/{device_id}",
        ...options,
    });
};

/**
 * Update Device Endpoint
 * Update a device.
 */
export const updateDevice = <ThrowOnError extends boolean = true>(options: Options<UpdateDeviceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdateDeviceError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/devices/device/{device_id}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Add Device Endpoint
 * Add a device.
 */
export const addDevice = <ThrowOnError extends boolean = true>(options: Options<AddDeviceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AddDeviceResponse, AddDeviceError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/devices/device",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get New Device Event Endpoint
 * Get a new device event dialog seed.
 */
export const getNewDeviceEventDialogSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetNewDeviceEventDialogSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetNewDeviceEventDialogSeedResponse,
        GetNewDeviceEventDialogSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/devices/device/{device_id}/events/new",
        ...options,
    });
};

/**
 * Get Existing Device Event Endpoint
 * Get an existing device event dialog seed.
 */
export const getExistingDeviceEventDialogSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetExistingDeviceEventDialogSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetExistingDeviceEventDialogSeedResponse,
        GetExistingDeviceEventDialogSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/devices/device/{device_id}/events/{event_id}",
        ...options,
    });
};

/**
 * Update Device Event Endpoint
 * Update a device event.
 */
export const updateDeviceEvent = <ThrowOnError extends boolean = true>(
    options: Options<UpdateDeviceEventData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdateDeviceEventError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/devices/device/{device_id}/events/{event_id}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Add Device Event Endpoint
 * Add a device event.
 */
export const addDeviceEvent = <ThrowOnError extends boolean = true>(
    options: Options<AddDeviceEventData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<AddDeviceEventResponse, AddDeviceEventError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/devices/device/{device_id}/events",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Document Widget Seed
 * Get a seed for the document widget.
 */
export const getDocumentWidgetSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetDocumentWidgetSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<
        GetDocumentWidgetSeedResponse,
        GetDocumentWidgetSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/documents/seed",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Post Document
 * Upload a document.
 *
 * Return the ID of the document.
 */
export const storeDocument = <ThrowOnError extends boolean = true>(
    options: Options<StoreDocumentData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<StoreDocumentResponse, StoreDocumentError, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/documents",
        ...options,
        headers: {
            "Content-Type": null,
            ...options?.headers,
        },
    });
};

/**
 * Delete Document Subjects
 */
export const removeDocumentSubjects = <ThrowOnError extends boolean = true>(
    options: Options<RemoveDocumentSubjectsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, RemoveDocumentSubjectsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/documents/{document_id}/subjects",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Delete Document Id
 * Delete a document.
 */
export const deleteDocument = <ThrowOnError extends boolean = true>(
    options: Options<DeleteDocumentData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, DeleteDocumentError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/documents/{document_id}",
        ...options,
    });
};

/**
 * Get Independent Document Id
 * Get details of an independent document.
 */
export const getIndependentDocumentDetails = <ThrowOnError extends boolean = true>(
    options: Options<GetIndependentDocumentDetailsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetIndependentDocumentDetailsResponse,
        GetIndependentDocumentDetailsError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/documents/independent/{document_id}",
        ...options,
    });
};

/**
 * Update Independent Document Id
 * Update an independent document.
 */
export const updateIndependentDocument = <ThrowOnError extends boolean = true>(
    options: Options<UpdateIndependentDocumentData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdateIndependentDocumentError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/documents/independent/{document_id}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Add Independent Document
 * Add an independent document.
 */
export const addIndependentDocument = <ThrowOnError extends boolean = true>(
    options: Options<AddIndependentDocumentData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, AddIndependentDocumentError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/documents/independent",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Drug Request Details Endpoint
 * Get dialog seed for drug request details
 */
export const getDrugRequestDetails = <ThrowOnError extends boolean = true>(
    options?: Options<GetDrugRequestDetailsData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<
        GetDrugRequestDetailsResponse,
        GetDrugRequestDetailsError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/drug_requests/details",
        ...options,
    });
};

/**
 * Create Drug Request Endpoint
 * Create a new drug request.
 */
export const createDrugRequest = <ThrowOnError extends boolean = true>(
    options: Options<CreateDrugRequestData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, CreateDrugRequestError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/drug_requests",
        ...options,
    });
};

/**
 * Update Drug Request Endpoint
 * Update a drug request by ID.
 */
export const updateDrugRequest = <ThrowOnError extends boolean = true>(
    options: Options<UpdateDrugRequestData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdateDrugRequestError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/drug_requests/{drug_request_id}",
        ...options,
    });
};

/**
 * Set Drug Request Status Endpoint
 * Set the status for a drug request.
 */
export const setDrugRequestStatus = <ThrowOnError extends boolean = true>(
    options: Options<SetDrugRequestStatusData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetDrugRequestStatusError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/drug_requests/{drug_request_id}/status",
        ...options,
    });
};

/**
 * Get Drug Details Endpoint
 * Get dialog seed for drug details
 */
export const getDrugDetails = <ThrowOnError extends boolean = true>(
    options?: Options<GetDrugDetailsData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<GetDrugDetailsResponse, GetDrugDetailsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/drugs/details",
        ...options,
    });
};

/**
 * Create Drug Endpoint
 * Create a new drug.
 */
export const createDrug = <ThrowOnError extends boolean = true>(options: Options<CreateDrugData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateDrugResponse2, CreateDrugError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/drugs",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Delete Drug Endpoint
 * Delete a drug by ID.
 */
export const deleteDrug = <ThrowOnError extends boolean = true>(options: Options<DeleteDrugData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<unknown, DeleteDrugError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/drugs/{drug_id}",
        ...options,
    });
};

/**
 * Update Drug Endpoint
 * Update a drug by ID.
 */
export const updateDrug = <ThrowOnError extends boolean = true>(options: Options<UpdateDrugData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdateDrugError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/drugs/{drug_id}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Drugs For Procedure For Setting Endpoint
 * Get the list of available drugs for applying a procedure.
 */
export const getDrugsForProcedureForSetting = <ThrowOnError extends boolean = true>(
    options: Options<GetDrugsForProcedureForSettingData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetDrugsForProcedureForSettingResponse,
        GetDrugsForProcedureForSettingError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/drugs/drugs_for_procedure/{procedure_id}/for_setting",
        ...options,
    });
};

/**
 * Update Drug Categories
 * Update the drug categories.
 */
export const updateDrugCategories = <ThrowOnError extends boolean = true>(
    options: Options<UpdateDrugCategoriesData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, UpdateDrugCategoriesError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/drugs/categories",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Drug Package Details Endpoint
 * Get dialog seed for drug package details
 */
export const getDrugPackageDetails = <ThrowOnError extends boolean = true>(
    options?: Options<GetDrugPackageDetailsData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<
        GetDrugPackageDetailsResponse,
        GetDrugPackageDetailsError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/drugs/packages",
        ...options,
    });
};

/**
 * Create Drug Packages Endpoint
 * Create multiple drug packages with the same data.
 */
export const createDrugPackages = <ThrowOnError extends boolean = true>(
    options: Options<CreateDrugPackagesData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, CreateDrugPackagesError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/drugs/packages",
        ...options,
    });
};

/**
 * Delete Drug Package Endpoint
 * Delete a drug package by ID.
 */
export const deleteDrugPackage = <ThrowOnError extends boolean = true>(
    options: Options<DeleteDrugPackageData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, DeleteDrugPackageError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/drugs/packages/{drug_package_id}",
        ...options,
    });
};

/**
 * Update Drug Package Endpoint
 * Update a drug package by ID.
 */
export const updateDrugPackage = <ThrowOnError extends boolean = true>(
    options: Options<UpdateDrugPackageData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdateDrugPackageError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/drugs/packages/{drug_package_id}",
        ...options,
    });
};

/**
 * Set Drug Package Status Endpoint
 * Set status for a drug package.
 */
export const setDrugPackageStatus = <ThrowOnError extends boolean = true>(
    options: Options<SetDrugPackageStatusData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetDrugPackageStatusError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/drugs/packages/{drug_package_id}/status",
        ...options,
    });
};

/**
 * Sign Off Drug Package Endpoint
 * Sign off elimination of a drug package by ID.
 */
export const signOffDrugPackage = <ThrowOnError extends boolean = true>(
    options: Options<SignOffDrugPackageData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SignOffDrugPackageError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/drugs/packages/{drug_package_id}/sign_off",
        ...options,
    });
};

/**
 * Get Quickselect Seed
 * Get seed for drug package quickselect.
 */
export const getDrugPackageQuickselectSeed = <ThrowOnError extends boolean = true>(
    options?: Options<GetDrugPackageQuickselectSeedData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).post<
        GetDrugPackageQuickselectSeedResponse,
        GetDrugPackageQuickselectSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/drugs/quickselect/seed",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Apply Quickselect
 */
export const applyDrugPackageQuickselectActions = <ThrowOnError extends boolean = true>(
    options: Options<ApplyDrugPackageQuickselectActionsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<
        ApplyDrugPackageQuickselectActionsResponse,
        ApplyDrugPackageQuickselectActionsError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/drugs/quickselect/apply",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Drug Packages For Setting Endpoint
 * Get the list of available drug packages for the given drug id.
 */
export const getDrugPackagesForSetting = <ThrowOnError extends boolean = true>(
    options: Options<GetDrugPackagesForSettingData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetDrugPackagesForSettingResponse,
        GetDrugPackagesForSettingError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/drugs/drug_packages/for_setting",
        ...options,
    });
};

/**
 * Get Drug Register Details Endpoint
 * Get dialog seed for drug register details
 */
export const getDrugRegisterDetails = <ThrowOnError extends boolean = true>(
    options?: Options<GetDrugRegisterDetailsData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<
        GetDrugRegisterDetailsResponse,
        GetDrugRegisterDetailsError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/drugs/registers",
        ...options,
    });
};

/**
 * Create Drug Register Endpoint
 * Create a new drug register.
 */
export const createDrugRegister = <ThrowOnError extends boolean = true>(
    options: Options<CreateDrugRegisterData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, CreateDrugRegisterError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/drugs/registers",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Delete Drug Register Endpoint
 * Delete a drug register by ID.
 */
export const deleteDrugRegister = <ThrowOnError extends boolean = true>(
    options: Options<DeleteDrugRegisterData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, DeleteDrugRegisterError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/drugs/registers/{drug_register_id}",
        ...options,
    });
};

/**
 * Update Drug Register Endpoint
 * Update a drug register by ID.
 */
export const updateDrugRegister = <ThrowOnError extends boolean = true>(
    options: Options<UpdateDrugRegisterData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdateDrugRegisterError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/drugs/registers/{drug_register_id}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Embryo Details
 * Get details of an embryo group.
 */
export const getEmbryoDetails = <ThrowOnError extends boolean = true>(
    options: Options<GetEmbryoDetailsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetEmbryoDetailsResponse, GetEmbryoDetailsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/embryos/{embryo_group_key}/details",
        ...options,
    });
};

/**
 * Get Embryo History
 * Get history of an embryo group.
 */
export const getEmbryoHistory = <ThrowOnError extends boolean = true>(
    options: Options<GetEmbryoHistoryData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetEmbryoHistoryResponse, GetEmbryoHistoryError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/embryos/{embryo_group_key}/history",
        ...options,
    });
};

/**
 * Get Carnegie Stages
 * Get possible carnegie stages (age levels, cell stages) for embryos.
 */
export const getCarnegieStagesForSetting = <ThrowOnError extends boolean = true>(
    options?: Options<GetCarnegieStagesForSettingData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<
        GetCarnegieStagesForSettingResponse,
        GetCarnegieStagesForSettingError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/embryos/carnegie_stages/for_setting",
        ...options,
    });
};

/**
 * Get Next Free Straw Labels
 * Get next free straw labels for cryopreserved embryos.
 */
export const getNextFreeEmbryoStrawLabels = <ThrowOnError extends boolean = true>(
    options: Options<GetNextFreeEmbryoStrawLabelsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetNextFreeEmbryoStrawLabelsResponse,
        GetNextFreeEmbryoStrawLabelsError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/embryos/straw_labels/for_setting",
        ...options,
    });
};

/**
 * Get Foster Mothers By Strain Id
 * Get female animals of the given strain to use them as foster mothers for embryos.
 */
export const getFosterMothersByStrainId = <ThrowOnError extends boolean = true>(
    options: Options<GetFosterMothersByStrainIdData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetFosterMothersByStrainIdResponse,
        GetFosterMothersByStrainIdError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/embryos/foster_mothers_by_strain_id/{strain_id}",
        ...options,
    });
};

/**
 * Get Foster Mother Suffixes
 * Get missing suffixes to assign new eartags to foster mothers on embryo transfer.
 */
export const getFosterMotherSuffixes = <ThrowOnError extends boolean = true>(
    options: Options<GetFosterMotherSuffixesData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetFosterMotherSuffixesResponse,
        GetFosterMotherSuffixesError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/embryos/foster_mother_suffixes",
        ...options,
    });
};

/**
 * Import Embryos
 * Import embryos.
 */
export const importEmbryos = <ThrowOnError extends boolean = true>(
    options: Options<ImportEmbryosData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<ImportEmbryosResponse, ImportEmbryosError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/embryos/import",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Quickselect Seed
 * Get seed for embryo Quickselect.
 */
export const getEmbryoQuickselectSeed = <ThrowOnError extends boolean = true>(
    options?: Options<GetEmbryoQuickselectSeedData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).put<
        GetEmbryoQuickselectSeedResponse,
        GetEmbryoQuickselectSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/embryos/quickselect/seed",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Apply Quickselect
 * Apply Quickselect actions to selected embryo IDs.
 */
export const applyEmbryoQuickselectActions = <ThrowOnError extends boolean = true>(
    options: Options<ApplyEmbryoQuickselectActionsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<
        ApplyEmbryoQuickselectActionsResponse,
        ApplyEmbryoQuickselectActionsError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/embryos/quickselect/apply",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Update Facilities
 * Change data of multiple facilities at once and roll back on error.
 */
export const updateFacilities = <ThrowOnError extends boolean = true>(
    options: Options<UpdateFacilitiesData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, UpdateFacilitiesError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/facilities",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Update Genetic Backgrounds
 * Change data of multiple genetic backgrounds at once and roll back on error.
 */
export const updateGeneticBackgrounds = <ThrowOnError extends boolean = true>(
    options: Options<UpdateGeneticBackgroundsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, UpdateGeneticBackgroundsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/genetic_backgrounds",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Update Internal Order Costs
 * Change data of multiple internal order cost at once and roll back on error.
 */
export const updateInternalOrderCosts = <ThrowOnError extends boolean = true>(
    options: Options<UpdateInternalOrderCostsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, UpdateInternalOrderCostsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/internalOrderCosts",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get License Options Endpoint
 * Get the list of licenses for setting a license.
 *
 * Replacement for former:
 * - ajax_service -> get_licence_list_json
 * - ajax_service -> get_licenses_for_association
 * - ajax_service -> get_licenses_for_setting
 */
export const getLicenseOptions = <ThrowOnError extends boolean = true>(
    options?: Options<GetLicenseOptionsData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<GetLicenseOptionsResponse, GetLicenseOptionsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/licenses/license_options",
        ...options,
    });
};

/**
 * Get License Classification Options Endpoint
 * Get the list of classifications for setting a license.
 *
 * Replacement for former:
 * - ajax_service -> get_licence_classifications_json
 * - ajax_service -> get_license_classifications_for_association
 * - ajax_service -> get_license_classifications_for_setting
 * - ajax_service -> get_license_classifications_for_filter
 */
export const getLicenseClassificationOptions = <ThrowOnError extends boolean = true>(
    options: Options<GetLicenseClassificationOptionsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetLicenseClassificationOptionsResponse,
        GetLicenseClassificationOptionsError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/licenses/license/{license_id}/classification_options",
        ...options,
    });
};

/**
 * Get Procedures For Classification Endpoint
 * Get procedures for the given classification.
 *
 * Replacement for former:
 * - ajax_service -> get_procedures_for_classification
 */
export const getProceduresForClassification = <ThrowOnError extends boolean = true>(
    options: Options<GetProceduresForClassificationData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetProceduresForClassificationResponse,
        GetProceduresForClassificationError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/licenses/classification/{classification_id}/procedures",
        ...options,
    });
};

/**
 * Get License Sign Off Data
 * Get the sign-off details for a license or default (license_id=0).
 */
export const getLicenseSignOff = <ThrowOnError extends boolean = true>(
    options: Options<GetLicenseSignOffData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetLicenseSignOffResponse, GetLicenseSignOffError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/licenses/license/{license_id}/sign_off",
        ...options,
    });
};

/**
 * Post License Sign Off Data
 * Save the sign-off details for a license or the default (license_id=0).
 */
export const saveLicenseSignOff = <ThrowOnError extends boolean = true>(
    options: Options<SaveLicenseSignOffData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, SaveLicenseSignOffError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/licenses/license/{license_id}/sign_off",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Set License Dialog Options Endpoint
 * Get the options for setting a license.
 */
export const getSetLicenseDialogOptions = <ThrowOnError extends boolean = true>(
    options?: Options<GetSetLicenseDialogOptionsData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<
        GetSetLicenseDialogOptionsResponse,
        GetSetLicenseDialogOptionsError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/licenses/set_license_dialog_options",
        ...options,
    });
};

/**
 * Apply Licenses Changes Endpoint
 */
export const applyLicenseAssignments = <ThrowOnError extends boolean = true>(
    options: Options<ApplyLicenseAssignmentsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, ApplyLicenseAssignmentsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/licenses/set_license",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Update License Types
 * Change data of multiple license types at once and roll back on error.
 */
export const updateLicenseTypes = <ThrowOnError extends boolean = true>(
    options: Options<UpdateLicenseTypesData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, UpdateLicenseTypesError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/licenses/update_license_types",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get License Details Seed Endpoint
 * Get the details of a license.
 */
export const getLicenseDetailsSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetLicenseDetailsSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetLicenseDetailsSeedResponse,
        GetLicenseDetailsSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/licenses/license/{license_id}/details",
        ...options,
    });
};

/**
 * Post License Details Endpoint
 * Update the details of a license or create a new one.
 */
export const updateLicenseDetails = <ThrowOnError extends boolean = true>(
    options: Options<UpdateLicenseDetailsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<
        UpdateLicenseDetailsResponse,
        UpdateLicenseDetailsError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/licenses/license/{license_id}/details",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Add Guidance Endpoint
 * Add guidance as sign-off-user.
 */
export const addLicenseGuidance = <ThrowOnError extends boolean = true>(
    options: Options<AddLicenseGuidanceData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, AddLicenseGuidanceError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/licenses/license/{license_id}/guidance",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Delete License Endpoint
 * Deactivate a license.
 */
export const deleteLicense = <ThrowOnError extends boolean = true>(
    options: Options<DeleteLicenseData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, DeleteLicenseError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/licenses/license/{license_id}",
        ...options,
    });
};

/**
 * Get Column Select Params
 * Return the parameters for the Listview view_name.
 */
export const getColumnSelectParams = <ThrowOnError extends boolean = true>(
    options: Options<GetColumnSelectParamsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetColumnSelectParamsResponse,
        GetColumnSelectParamsError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/list_view/{view_name}/column_select",
        ...options,
    });
};

/**
 * Post Column Selection
 * Set the selected columns for the Listview view_name.
 */
export const setColumnSelection = <ThrowOnError extends boolean = true>(
    options: Options<SetColumnSelectionData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, SetColumnSelectionError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/list_view/{view_name}/column_select",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Filter Parameters
 * Get list filter "seed" parameters.
 */
export const getFilterParameters = <ThrowOnError extends boolean = true>(
    options: Options<GetFilterParametersData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<GetFilterParametersResponse, GetFilterParametersError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/list_view/{view_name}/filter/parameters",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Set Filter
 * Set list filter.
 */
export const setFilter = <ThrowOnError extends boolean = true>(options: Options<SetFilterData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, SetFilterError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/list_view/{view_name}/filter/set",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Reset Filter
 * Reset list filter.
 */
export const resetFilter = <ThrowOnError extends boolean = true>(options: Options<ResetFilterData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, ResetFilterError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/list_view/{view_name}/filter/reset",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Execute Filter Request
 * Set list filter preferences.
 */
export const setFilterPreferences = <ThrowOnError extends boolean = true>(
    options: Options<SetFilterPreferencesData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, SetFilterPreferencesError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/list_view/{view_name}/filter/set_preferences",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Set Filter Preset
 * Set list filter preset.
 */
export const setFilterPreset = <ThrowOnError extends boolean = true>(
    options: Options<SetFilterPresetData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, SetFilterPresetError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/list_view/{view_name}/filter/set_preset",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Remove Filter Preset
 * Remove filter preset.
 */
export const removeFilterPreset = <ThrowOnError extends boolean = true>(
    options: Options<RemoveFilterPresetData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, RemoveFilterPresetError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/list_view/{view_name}/filter/remove_preset",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Possible Filter Values
 * Get possible filter values.
 */
export const getPossibleFilterValues = <ThrowOnError extends boolean = true>(
    options: Options<GetPossibleFilterValuesData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, GetPossibleFilterValuesError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/list_view/{view_name}/filter/possible_values/{item_name}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Location Detail Seed
 * Get the location detail seed.
 */
export const getLocationDetails = <ThrowOnError extends boolean = true>(
    options: Options<GetLocationDetailsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetLocationDetailsResponse, GetLocationDetailsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/locations/{location_id}/details",
        ...options,
    });
};

/**
 * Update Location Endpoint
 * Update a location from the detail page.
 */
export const updateLocationDetails = <ThrowOnError extends boolean = true>(
    options: Options<UpdateLocationDetailsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdateLocationDetailsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/locations/{location_id}/details",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Generate Rack Positions
 * Generate a position matrix for a rack.
 */
export const generateRackPositions = <ThrowOnError extends boolean = true>(
    options: Options<GenerateRackPositionsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GenerateRackPositionsResponse,
        GenerateRackPositionsError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/locations/positions",
        ...options,
    });
};

/**
 * Delete Location Endpoint
 * Delete a location.
 */
export const deleteLocation = <ThrowOnError extends boolean = true>(
    options: Options<DeleteLocationData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, DeleteLocationError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/locations/{location_id}",
        ...options,
    });
};

/**
 * Create Location Endpoint
 * Create a new location.
 */
export const createLocation = <ThrowOnError extends boolean = true>(
    options?: Options<CreateLocationData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).post<CreateLocationResponse, CreateLocationError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/locations",
        ...options,
    });
};

/**
 * Get Picker Location
 * Get a single location for the location picker (used to show preselected item).
 */
export const getPickerLocation = <ThrowOnError extends boolean = true>(
    options: Options<GetPickerLocationData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetPickerLocationResponse, GetPickerLocationError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/locations/picker/locations/types/{location_type}/{location_id}",
        ...options,
    });
};

/**
 * Get Picker Location List
 * Get locations for the location picker.
 */
export const getPickerLocationList = <ThrowOnError extends boolean = true>(
    options?: Options<GetPickerLocationListData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<
        GetPickerLocationListResponse,
        GetPickerLocationListError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/locations/picker/locations",
        ...options,
    });
};

/**
 * Get Picker Cage
 * Get a single cage for the location picker
 */
export const getPickerCage = <ThrowOnError extends boolean = true>(
    options: Options<GetPickerCageData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetPickerCageResponse, GetPickerCageError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/locations/picker/locations/cages/{cage_id}",
        ...options,
    });
};

/**
 * Get Picker Cage List
 * Get cages for the location picker
 */
export const getPickerCageList = <ThrowOnError extends boolean = true>(
    options: Options<GetPickerCageListData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetPickerCageListResponse, GetPickerCageListError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/locations/picker/locations/{location_id}/cages",
        ...options,
    });
};

/**
 * Get Picker Tank List
 * Get tanks for the location picker
 */
export const getPickerTankList = <ThrowOnError extends boolean = true>(
    options: Options<GetPickerTankListData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetPickerTankListResponse, GetPickerTankListError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/locations/picker/locations/{location_id}/tanks",
        ...options,
    });
};

/**
 * Update Medical Conditions
 * Change data of multiple medical conditions at once and roll back on error.
 */
export const updateMedicalConditions = <ThrowOnError extends boolean = true>(
    options: Options<UpdateMedicalConditionsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, UpdateMedicalConditionsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/medical_conditions",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Mutation Dialog Seed Endpoint
 * Get seed for mutation dialog.
 */
export const getMutationDialogSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetMutationDialogSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetMutationDialogSeedResponse,
        GetMutationDialogSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/mutations/{mutation_id}",
        ...options,
    });
};

/**
 * Update Mutation Endpoint
 */
export const updateMutation = <ThrowOnError extends boolean = true>(
    options: Options<UpdateMutationData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdateMutationError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/mutations/{mutation_id}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Mutation Dialog Seed Endpoint
 * Get seed for mutation dialog.
 */
export const getNewMutationDialogSeed = <ThrowOnError extends boolean = true>(
    options?: Options<GetNewMutationDialogSeedData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<
        GetNewMutationDialogSeedResponse,
        GetNewMutationDialogSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/mutations/new",
        ...options,
    });
};

/**
 * Create Mutation Endpoint
 */
export const createMutation = <ThrowOnError extends boolean = true>(
    options: Options<CreateMutationData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<CreateMutationResponse, CreateMutationError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/mutations/new",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Deactivate Mutation Endpoint
 * Deactivate a mutation.
 */
export const deactivateMutation = <ThrowOnError extends boolean = true>(
    options: Options<DeactivateMutationData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, DeactivateMutationError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/mutations/{mutation_id}/active",
        ...options,
    });
};

/**
 * Activate Mutation Endpoint
 * Activate a mutation.
 */
export const activateMutation = <ThrowOnError extends boolean = true>(
    options: Options<ActivateMutationData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, ActivateMutationError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/mutations/{mutation_id}/active",
        ...options,
    });
};

/**
 * Get Mutation Grades
 * Get grade list according to the specified mutation id.
 */
export const getMutationGrades = <ThrowOnError extends boolean = true>(
    options: Options<GetMutationGradesData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetMutationGradesResponse, GetMutationGradesError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/mutations/{mutation_id}/grades",
        ...options,
    });
};

/**
 * Update Grades
 * Change data of multiple grades at once and roll back on error.
 */
export const updateGrades = <ThrowOnError extends boolean = true>(options: Options<UpdateGradesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, UpdateGradesError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/mutation_grades",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Update Mutation Types
 * Change data of multiple mutation types at once and roll back on error.
 */
export const updateMutationTypes = <ThrowOnError extends boolean = true>(
    options: Options<UpdateMutationTypesData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, UpdateMutationTypesError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/mutation_types",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Delete Mutation Types Grade
 * Delete grade associated to mutation types and roll back on error.
 */
export const deleteMutationTypeGrade = <ThrowOnError extends boolean = true>(
    options: Options<DeleteMutationTypeGradeData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, DeleteMutationTypeGradeError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/mutation_types/{mutation_type_id}/grades/{grade_id}",
        ...options,
    });
};

/**
 * Add Mutation Types Grade
 * Add grade associated to mutation types and roll back on error.
 */
export const addMutationTypeGrade = <ThrowOnError extends boolean = true>(
    options: Options<AddMutationTypeGradeData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, AddMutationTypeGradeError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/mutation_types/{mutation_type_id}/grades/{grade_id}",
        ...options,
    });
};

/**
 * Get Mutation Type Unassigned Grades
 * Get grades that can still be associated to mutation types.
 */
export const getMutationTypeUnassignedGrades = <ThrowOnError extends boolean = true>(
    options: Options<GetMutationTypeUnassignedGradesData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetMutationTypeUnassignedGradesResponse,
        GetMutationTypeUnassignedGradesError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/mutation_types/{mutation_type_id}/grades",
        ...options,
    });
};

/**
 * Update Order Request Catalogs
 * Update the order request catalogs.
 */
export const updateOrderRequestCatalogs = <ThrowOnError extends boolean = true>(
    options: Options<UpdateOrderRequestCatalogsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, UpdateOrderRequestCatalogsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/order_request_catalogs",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Update Order Request Catalog Items
 * Update the order request catalogs.
 */
export const updateOrderRequestCatalogItems = <ThrowOnError extends boolean = true>(
    options: Options<UpdateOrderRequestCatalogItemsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, UpdateOrderRequestCatalogItemsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/order_request_catalogs/items",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Upload Order Request Catalog Import File
 * Handle upload of the import file and return import data for a preview.
 */
export const uploadOrderRequestCatalogImportFile = <ThrowOnError extends boolean = true>(
    options: Options<UploadOrderRequestCatalogImportFileData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<
        UploadOrderRequestCatalogImportFileResponse,
        UploadOrderRequestCatalogImportFileError,
        ThrowOnError
    >({
        ...formDataBodySerializer,
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/order_request_catalogs/upload_import_file",
        ...options,
        headers: {
            "Content-Type": null,
            ...options?.headers,
        },
    });
};

/**
 * Import Order Request Catalog Items
 * Import the order request catalog items from the import file.
 */
export const importOrderRequestCatalogItems = <ThrowOnError extends boolean = true>(
    options: Options<ImportOrderRequestCatalogItemsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<
        ImportOrderRequestCatalogItemsResponse,
        ImportOrderRequestCatalogItemsError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/order_request_catalogs/import",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Order Request Details Endpoint
 * Get dialog seed for order request details.
 */
export const getOrderRequestDetails = <ThrowOnError extends boolean = true>(
    options?: Options<GetOrderRequestDetailsData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<
        GetOrderRequestDetailsResponse,
        GetOrderRequestDetailsError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/order_requests/details",
        ...options,
    });
};

/**
 * Get Order Request Animal Filter Endpoint
 * Get the filter to redirect to the animal list.
 */
export const getOrderRequestAnimalFilter = <ThrowOnError extends boolean = true>(
    options: Options<GetOrderRequestAnimalFilterData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetOrderRequestAnimalFilterResponse,
        GetOrderRequestAnimalFilterError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/order_requests/animal_filter",
        ...options,
    });
};

/**
 * Create Order Request Endpoint
 * Create a new order request.
 */
export const createOrderRequest = <ThrowOnError extends boolean = true>(
    options: Options<CreateOrderRequestData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, CreateOrderRequestError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/order_requests",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Delete Order Request Endpoint
 * Delete a order request by ID.
 */
export const deleteOrderRequest = <ThrowOnError extends boolean = true>(
    options: Options<DeleteOrderRequestData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, DeleteOrderRequestError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/order_requests/{order_request_id}",
        ...options,
    });
};

/**
 * Update Order Request Endpoint
 * Update a order request by ID.
 */
export const updateOrderRequest = <ThrowOnError extends boolean = true>(
    options: Options<UpdateOrderRequestData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdateOrderRequestError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/order_requests/{order_request_id}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Set Order Request Status Endpoint
 * Set the status for a order request.
 */
export const setOrderRequestStatus = <ThrowOnError extends boolean = true>(
    options: Options<SetOrderRequestStatusData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetOrderRequestStatusError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/order_requests/{order_request_id}/status",
        ...options,
    });
};

/**
 * Get Order Request Animal Export Data Endpoint
 */
export const getOrderRequestAnimalExportData = <ThrowOnError extends boolean = true>(
    options: Options<GetOrderRequestAnimalExportDataData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetOrderRequestAnimalExportDataResponse,
        GetOrderRequestAnimalExportDataError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/order_requests/{order_request_id}/animal_export",
        ...options,
    });
};

/**
 * Post Order Request Animal Export Data Endpoint
 */
export const exportOrderRequestAnimals = <ThrowOnError extends boolean = true>(
    options: Options<ExportOrderRequestAnimalsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, ExportOrderRequestAnimalsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/order_requests/{order_request_id}/animal_export",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Origins For Setting
 * Get the list of origins for setting an origin.
 */
export const getOriginsForSetting = <ThrowOnError extends boolean = true>(
    options?: Options<GetOriginsForSettingData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<
        GetOriginsForSettingResponse,
        GetOriginsForSettingError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/origins/for_setting",
        ...options,
    });
};

/**
 * Delete Origin Endpoint
 * Delete an origin.
 */
export const deleteOrigin = <ThrowOnError extends boolean = true>(options: Options<DeleteOriginData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<unknown, DeleteOriginError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/origins/{origin_id}",
        ...options,
    });
};

/**
 * Get Origin Details Endpoint
 * Get the details of an origin.
 */
export const getOriginDetailsSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetOriginDetailsSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetOriginDetailsSeedResponse, GetOriginDetailsSeedError, ThrowOnError>(
        {
            security: [
                {
                    scheme: "bearer",
                    type: "http",
                },
            ],
            url: "/origins/{origin_id}",
            ...options,
        },
    );
};

/**
 * Update Origin Endpoint
 * Update an origin.
 */
export const updateOrigin = <ThrowOnError extends boolean = true>(options: Options<UpdateOriginData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdateOriginError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/origins/{origin_id}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Create Origin Endpoint
 * Create a new origin.
 */
export const createOrigin = <ThrowOnError extends boolean = true>(options: Options<CreateOriginData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateOriginResponse, CreateOriginError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/origins",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Deactivate Origin Endpoint
 * Deactivate an origin.
 */
export const deactivateOrigin = <ThrowOnError extends boolean = true>(
    options: Options<DeactivateOriginData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, DeactivateOriginError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/origins/{origin_id}/active",
        ...options,
    });
};

/**
 * Activate Origin Endpoint
 * Activate an origin.
 */
export const activateOrigin = <ThrowOnError extends boolean = true>(
    options: Options<ActivateOriginData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, ActivateOriginError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/origins/{origin_id}/active",
        ...options,
    });
};

/**
 * Get Cage Label Printer Preference
 * Check we should offer a list of printers, send to a predefined printer or show the card in the browser.
 */
export const getCageLabelPrinterPreference = <ThrowOnError extends boolean = true>(
    options: Options<GetCageLabelPrinterPreferenceData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetCageLabelPrinterPreferenceResponse,
        GetCageLabelPrinterPreferenceError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/printout/preference",
        ...options,
    });
};

/**
 * Send Cage Label To Printer
 * Send the cage label to the printer.
 */
export const sendCageLabelToPrinter = <ThrowOnError extends boolean = true>(
    options: Options<SendCageLabelToPrinterData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, SendCageLabelToPrinterError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/printout/print",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Delete Procedure Assignment
 * Remove procedure
 */
export const removeProcedureAssignment = <ThrowOnError extends boolean = true>(
    options: Options<RemoveProcedureAssignmentData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, RemoveProcedureAssignmentError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/procedures/assignment",
        ...options,
    });
};

/**
 * Post Procedure Assignment
 * Add procedure
 */
export const addProcedureAssignment = <ThrowOnError extends boolean = true>(
    options: Options<AddProcedureAssignmentData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, AddProcedureAssignmentError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/procedures/assignment",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Update Procedures
 * Change data of multiple procedures at once and roll back on error.
 */
export const updateProcedures = <ThrowOnError extends boolean = true>(
    options: Options<UpdateProceduresData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, UpdateProceduresError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/procedures",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Projects For Setting Endpoint
 * Get the list of projects for setting a project.
 */
export const getProjectsForSetting = <ThrowOnError extends boolean = true>(
    options?: Options<GetProjectsForSettingData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<
        GetProjectsForSettingResponse,
        GetProjectsForSettingError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/projects/for_setting",
        ...options,
    });
};

/**
 * Deactivate Project Endpoint
 * Deactivate a project.
 */
export const deactivateProject = <ThrowOnError extends boolean = true>(
    options: Options<DeactivateProjectData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, DeactivateProjectError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/projects/{project_id}/active",
        ...options,
    });
};

/**
 * Reactivate Project Endpoint
 * (Re)activate a project.
 */
export const activateProject = <ThrowOnError extends boolean = true>(
    options: Options<ActivateProjectData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, ActivateProjectError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/projects/{project_id}/active",
        ...options,
    });
};

/**
 * Delete Project Endpoint
 * Delete a project.
 */
export const deleteProject = <ThrowOnError extends boolean = true>(
    options: Options<DeleteProjectData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, DeleteProjectError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/projects/{project_id}",
        ...options,
    });
};

/**
 * Update Project Endpoint
 * Update an existing project.
 */
export const updateProject = <ThrowOnError extends boolean = true>(
    options: Options<UpdateProjectData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdateProjectError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/projects/{project_id}",
        ...options,
    });
};

/**
 * Update Project Categories Endpoint
 * Update the project categories.
 */
export const updateProjectCategories = <ThrowOnError extends boolean = true>(
    options: Options<UpdateProjectCategoriesData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, UpdateProjectCategoriesError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/projects/categories",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Project Details Endpoint
 * Get project details.
 */
export const getProjectDetails = <ThrowOnError extends boolean = true>(
    options?: Options<GetProjectDetailsData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<GetProjectDetailsResponse2, GetProjectDetailsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/projects/details",
        ...options,
    });
};

/**
 * Add User To Projec Endpont
 * Add a user to a project.
 */
export const addUserToProject = <ThrowOnError extends boolean = true>(
    options: Options<AddUserToProjectData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, AddUserToProjectError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/projects/{project_id}/users",
        ...options,
    });
};

/**
 * Remove User From Project Endpoint
 * Remove a user from a project.
 */
export const removeUserFromProject = <ThrowOnError extends boolean = true>(
    options: Options<RemoveUserFromProjectData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, RemoveUserFromProjectError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/projects/{project_id}/users/{user_id}",
        ...options,
    });
};

/**
 * Create Project Budget Endpoint
 * Create a new project budget.
 */
export const createProjectBudget = <ThrowOnError extends boolean = true>(
    options: Options<CreateProjectBudgetData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<CreateProjectBudgetResponse2, CreateProjectBudgetError, ThrowOnError>(
        {
            security: [
                {
                    scheme: "bearer",
                    type: "http",
                },
            ],
            url: "/projects/budgets",
            ...options,
        },
    );
};

/**
 * Create Project Endpoint
 * Create a new project.
 *
 * :return: New project id.
 */
export const createProject = <ThrowOnError extends boolean = true>(
    options: Options<CreateProjectData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<CreateProjectResponse, CreateProjectError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/projects",
        ...options,
    });
};

/**
 * Get Pup Detail Data Endpoint
 * Get data for pup detail dialog.
 */
export const getPupDetailData = <ThrowOnError extends boolean = true>(
    options: Options<GetPupDetailDataData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetPupDetailDataResponse, GetPupDetailDataError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/pups/{pup_id}/details",
        ...options,
    });
};

/**
 * Get Pup Pedigree Dialog Data Endpoint
 * Get data for pup pedigree dialog.
 */
export const getPupPedigreeDialogData = <ThrowOnError extends boolean = true>(
    options: Options<GetPupPedigreeDialogDataData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetPupPedigreeDialogDataResponse,
        GetPupPedigreeDialogDataError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/pups/{pup_id}/pedigree",
        ...options,
    });
};

/**
 * Get Pup Cohort Id Endpoint
 * Get the cohort id for a pup.
 */
export const getPupCohortId = <ThrowOnError extends boolean = true>(
    options: Options<GetPupCohortIdData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetPupCohortIdResponse, GetPupCohortIdError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/pups/{pup_id}/cohort_id",
        ...options,
    });
};

/**
 * Set Pup Cohort Id Endpoint
 * Set the cohort id for a pup.
 */
export const setPupCohortId = <ThrowOnError extends boolean = true>(
    options: Options<SetPupCohortIdData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetPupCohortIdError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/pups/{pup_id}/cohort_id",
        ...options,
    });
};

/**
 * Get Pup Eartag Endpoint
 * Get eartag for a pup.
 */
export const getPupEartag = <ThrowOnError extends boolean = true>(options: Options<GetPupEartagData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetPupEartagResponse, GetPupEartagError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/pups/{pup_id}/eartag",
        ...options,
    });
};

/**
 * Set Pup Eartag Endpoint
 * Set eartag for a pup.
 */
export const setPupEartag = <ThrowOnError extends boolean = true>(options: Options<SetPupEartagData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<unknown, SetPupEartagError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/pups/{pup_id}/eartag",
        ...options,
    });
};

/**
 * Get Pup Generation Endpoint
 * Get generation for a pup.
 */
export const getPupGeneration = <ThrowOnError extends boolean = true>(
    options: Options<GetPupGenerationData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetPupGenerationResponse, GetPupGenerationError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/pups/{pup_id}/generation",
        ...options,
    });
};

/**
 * Set Pup Generation Endpoint
 * Set generation for a pup.
 */
export const setPupGeneration = <ThrowOnError extends boolean = true>(
    options: Options<SetPupGenerationData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetPupGenerationError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/pups/{pup_id}/generation",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Pup Genetic Background Endpoint
 * Get genetic background for a pup.
 */
export const getPupGeneticBackground = <ThrowOnError extends boolean = true>(
    options: Options<GetPupGeneticBackgroundData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetPupGeneticBackgroundResponse,
        GetPupGeneticBackgroundError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/pups/{pup_id}/genetic_background",
        ...options,
    });
};

/**
 * Set Pup Genetic Background Endpoint
 * Set genetic background for a pup.
 */
export const setPupGeneticBackground = <ThrowOnError extends boolean = true>(
    options: Options<SetPupGeneticBackgroundData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetPupGeneticBackgroundError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/pups/{pup_id}/genetic_background",
        ...options,
    });
};

/**
 * Remove Pup Projects Endpoint
 * Remove projects from a pup
 */
export const removePupProjects = <ThrowOnError extends boolean = true>(
    options: Options<RemovePupProjectsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, RemovePupProjectsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/pups/{pup_id}/projects",
        ...options,
    });
};

/**
 * Get Pup Projects Endpoint
 * Get all projects assigned to a pup
 */
export const getPupProjects = <ThrowOnError extends boolean = true>(
    options: Options<GetPupProjectsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetPupProjectsResponse, GetPupProjectsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/pups/{pup_id}/projects",
        ...options,
    });
};

/**
 * Add Pup Projects Endpoint
 * Assign projects to a pup
 */
export const addPupProjects = <ThrowOnError extends boolean = true>(
    options: Options<AddPupProjectsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, AddPupProjectsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/pups/{pup_id}/projects",
        ...options,
    });
};

/**
 * Get Pup Incompatible Sanitary Status Locations Endpoint
 * Get incompatible sanitary status locations for pups based on given new cage or rack id.
 */
export const getPupIncompatibleSanitaryStatusLocations = <ThrowOnError extends boolean = true>(
    options: Options<GetPupIncompatibleSanitaryStatusLocationsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetPupIncompatibleSanitaryStatusLocationsResponse,
        GetPupIncompatibleSanitaryStatusLocationsError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/pups/incompatible_sanitary_status_locations",
        ...options,
    });
};

/**
 * Get Pup Lab Id Endpoint
 * Get lab id for a pup.
 */
export const getPupLabId = <ThrowOnError extends boolean = true>(options: Options<GetPupLabIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetPupLabIdResponse, GetPupLabIdError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/pups/{pup_id}/lab_id",
        ...options,
    });
};

/**
 * Set Pup Lab Id Endpoint
 * Set lab id for a pup.
 */
export const setPupLabId = <ThrowOnError extends boolean = true>(options: Options<SetPupLabIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<unknown, SetPupLabIdError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/pups/{pup_id}/lab_id",
        ...options,
    });
};

/**
 * Get Pup Medical Condition Dialog Seed Endpoint
 * Get details for the pup SetMedicalConditions-Dialog.
 */
export const getPupMedicalConditionDialogSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetPupMedicalConditionDialogSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetPupMedicalConditionDialogSeedResponse,
        GetPupMedicalConditionDialogSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/pups/{pup_id}/medical_condition_dialog",
        ...options,
    });
};

/**
 * Set Pup Medical Conditions Endpoint
 * Set medical conditions for a pup.
 */
export const setPupMedicalConditions = <ThrowOnError extends boolean = true>(
    options: Options<SetPupMedicalConditionsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetPupMedicalConditionsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/pups/{pup_id}/medical_conditions",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Pup Mutation Dialog Seed Endpoint
 * Get details for the pup SetMutation-Dialog.
 */
export const getPupMutationDialogSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetPupMutationDialogSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetPupMutationDialogSeedResponse,
        GetPupMutationDialogSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/pups/{pup_id}/mutation_dialog",
        ...options,
    });
};

/**
 * Set Pup Mutations Endpoint
 * Set mutations for a pup.
 */
export const setPupMutations = <ThrowOnError extends boolean = true>(
    options: Options<SetPupMutationsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetPupMutationsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/pups/{pup_id}/mutations",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Pup Owner Dialog Seed Endpoint
 * Get details for the pup SetOwner-Dialog.
 */
export const getPupOwnerDialogSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetPupOwnerDialogSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetPupOwnerDialogSeedResponse,
        GetPupOwnerDialogSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/pups/{pup_id}/owner_dialog",
        ...options,
    });
};

/**
 * Set Pup Owner Endpoint
 * Set owner for a pup.
 */
export const setPupOwner = <ThrowOnError extends boolean = true>(options: Options<SetPupOwnerData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<unknown, SetPupOwnerError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/pups/{pup_id}/owner",
        ...options,
    });
};

/**
 * Get Pup Responsible Dialog Seed Endpoint
 * Get details for the pup SetResponsible-Dialog.
 */
export const getPupResponsibleDialogSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetPupResponsibleDialogSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetPupResponsibleDialogSeedResponse,
        GetPupResponsibleDialogSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/pups/{pup_id}/responsible_dialog",
        ...options,
    });
};

/**
 * Set Pup Responsible Endpoint
 * Set responsible for a pup.
 */
export const setPupResponsible = <ThrowOnError extends boolean = true>(
    options: Options<SetPupResponsibleData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetPupResponsibleError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/pups/{pup_id}/responsible",
        ...options,
    });
};

/**
 * Get Pup Sex Move Sacrifice Dialog Seed Endpoint
 * Get details for the pup SetSexMoveSacrifice-Dialog.
 */
export const getPupSexMoveSacrificeDialogSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetPupSexMoveSacrificeDialogSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetPupSexMoveSacrificeDialogSeedResponse,
        GetPupSexMoveSacrificeDialogSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/pups/{pup_id}/sex_move_sacrifice_dialog",
        ...options,
    });
};

/**
 * Note Pup In Action Log Endpoint
 * Add note for a pup to action log.
 */
export const notePupInActionLog = <ThrowOnError extends boolean = true>(
    options: Options<NotePupInActionLogData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, NotePupInActionLogError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/pups/{pup_id}/note_in_action_log",
        ...options,
    });
};

/**
 * Resurrect Pup Endpoint
 * Resurrect a pup.
 */
export const resurrectPup = <ThrowOnError extends boolean = true>(options: Options<ResurrectPupData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<unknown, ResurrectPupError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/pups/{pup_id}/resurrect",
        ...options,
    });
};

/**
 * Sacrifice Pup Endpoint
 * Sacrifice a pup.
 */
export const sacrificePup = <ThrowOnError extends boolean = true>(options: Options<SacrificePupData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<unknown, SacrificePupError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/pups/{pup_id}/sacrifice",
        ...options,
    });
};

/**
 * Update Pup Birth Date Endpoint
 * Update birthdate for a pup.
 */
export const updatePupBirthDate = <ThrowOnError extends boolean = true>(
    options: Options<UpdatePupBirthDateData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdatePupBirthDateError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/pups/{pup_id}/birth_date",
        ...options,
    });
};

/**
 * Update Pup Sacrifice Date Endpoint
 * Update sacrifice date for a pup.
 */
export const updatePupSacrificeDate = <ThrowOnError extends boolean = true>(
    options: Options<UpdatePupSacrificeDateData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdatePupSacrificeDateError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/pups/{pup_id}/sacrifice_date",
        ...options,
    });
};

/**
 * Set Pup Sex Endpoint
 * Set sex of a pup.
 */
export const setPupSex = <ThrowOnError extends boolean = true>(options: Options<SetPupSexData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<unknown, SetPupSexError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/pups/{pup_id}/sex",
        ...options,
    });
};

/**
 * Get Pup Species Dialog Seed Endpoint
 * Get details for the pup SetSpecies-Dialog.
 */
export const getPupSpeciesDialogSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetPupSpeciesDialogSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetPupSpeciesDialogSeedResponse,
        GetPupSpeciesDialogSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/pups/{pup_id}/species_dialog",
        ...options,
    });
};

/**
 * Set Pup Species Endpoint
 * Set species for pup.
 */
export const setPupSpecies = <ThrowOnError extends boolean = true>(
    options: Options<SetPupSpeciesData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetPupSpeciesError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/pups/{pup_id}/species",
        ...options,
    });
};

/**
 * Get Pup Strain Dialog Seed Endpoint
 * Get details for the pup SetStrain-Dialog.
 */
export const getPupStrainDialogSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetPupStrainDialogSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetPupStrainDialogSeedResponse,
        GetPupStrainDialogSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/pups/{pup_id}/strain_dialog",
        ...options,
    });
};

/**
 * Set Pup Strain Endpoint
 * Set strain for pup.
 */
export const setPupStrain = <ThrowOnError extends boolean = true>(options: Options<SetPupStrainData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<unknown, SetPupStrainError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/pups/{pup_id}/strain",
        ...options,
    });
};

/**
 * Get Pup Weight Dialog Seed Endpoint
 * Get details for the pup setWeight-Dialog.
 */
export const getPupWeightDialogSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetPupWeightDialogSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetPupWeightDialogSeedResponse,
        GetPupWeightDialogSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/pups/{pup_id}/weight_dialog_seed",
        ...options,
    });
};

/**
 * Set Pup Weight Endpoint
 * Set weight for pup.
 */
export const addPupWeight = <ThrowOnError extends boolean = true>(options: Options<AddPupWeightData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, AddPupWeightError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/pups/{pup_id}/weight",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Unset Pup Reference Weight Endpoint
 * Unset reference weight for pup.
 */
export const unsetPupReferenceWeight = <ThrowOnError extends boolean = true>(
    options: Options<UnsetPupReferenceWeightData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, UnsetPupReferenceWeightError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/pups/{pup_id}/reference-weight",
        ...options,
    });
};

/**
 * Delete Pup Weight Endpoint
 * Delete weight for pup.
 */
export const deletePupWeight = <ThrowOnError extends boolean = true>(
    options: Options<DeletePupWeightData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, DeletePupWeightError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/pups/{pup_id}/weight/{weight_id}",
        ...options,
    });
};

/**
 * Get Breeding Performance Details
 * Get data for breeding performance details dialog.
 */
export const getBreedingPerformanceDetails = <ThrowOnError extends boolean = true>(
    options: Options<GetBreedingPerformanceDetailsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetBreedingPerformanceDetailsResponse,
        GetBreedingPerformanceDetailsError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/reports/breeding_performance_details",
        ...options,
    });
};

/**
 * Get Colony Pedigree
 * Get colony pedigree.
 */
export const getColonyPedigree = <ThrowOnError extends boolean = true>(
    options: Options<GetColonyPedigreeData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetColonyPedigreeResponse, GetColonyPedigreeError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/reports/colony_pedigree",
        ...options,
    });
};

/**
 * Update Sacrifice Methods
 * Update the sacrifice methods.
 */
export const updateSacrificeMethods = <ThrowOnError extends boolean = true>(
    options: Options<UpdateSacrificeMethodsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, UpdateSacrificeMethodsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/sacrifice_methods",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Update Sacrifice Reasons
 * Change data of multiple sacrifice reasons at once and roll back on error.
 */
export const updateSacrificeReasons = <ThrowOnError extends boolean = true>(
    options: Options<UpdateSacrificeReasonsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, UpdateSacrificeReasonsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/sacrifice_reasons",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Report Details Endpoint
 * Returns details of a scheduled report
 */
export const getReportDetails = <ThrowOnError extends boolean = true>(
    options: Options<GetReportDetailsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetReportDetailsResponse, GetReportDetailsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/scheduled_reports/report/{report_id}",
        ...options,
    });
};

/**
 * Delete Report Endpoint
 * Delete a scheduled report
 */
export const deleteReport = <ThrowOnError extends boolean = true>(options: Options<DeleteReportData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DeleteReportResponse, DeleteReportError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/scheduled_reports/report/{report_id}",
        ...options,
    });
};

/**
 * Update Report Endpoint
 * Update a scheduled report
 */
export const updateReport = <ThrowOnError extends boolean = true>(options: Options<UpdateReportData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateReportResponse, UpdateReportError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/scheduled_reports/report/{report_id}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Available Reports Endpoint
 * Returns a list of available reports
 */
export const getAvailableReports = <ThrowOnError extends boolean = true>(
    options?: Options<GetAvailableReportsData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<GetAvailableReportsResponse, GetAvailableReportsError, ThrowOnError>({
        url: "/scheduled_reports/available_reports",
        ...options,
    });
};

/**
 * Get Available Repetitions Endpoint
 * Returns a list of available repetitions
 */
export const getAvailableRepetitions = <ThrowOnError extends boolean = true>(
    options?: Options<GetAvailableRepetitionsData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<
        GetAvailableRepetitionsResponse,
        GetAvailableRepetitionsError,
        ThrowOnError
    >({
        url: "/scheduled_reports/available_repetitions",
        ...options,
    });
};

/**
 * Post Report Endpoint
 * Schedule a report
 */
export const scheduleReport = <ThrowOnError extends boolean = true>(
    options: Options<ScheduleReportData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<ScheduleReportResponse, ScheduleReportError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/scheduled_reports/report",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Service Details Endpoint
 * Get dialog seed for service details
 */
export const getServiceDetails = <ThrowOnError extends boolean = true>(
    options?: Options<GetServiceDetailsData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<GetServiceDetailsResponse, GetServiceDetailsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/services/details",
        ...options,
    });
};

/**
 * Create Service Endpoint
 * Create a new service.
 */
export const createService = <ThrowOnError extends boolean = true>(
    options: Options<CreateServiceData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<CreateServiceResponse, CreateServiceError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/services",
        ...options,
    });
};

/**
 * Delete Service Endpoint
 * Delete a service.
 */
export const deleteService = <ThrowOnError extends boolean = true>(
    options: Options<DeleteServiceData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, DeleteServiceError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/services/{service_id}",
        ...options,
    });
};

/**
 * Update Service Endpoint
 * Update a service.
 */
export const updateService = <ThrowOnError extends boolean = true>(
    options: Options<UpdateServiceData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdateServiceError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/services/{service_id}",
        ...options,
    });
};

/**
 * Deactivate Service Endpoint
 * Deactivate a service.
 */
export const deactivateService = <ThrowOnError extends boolean = true>(
    options: Options<DeactivateServiceData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, DeactivateServiceError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/services/{service_id}/inactive",
        ...options,
    });
};

/**
 * Activate Service Endpoint
 * Activate a service.
 */
export const activateService = <ThrowOnError extends boolean = true>(
    options: Options<ActivateServiceData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, ActivateServiceError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/services/{service_id}/active",
        ...options,
    });
};

/**
 * Update Service Categories
 * Update the work request statuses.
 */
export const updateServiceCategories = <ThrowOnError extends boolean = true>(
    options: Options<UpdateServiceCategoriesData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, UpdateServiceCategoriesError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/service_categories",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Service Request Details Endpoint
 * Get dialog seed for service request details.
 */
export const getServiceRequestDetails = <ThrowOnError extends boolean = true>(
    options?: Options<GetServiceRequestDetailsData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<
        GetServiceRequestDetailsResponse,
        GetServiceRequestDetailsError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/service_requests/details",
        ...options,
    });
};

/**
 * Get Service Request Licenses For Setting Endpoint
 * Get the list of available licenses for the given due date and owner.
 *
 * If service_request_id is given, include the current license of the service request.
 */
export const getServiceRequestLicensesForSetting = <ThrowOnError extends boolean = true>(
    options: Options<GetServiceRequestLicensesForSettingData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetServiceRequestLicensesForSettingResponse,
        GetServiceRequestLicensesForSettingError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/service_requests/licenses/for_setting",
        ...options,
    });
};

/**
 * Create Service Request Endpoint
 * Create a new service request.
 */
export const createServiceRequest = <ThrowOnError extends boolean = true>(
    options: Options<CreateServiceRequestData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, CreateServiceRequestError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/service_requests",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Update Service Request Endpoint
 * Update a service request by ID.
 */
export const updateServiceRequest = <ThrowOnError extends boolean = true>(
    options: Options<UpdateServiceRequestData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdateServiceRequestError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/service_requests/{service_request_id}",
        ...options,
    });
};

/**
 * Set Service Request Status Endpoint
 * Set the status for a service request.
 */
export const setServiceRequestStatus = <ThrowOnError extends boolean = true>(
    options: Options<SetServiceRequestStatusData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetServiceRequestStatusError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/service_requests/{service_request_id}/status",
        ...options,
    });
};

/**
 * Get Session Time
 * Get the time left until the session ends.
 */
export const getSessionTime = <ThrowOnError extends boolean = true>(
    options?: Options<GetSessionTimeData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<GetSessionTimeResponse, GetSessionTimeError, ThrowOnError>({
        url: "/session/session_time",
        ...options,
    });
};

/**
 * Reactivate Session
 * Try to resurrect the session (re-open an expired session by giving the credentials).
 */
export const reactivateSession = <ThrowOnError extends boolean = true>(
    options: Options<ReactivateSessionData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<ReactivateSessionResponse, ReactivateSessionError, ThrowOnError>({
        url: "/session/reactivate_session",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Post Re Authenticate Endpoint
 * Re-authenticate the user as confirmation for a critical action.
 */
export const reAuthenticate = <ThrowOnError extends boolean = true>(
    options: Options<ReAuthenticateData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<ReAuthenticateResponse, ReAuthenticateError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/session/re_authenticate",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get User Aliases
 * Get the aliases of the user.
 */
export const getAliases = <ThrowOnError extends boolean = true>(options?: Options<GetAliasesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetAliasesResponse, GetAliasesError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/session/aliases",
        ...options,
    });
};

/**
 * Update Clinical Signs
 * Change data of multiple clinical signs at once and roll back on error.
 */
export const updateClinicalSigns = <ThrowOnError extends boolean = true>(
    options: Options<UpdateClinicalSignsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, UpdateClinicalSignsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/clinicalsigns",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Update Clinical Sign Categories
 * Change data of multiple clinical sign categories at once and roll back on error.
 */
export const updateClinicalSignCategories = <ThrowOnError extends boolean = true>(
    options: Options<UpdateClinicalSignCategoriesData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, UpdateClinicalSignCategoriesError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/clinicalsigns/categories",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Template Details Endpoint
 * Get details for a template
 */
export const getSeverityAssessmentTemplateDetails = <ThrowOnError extends boolean = true>(
    options?: Options<GetSeverityAssessmentTemplateDetailsData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<
        GetSeverityAssessmentTemplateDetailsResponse,
        GetSeverityAssessmentTemplateDetailsError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/severity_assessment/template/details",
        ...options,
    });
};

/**
 * Create Template Endpoint
 * Create a new template
 */
export const createSeverityAssessmentTemplate = <ThrowOnError extends boolean = true>(
    options: Options<CreateSeverityAssessmentTemplateData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<
        CreateSeverityAssessmentTemplateResponse,
        CreateSeverityAssessmentTemplateError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/severity_assessment/template",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Update Template Endpoint
 * Update an existing template
 */
export const updateSeverityAssessmentTemplate = <ThrowOnError extends boolean = true>(
    options: Options<UpdateSeverityAssessmentTemplateData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdateSeverityAssessmentTemplateError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/severity_assessment/template/{template_id}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get New Assessment Sheet Endpoint
 */
export const getNewAssessmentSheet = <ThrowOnError extends boolean = true>(
    options: Options<GetNewAssessmentSheetData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetNewAssessmentSheetResponse,
        GetNewAssessmentSheetError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/severity_assessment/sheets",
        ...options,
    });
};

/**
 * Add Assessment Sheet Endpoint
 * Create a new assessment sheet.
 */
export const addAssessmentSheet = <ThrowOnError extends boolean = true>(
    options: Options<AddAssessmentSheetData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<AddAssessmentSheetResponse, AddAssessmentSheetError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/severity_assessment/sheets",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Delete Assessment Sheet Endpoint
 * Delete an assessment drug by ID.
 */
export const deleteAssessmentSheet = <ThrowOnError extends boolean = true>(
    options: Options<DeleteAssessmentSheetData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, DeleteAssessmentSheetError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/severity_assessment/sheets/{scoresheet_id}",
        ...options,
    });
};

/**
 * Get Existing Assessment Sheet Endpoint
 */
export const getExistingAssessmentSheet = <ThrowOnError extends boolean = true>(
    options: Options<GetExistingAssessmentSheetData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetExistingAssessmentSheetResponse,
        GetExistingAssessmentSheetError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/severity_assessment/sheets/{scoresheet_id}",
        ...options,
    });
};

/**
 * Update Assessment Sheet Endpoint
 */
export const updateAssessmentSheet = <ThrowOnError extends boolean = true>(
    options: Options<UpdateAssessmentSheetData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, UpdateAssessmentSheetError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/severity_assessment/sheets/{scoresheet_id}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Severity Level Details Endpoint
 * Get details for a severity level
 */
export const getSeverityLevelDetails = <ThrowOnError extends boolean = true>(
    options?: Options<GetSeverityLevelDetailsData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<
        GetSeverityLevelDetailsResponse,
        GetSeverityLevelDetailsError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/severity_levels/details",
        ...options,
    });
};

/**
 * Get Severity Levels
 * Get the list of severity levels to select for assignment.
 */
export const getSeverityLevelOptions = <ThrowOnError extends boolean = true>(
    options?: Options<GetSeverityLevelOptionsData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<
        GetSeverityLevelOptionsResponse,
        GetSeverityLevelOptionsError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/severity_levels",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Create Severity Level Endpoint
 * Create a new severity level
 */
export const createSeverityLevel = <ThrowOnError extends boolean = true>(
    options: Options<CreateSeverityLevelData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<CreateSeverityLevelResponse, CreateSeverityLevelError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/severity_levels",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Delete Severity Level Endpoint
 * Delete an existing severity level
 */
export const deleteSeverityLevel = <ThrowOnError extends boolean = true>(
    options: Options<DeleteSeverityLevelData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, DeleteSeverityLevelError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/severity_levels/{severity_level_id}",
        ...options,
    });
};

/**
 * Update Severity Level Endpoint
 * Update an existing severity level
 */
export const updateSeverityLevel = <ThrowOnError extends boolean = true>(
    options: Options<UpdateSeverityLevelData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdateSeverityLevelError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/severity_levels/{severity_level_id}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Species Dialog Seed
 */
export const getSpeciesDialogSeed = <ThrowOnError extends boolean = true>(
    options?: Options<GetSpeciesDialogSeedData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<
        GetSpeciesDialogSeedResponse,
        GetSpeciesDialogSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/species/dialog",
        ...options,
    });
};

/**
 * Delete Species Endpoint
 * Delete a species.
 */
export const deleteSpecies = <ThrowOnError extends boolean = true>(
    options: Options<DeleteSpeciesData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<DeleteSpeciesResponse, DeleteSpeciesError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/species/{species_id}",
        ...options,
    });
};

/**
 * Get Species Details Endpoint
 */
export const getSpeciesDetails = <ThrowOnError extends boolean = true>(
    options: Options<GetSpeciesDetailsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetSpeciesDetailsResponse, GetSpeciesDetailsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/species/{species_id}",
        ...options,
    });
};

/**
 * Update Species Endpoint
 * Update a species.
 */
export const updateSpecies = <ThrowOnError extends boolean = true>(
    options: Options<UpdateSpeciesData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, UpdateSpeciesError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/species/{species_id}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Create Species Endpoint
 * Create a new species.
 */
export const createSpecies = <ThrowOnError extends boolean = true>(
    options: Options<CreateSpeciesData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<CreateSpeciesResponse, CreateSpeciesError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/species",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Sperm Details
 * Get sperm details.
 */
export const getSpermDetails = <ThrowOnError extends boolean = true>(
    options: Options<GetSpermDetailsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetSpermDetailsResponse, GetSpermDetailsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/sperm/{sperm_id}/details",
        ...options,
    });
};

/**
 * Get Sperm History
 * Get sperm history.
 */
export const getSpermHistory = <ThrowOnError extends boolean = true>(
    options: Options<GetSpermHistoryData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetSpermHistoryResponse, GetSpermHistoryError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/sperm/{sperm_id}/history",
        ...options,
    });
};

/**
 * Get Sperm Qualities
 * Get sperm quality options.
 */
export const getSpermQualitiesForSetting = <ThrowOnError extends boolean = true>(
    options?: Options<GetSpermQualitiesForSettingData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<
        GetSpermQualitiesForSettingResponse,
        GetSpermQualitiesForSettingError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/sperm/qualities/for_setting",
        ...options,
    });
};

/**
 * Get Next Free Straw Labels
 * Get next free straw labels for cryopreserved sperm.
 */
export const getNextFreeSpermStrawLabels = <ThrowOnError extends boolean = true>(
    options: Options<GetNextFreeSpermStrawLabelsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetNextFreeSpermStrawLabelsResponse,
        GetNextFreeSpermStrawLabelsError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/sperm/straw_labels/for_setting",
        ...options,
    });
};

/**
 * Get Oocyte Donors By Strain
 * Get female animals of a certain strain for selection as oocyte donors.
 */
export const getOocyteDonorsByStrainForSetting = <ThrowOnError extends boolean = true>(
    options: Options<GetOocyteDonorsByStrainForSettingData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetOocyteDonorsByStrainForSettingResponse,
        GetOocyteDonorsByStrainForSettingError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/sperm/oocyte_donors_by_strain/{strain_id}/for_setting",
        ...options,
    });
};

/**
 * Import Sperm
 * Import sperm.
 */
export const importSperm = <ThrowOnError extends boolean = true>(options: Options<ImportSpermData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ImportSpermResponse, ImportSpermError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/sperm/import",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Quickselect Seed
 * Get seed for sperm Quickselect.
 */
export const getSpermQuickselectSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetSpermQuickselectSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<
        GetSpermQuickselectSeedResponse,
        GetSpermQuickselectSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/sperm/quickselect/seed",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Apply Quickselect
 * Apply Quickselect actions to selected sperm IDs.
 */
export const applySpermQuickselectActions = <ThrowOnError extends boolean = true>(
    options: Options<ApplySpermQuickselectActionsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<
        ApplySpermQuickselectActionsResponse,
        ApplySpermQuickselectActionsError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/sperm/quickselect/apply",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * List Strain Options
 */
export const getStrainsForSetting = <ThrowOnError extends boolean = true>(
    options?: Options<GetStrainsForSettingData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<
        GetStrainsForSettingResponse,
        GetStrainsForSettingError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/strains/for_setting",
        ...options,
    });
};

/**
 * List Strain Options
 */
export const getStrainsForFilter = <ThrowOnError extends boolean = true>(
    options?: Options<GetStrainsForFilterData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<GetStrainsForFilterResponse, GetStrainsForFilterError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/strains/for_filter",
        ...options,
    });
};

/**
 * Unblock Strain
 * Unblock a strain.
 */
export const unblockStrain = <ThrowOnError extends boolean = true>(
    options: Options<UnblockStrainData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, UnblockStrainError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/strains/{strain_id}/block",
        ...options,
    });
};

/**
 * Get Strain Block Details
 * Get details for blocking a strain.
 */
export const getStrainBlockDetails = <ThrowOnError extends boolean = true>(
    options: Options<GetStrainBlockDetailsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetStrainBlockDetailsResponse,
        GetStrainBlockDetailsError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/strains/{strain_id}/block",
        ...options,
    });
};

/**
 * Block Strain
 * Block a strain.
 */
export const blockStrain = <ThrowOnError extends boolean = true>(options: Options<BlockStrainData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<unknown, BlockStrainError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/strains/{strain_id}/block",
        ...options,
    });
};

/**
 * Get Strains By Sex For Owners
 * Get strains for filter depending on the selected owner
 *
 * Send result as JSON response to client (a dict containing the strains divided by sex).
 *
 * :param owner_ids: '__all_for_alias__' to get strains of all aliases of the user's alias;
 * or ID(s) of scientist strains shall be fetched for
 * or Empty to get strains of all the user's aliases
 */
export const getStrainsBySexForOwners = <ThrowOnError extends boolean = true>(
    options?: Options<GetStrainsBySexForOwnersData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<
        GetStrainsBySexForOwnersResponse,
        GetStrainsBySexForOwnersError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/strains/strains_by_sex_for_owners",
        ...options,
    });
};

/**
 * Get Strains By Usage For Owners Endpoint
 * Get strains for filter depending on the selected owner
 *
 * :param owner_ids: ['__all_for_alias__'] to get strains of all aliases of the user's alias;
 * or ID(s) of scientist strains shall be fetched for ('__all_for_alias__' might be included);
 * or None to get strains of all the user's aliases.
 *
 * :param subjects: Subjects to aggregate usage for.
 * Possible values are any combination of:
 * - 'animal'
 * - 'pup'
 * - 'tank'
 * If omitted, defaults to ['animal', 'pup', 'tank'].
 *
 * :param usage: OR-list of usage values over aggregated cached strain usage.
 * Allowed values: live, dead, unused.
 * If omitted, defaults to ['live', 'dead'].
 * `unused` entries are returned in group "active".
 */
export const getStrainsByUsageForOwners = <ThrowOnError extends boolean = true>(
    options?: Options<GetStrainsByUsageForOwnersData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<
        GetStrainsByUsageForOwnersResponse,
        GetStrainsByUsageForOwnersError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/strains/strains_by_usage_for_owners",
        ...options,
    });
};

/**
 * Get Strain Ids By Name
 * Get strain IDs from strain names with placeholders
 *
 * This is a post request, because the list of possible strain IDs
 * might be too long to be sent as a query parameter.
 *
 * :param strain_names: Strain names with placeholders.
 *
 * :param possible_strain_ids: All strain IDs that are possible for the
 * owner currently selected in the filter; the result will only IDs
 * that are included here; this is to not reveal strain information
 * that the user is not allowed to see.
 */
export const getStrainIdsByName = <ThrowOnError extends boolean = true>(
    options: Options<GetStrainIdsByNameData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<GetStrainIdsByNameResponse, GetStrainIdsByNameError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/strains/strain_ids_by_name",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Update Strain Database Fields Endpoint
 */
export const updateStrainDatabaseFields = <ThrowOnError extends boolean = true>(
    options: Options<UpdateStrainDatabaseFieldsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, UpdateStrainDatabaseFieldsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/strains/strain_database_fields",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Strain Database Field Values Endpoint
 */
export const getStrainDatabaseFieldValues = <ThrowOnError extends boolean = true>(
    options: Options<GetStrainDatabaseFieldValuesData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetStrainDatabaseFieldValuesResponse,
        GetStrainDatabaseFieldValuesError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/strains/strain_database_fields/{field_id}/values",
        ...options,
    });
};

/**
 * Update Strain Database Field Values Endpoint
 */
export const updateStrainDatabaseFieldValues = <ThrowOnError extends boolean = true>(
    options: Options<UpdateStrainDatabaseFieldValuesData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, UpdateStrainDatabaseFieldValuesError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/strains/strain_database_fields/{field_id}/values",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get New Strain Details Endpoint
 * Get strain detail dialog seed
 */
export const getNewStrainDialogSeed = <ThrowOnError extends boolean = true>(
    options?: Options<GetNewStrainDialogSeedData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<
        GetNewStrainDialogSeedResponse,
        GetNewStrainDialogSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/strains/new",
        ...options,
    });
};

/**
 * Create Strain Endpoint
 * Update strain
 */
export const createStrain = <ThrowOnError extends boolean = true>(options: Options<CreateStrainData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateStrainResponse, CreateStrainError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/strains/new",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Existing Strain Details Endpoint
 * Get strain detail dialog seed
 */
export const getStrainDialogSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetStrainDialogSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetStrainDialogSeedResponse, GetStrainDialogSeedError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/strains/{strain_id}",
        ...options,
    });
};

/**
 * Update Strain Endpoint
 * Update strain
 */
export const updateStrain = <ThrowOnError extends boolean = true>(options: Options<UpdateStrainData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdateStrainError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/strains/{strain_id}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Strain Database Values Endpoint
 */
export const getStrainDatabaseValues = <ThrowOnError extends boolean = true>(
    options: Options<GetStrainDatabaseValuesData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetStrainDatabaseValuesResponse,
        GetStrainDatabaseValuesError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/strains/{strain_id}/strain_database_values",
        ...options,
    });
};

/**
 * Get Version
 * Get the current PyRAT version.
 */
export const getVersion = <ThrowOnError extends boolean = true>(options?: Options<GetVersionData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetVersionResponse, GetVersionError, ThrowOnError>({
        url: "/system/version",
        ...options,
    });
};

/**
 * Post Exception
 * Write an exception to the server.
 */
export const writeException = <ThrowOnError extends boolean = true>(
    options: Options<WriteExceptionData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, WriteExceptionError, ThrowOnError>({
        url: "/system/exception",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Create Status Record
 * Create status record.
 */
export const createSystemStatusRecord = <ThrowOnError extends boolean = true>(
    options?: Options<CreateSystemStatusRecordData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).post<unknown, CreateSystemStatusRecordError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/system_status/record",
        ...options,
    });
};

/**
 * Save Status Administration Settings
 * Save status administration settings.
 */
export const saveSystemStatusSettings = <ThrowOnError extends boolean = true>(
    options: Options<SaveSystemStatusSettingsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, SaveSystemStatusSettingsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/system_status/settings",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Is Position Occupied
 * Check if given positions of a tank are occupied.
 *
 * Returns the set of positions that are already occupied.
 */
export const isPositionOccupied = <ThrowOnError extends boolean = true>(
    options: Options<IsPositionOccupiedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<IsPositionOccupiedResponse, IsPositionOccupiedError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/tanks/is_position_occupied",
        ...options,
    });
};

/**
 * Get Quickselect
 */
export const getTankQuickselectActionsSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetTankQuickselectActionsSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<
        GetTankQuickselectActionsSeedResponse,
        GetTankQuickselectActionsSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/tanks/quickselect:get_actions_seed",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Post Quickselect
 */
export const executeTankQuickselectActions = <ThrowOnError extends boolean = true>(
    options: Options<ExecuteTankQuickselectActionsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<
        ExecuteTankQuickselectActionsResponse,
        ExecuteTankQuickselectActionsError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/tanks/quickselect:execute_actions",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Tank Details Endpoint
 * Get tank details.
 */
export const getTankDetails = <ThrowOnError extends boolean = true>(
    options: Options<GetTankDetailsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetTankDetailsResponse, GetTankDetailsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/tanks/{tank_id}/details",
        ...options,
    });
};

/**
 * Get Age Levels Endpoint
 * Get age levels.
 */
export const getAgeLevels = <ThrowOnError extends boolean = true>(
    options?: Options<GetAgeLevelsData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<GetAgeLevelsResponse, GetAgeLevelsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/tanks/age_levels",
        ...options,
    });
};

/**
 * Update Age Level Endpoint
 * Update tank age level.
 */
export const updateAgeLevel = <ThrowOnError extends boolean = true>(
    options: Options<UpdateAgeLevelData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdateAgeLevelError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/tanks/{tank_id}/update_age_level",
        ...options,
    });
};

/**
 * Get Tank Medical Condition Dialog Seed Endpoint
 * Get details for the tank SetMedicalConditions-Dialog.
 */
export const getTankMedicalConditionDialogSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetTankMedicalConditionDialogSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetTankMedicalConditionDialogSeedResponse,
        GetTankMedicalConditionDialogSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/tanks/{tank_id}/medical_condition_dialog",
        ...options,
    });
};

/**
 * Set Tank Medical Conditions Endpoint
 * Set medical conditions for a tank.
 */
export const setTankMedicalConditions = <ThrowOnError extends boolean = true>(
    options: Options<SetTankMedicalConditionsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetTankMedicalConditionsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/tanks/{tank_id}/medical_conditions",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Crossing Detail Data Endpoint
 * Get crossing detail data.
 */
export const getCrossingDetailData = <ThrowOnError extends boolean = true>(
    options: Options<GetCrossingDetailDataData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetCrossingDetailDataResponse,
        GetCrossingDetailDataError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/tanks/crossings/{crossing_id}/details",
        ...options,
    });
};

/**
 * Delete Crossing Endpoint
 * Delete crossing.
 */
export const deleteCrossing = <ThrowOnError extends boolean = true>(
    options: Options<DeleteCrossingData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, DeleteCrossingError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/tanks/crossings/{crossing_id}",
        ...options,
    });
};

/**
 * Complete Crossing Endpoint
 * Complete crossing for given id.
 */
export const completeCrossing = <ThrowOnError extends boolean = true>(
    options: Options<CompleteCrossingData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, CompleteCrossingError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/tanks/crossings/{crossing_id}:complete",
        ...options,
    });
};

/**
 * Keep Crossing Endpoint
 * Keep crossing.
 */
export const keepCrossing = <ThrowOnError extends boolean = true>(options: Options<KeepCrossingData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<unknown, KeepCrossingError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/tanks/crossings/{crossing_id}:discarded",
        ...options,
    });
};

/**
 * Discard Crossing Endpoint
 * Discard crossing.
 */
export const discardCrossing = <ThrowOnError extends boolean = true>(
    options: Options<DiscardCrossingData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, DiscardCrossingError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/tanks/crossings/{crossing_id}:discarded",
        ...options,
    });
};

/**
 * Repeat Crossing Endpoint
 * Repeat crossing.
 *
 * Returns the id of the new crossing.
 */
export const repeatCrossing = <ThrowOnError extends boolean = true>(
    options: Options<RepeatCrossingData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<RepeatCrossingResponse, RepeatCrossingError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/tanks/crossings/{crossing_id}:repeat",
        ...options,
    });
};

/**
 * Update Crossing Endpoint
 * Update crossing.
 */
export const updateCrossing = <ThrowOnError extends boolean = true>(
    options: Options<UpdateCrossingData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdateCrossingError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/tanks/crossings/{crossing_id}:update",
        ...options,
    });
};

/**
 * Print Crossing Label Endpoint
 * Print crossing label.
 */
export const printCrossingLabel = <ThrowOnError extends boolean = true>(
    options: Options<PrintCrossingLabelData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, PrintCrossingLabelError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/tanks/crossings/{crossing_id}/print_label",
        ...options,
    });
};

/**
 * Get Label Endpoint
 * Get tank label.
 */
export const getTankLabel = <ThrowOnError extends boolean = true>(options: Options<GetTankLabelData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetTankLabelResponse, GetTankLabelError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/tanks/{tank_id}/get_label",
        ...options,
    });
};

/**
 * Update Label Endpoint
 * Update tank label.
 */
export const updateTankLabel = <ThrowOnError extends boolean = true>(
    options: Options<UpdateTankLabelData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdateTankLabelError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/tanks/{tank_id}/update_label",
        ...options,
    });
};

/**
 * Get Tank Import Dialog Data Endpoint
 * Get tank import dialog data.
 *
 * Import dialog and it's data can be accessed (based on permissions) via:
 * # Tanks list (=> "Import Tanks" menu button)
 * # Tank crossing detail dialog (=> "Raise" button)
 */
export const getTankImportDialogData = <ThrowOnError extends boolean = true>(
    options?: Options<GetTankImportDialogDataData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<
        GetTankImportDialogDataResponse,
        GetTankImportDialogDataError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/tanks/get_tank_import_dialog_data",
        ...options,
    });
};

/**
 * Import Tanks Endpoint
 * Import tanks.
 *
 * ...will be called (based on permissions) in connection with:
 * # General tank import in tank list
 * # Raising a tank crossing in related detail dialog
 *
 * Returns list of imported tank ids (added to database).
 */
export const importTanks = <ThrowOnError extends boolean = true>(options: Options<ImportTanksData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ImportTanksResponse, ImportTanksError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/tanks/import_tanks",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Location Label Dialog Data Endpoint
 * Get tank location label dialog data.
 */
export const getTankLocationLabelDialogData = <ThrowOnError extends boolean = true>(
    options: Options<GetTankLocationLabelDialogDataData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetTankLocationLabelDialogDataResponse,
        GetTankLocationLabelDialogDataError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/tanks/location/{location_id}/location_label_dialog_data",
        ...options,
    });
};

/**
 * Update Location Label Endpoint
 * Update tank location label.
 */
export const updateTankLocationLabel = <ThrowOnError extends boolean = true>(
    options: Options<UpdateTankLocationLabelData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdateTankLocationLabelError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/tanks/location/{location_id}/label",
        ...options,
    });
};

/**
 * Update Templates
 * Change data of multiple severity assessment templates at once and roll back on error.
 */
export const updateSeverityAssessmentTemplates = <ThrowOnError extends boolean = true>(
    options: Options<UpdateSeverityAssessmentTemplatesData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, UpdateSeverityAssessmentTemplatesError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/templates",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Update Time Points
 * Change data of multiple time points at once and roll back on error.
 */
export const updateSeverityAssessmentTimePoints = <ThrowOnError extends boolean = true>(
    options: Options<UpdateSeverityAssessmentTimePointsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, UpdateSeverityAssessmentTimePointsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/severity_assessment/timepoints",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Competence Details Endpoint
 * Get dialog seed for competence details.
 */
export const getCompetenceDetails = <ThrowOnError extends boolean = true>(
    options?: Options<GetCompetenceDetailsData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<
        GetCompetenceDetailsResponse,
        GetCompetenceDetailsError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/competences/competence/details",
        ...options,
    });
};

/**
 * Delete Competence
 */
export const deleteCompetence = <ThrowOnError extends boolean = true>(
    options: Options<DeleteCompetenceData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, DeleteCompetenceError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/competences/competence/{competence_id}",
        ...options,
    });
};

/**
 * Update Competence
 */
export const updateCompetence = <ThrowOnError extends boolean = true>(
    options: Options<UpdateCompetenceData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<UpdateCompetenceResponse, UpdateCompetenceError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/competences/competence/{competence_id}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Create Competence
 */
export const createCompetence = <ThrowOnError extends boolean = true>(
    options: Options<CreateCompetenceData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<CreateCompetenceResponse, CreateCompetenceError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/competences/competence",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Put Competent User
 */
export const updateCompetentUserAssignment = <ThrowOnError extends boolean = true>(
    options: Options<UpdateCompetentUserAssignmentData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdateCompetentUserAssignmentError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/competences/assignment/{assignment_id}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Update User Certificate Types Endpoint
 * Update the user_certificate categories.
 */
export const updateUserCertificateTypes = <ThrowOnError extends boolean = true>(
    options: Options<UpdateUserCertificateTypesData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, UpdateUserCertificateTypesError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/user_certificates/user_certificate_types",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get New User Certificate Endpoint
 * Get a new user certificate dialog seed.
 */
export const getNewUserCertificateDialogSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetNewUserCertificateDialogSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetNewUserCertificateDialogSeedResponse,
        GetNewUserCertificateDialogSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/user_certificates/certificate/new",
        ...options,
    });
};

/**
 * Get Existing User Certificate Endpoint
 * Get an existing user certificate event dialog seed.
 */
export const getExistingUserCertificateDialogSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetExistingUserCertificateDialogSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetExistingUserCertificateDialogSeedResponse,
        GetExistingUserCertificateDialogSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/user_certificates/certificate/{user_certificate_id}",
        ...options,
    });
};

/**
 * Update User Certificate Endpoint
 * Update a user certificate.
 */
export const updateUserCertificate = <ThrowOnError extends boolean = true>(
    options: Options<UpdateUserCertificateData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdateUserCertificateError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/user_certificates/certificate/{user_certificate_id}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Add User Certificate Endpoint
 * Add a user certificate.
 */
export const addUserCertificate = <ThrowOnError extends boolean = true>(
    options: Options<AddUserCertificateData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<AddUserCertificateResponse, AddUserCertificateError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/user_certificates/certificate",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Active Owner List
 * Get a list of active owners.
 */
export const getActiveOwners = <ThrowOnError extends boolean = true>(
    options?: Options<GetActiveOwnersData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<GetActiveOwnersResponse, GetActiveOwnersError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/users/active_owners",
        ...options,
    });
};

/**
 * Get Responsible User List
 * Get a list of active owners.
 */
export const getResponsibles = <ThrowOnError extends boolean = true>(
    options: Options<GetResponsiblesData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetResponsiblesResponse, GetResponsiblesError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/users/responsibles",
        ...options,
    });
};

/**
 * Get Prefixes
 * Get a list of prefixes for a user.
 */
export const getPrefixes = <ThrowOnError extends boolean = true>(options?: Options<GetPrefixesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetPrefixesResponse, GetPrefixesError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/users/prefixes",
        ...options,
    });
};

/**
 * Get User List For Setting
 * Get a list of users for setting.
 */
export const getUsersForSetting = <ThrowOnError extends boolean = true>(
    options: Options<GetUsersForSettingData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetUsersForSettingResponse, GetUsersForSettingError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/users/for_setting",
        ...options,
    });
};

/**
 * Get Owners For Group Widget
 * Return a list of owners for a group widget.
 */
export const getOwnersForGroupWidget = <ThrowOnError extends boolean = true>(
    options?: Options<GetOwnersForGroupWidgetData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<
        GetOwnersForGroupWidgetResponse,
        GetOwnersForGroupWidgetError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/users/owners_for_group_widget",
        ...options,
    });
};

/**
 * Get User Status Endpoint
 * Get user status.
 */
export const getUserStatus = <ThrowOnError extends boolean = true>(
    options: Options<GetUserStatusData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetUserStatusResponse, GetUserStatusError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/users/{user_id}/status",
        ...options,
    });
};

/**
 * Set User Status Endpoint
 * Set user status.
 */
export const setUserStatus = <ThrowOnError extends boolean = true>(
    options: Options<SetUserStatusData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetUserStatusError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/users/{user_id}/status",
        ...options,
    });
};

/**
 * Add Color Rule Endpoint
 * Add a color rule.
 */
export const addColorRule = <ThrowOnError extends boolean = true>(options: Options<AddColorRuleData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, AddColorRuleError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/users/color_rules",
        ...options,
    });
};

/**
 * Delete Color Rule Endpoint
 * Delete a color rule.
 */
export const deleteColorRule = <ThrowOnError extends boolean = true>(
    options: Options<DeleteColorRuleData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, DeleteColorRuleError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/users/color_rules/{color_rule_id}",
        ...options,
    });
};

/**
 * Update Color Rule Endpoint
 * Update a color rule.
 */
export const updateColorRule = <ThrowOnError extends boolean = true>(
    options: Options<UpdateColorRuleData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdateColorRuleError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/users/color_rules/{color_rule_id}",
        ...options,
    });
};

/**
 * Delete Totp Secret Endpoint
 * Delete the totp secret for a user.
 */
export const removeTotpSecret = <ThrowOnError extends boolean = true>(
    options: Options<RemoveTotpSecretData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, RemoveTotpSecretError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/users/totp_secret/{user_id}",
        ...options,
    });
};

/**
 * Get Totp Secret Endpoint
 * Get the totp secret for a user.
 */
export const getTotpSecret = <ThrowOnError extends boolean = true>(
    options: Options<GetTotpSecretData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetTotpSecretResponse, GetTotpSecretError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/users/totp_secret/{user_id}",
        ...options,
    });
};

/**
 * Post Totp Secret Endpoint
 * Set the totp secret for a user.
 */
export const setTotpSecret = <ThrowOnError extends boolean = true>(
    options: Options<SetTotpSecretData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, SetTotpSecretError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/users/totp_secret/{user_id}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Webauthn Endpoint
 * Get webauthn registration options.
 */
export const getWebAuthnRegistrationOptions = <ThrowOnError extends boolean = true>(
    options?: Options<GetWebAuthnRegistrationOptionsData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<unknown, GetWebAuthnRegistrationOptionsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/users/webauthn",
        ...options,
    });
};

/**
 * Post Webauthn Endpoint
 * Register a webauthn device.
 */
export const registerWebAuthnDevice = <ThrowOnError extends boolean = true>(
    options: Options<RegisterWebAuthnDeviceData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, RegisterWebAuthnDeviceError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/users/webauthn",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Delete Webauthn Device Endpoint
 * Delete a webauthn device.
 */
export const removeWebAuthnDevice = <ThrowOnError extends boolean = true>(
    options: Options<RemoveWebAuthnDeviceData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, RemoveWebAuthnDeviceError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/users/webauthn/{device_id}",
        ...options,
    });
};

/**
 * Post Saml User Id
 * Set the SAML remote user id for a local user.
 */
export const setSamlRemoteUserId = <ThrowOnError extends boolean = true>(
    options: Options<SetSamlRemoteUserIdData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, SetSamlRemoteUserIdError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/users/saml",
        ...options,
    });
};

/**
 * Get New User Details Endpoint
 * Get user details seed for new users.
 */
export const getNewUserDetailsSeed = <ThrowOnError extends boolean = true>(
    options?: Options<GetNewUserDetailsSeedData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<
        GetNewUserDetailsSeedResponse,
        GetNewUserDetailsSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/users/users/new",
        ...options,
    });
};

/**
 * Create User Endpoint
 * Update details of an existing user.
 */
export const createNewUser = <ThrowOnError extends boolean = true>(
    options: Options<CreateNewUserData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<CreateNewUserResponse, CreateNewUserError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/users/users/new",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Ldap Listing Endpoint
 * Get a list of users from LDAP.
 */
export const listLdapUsers = <ThrowOnError extends boolean = true>(
    options: Options<ListLdapUsersData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<ListLdapUsersResponse, ListLdapUsersError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/users/ldap/users",
        ...options,
    });
};

/**
 * Get Ldap User Details Endpoint
 * Get a list of users from LDAP.
 */
export const getLdapUserDetails = <ThrowOnError extends boolean = true>(
    options: Options<GetLdapUserDetailsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<GetLdapUserDetailsResponse, GetLdapUserDetailsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/users/ldap/users/{username}",
        ...options,
    });
};

/**
 * Update User Details From Ldap Endpoint
 * Update user details from LDAP.
 */
export const updateUserDetailsFromLdap = <ThrowOnError extends boolean = true>(
    options: Options<UpdateUserDetailsFromLdapData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdateUserDetailsFromLdapError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/users/users/{user_id}/from_ldap",
        ...options,
    });
};

/**
 * Get Existing User Details Endpoint
 * Get user details seed.
 */
export const getExistingUserDetailsSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetExistingUserDetailsSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetExistingUserDetailsSeedResponse,
        GetExistingUserDetailsSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/users/users/{user_id}",
        ...options,
    });
};

/**
 * Update Existing User Details Endpoint
 * Update details of an existing user.
 */
export const updateExistingUser = <ThrowOnError extends boolean = true>(
    options: Options<UpdateExistingUserData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdateExistingUserError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/users/users/{user_id}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Set User Permissions By Owner Endpoint
 * Set owner-based permissions and remove all location-based permissions.
 */
export const setUserPermissionsByOwner = <ThrowOnError extends boolean = true>(
    options: Options<SetUserPermissionsByOwnerData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetUserPermissionsByOwnerError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/users/users/{user_id}/owner_based_permissions",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Set User Permissions By Location Endpoint
 * Set location-based permissions and remove all owner-based permissions.
 */
export const setUserPermissionsByLocation = <ThrowOnError extends boolean = true>(
    options: Options<SetUserPermissionsByLocationData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetUserPermissionsByLocationError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/users/users/{user_id}/location_based_permissions",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Set User Password Endpoint
 * Set the password for a user.
 */
export const setUserPassword = <ThrowOnError extends boolean = true>(
    options: Options<SetUserPasswordData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetUserPasswordError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/users/users/{user_id}/password",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Set User Level Endpoint
 * Set the level for a user.
 */
export const setUserLevel = <ThrowOnError extends boolean = true>(options: Options<SetUserLevelData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<unknown, SetUserLevelError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/users/users/{user_id}/level",
        ...options,
    });
};

/**
 * Get Wellplate Export Seed Endpoint
 * Get the seed for exporting wellplates.
 */
export const getWellplatesExportSeed = <ThrowOnError extends boolean = true>(
    options?: Options<GetWellplatesExportSeedData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<
        GetWellplatesExportSeedResponse,
        GetWellplatesExportSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/wellplates/export_seed",
        ...options,
    });
};

/**
 * Get Dialog Options Endpoint
 * Get the options for the wellplate picker.
 */
export const getWellplatesDialogSeed = <ThrowOnError extends boolean = true>(
    options?: Options<GetWellplatesDialogSeedData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<
        GetWellplatesDialogSeedResponse,
        GetWellplatesDialogSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/wellplates/dialog_seed",
        ...options,
    });
};

/**
 * Add Wellplate Endpoint
 * Add a wellplate.
 */
export const addWellplate = <ThrowOnError extends boolean = true>(options: Options<AddWellplateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, AddWellplateError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/wellplates",
        ...options,
    });
};

/**
 * Delete Wellplate Endpoint
 * Delete a wellplate.
 *
 * Requirements for deletion:
 * - wellplate exists (for given wellplate_id) and
 * - wellplate has no related animals/pups and
 * - wellplate status is "active" or "ready"
 */
export const deleteWellplate = <ThrowOnError extends boolean = true>(
    options: Options<DeleteWellplateData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, DeleteWellplateError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/wellplates/{wellplate_id}",
        ...options,
    });
};

/**
 * Update Wellplate Endpoint
 * Update a wellplate.
 */
export const updateWellplate = <ThrowOnError extends boolean = true>(
    options: Options<UpdateWellplateData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdateWellplateError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/wellplates/{wellplate_id}",
        ...options,
    });
};

/**
 * Update Used Wellplate Endpoint
 * Update a wellplate that has some animals assigned.
 *
 * In that case not all the fields can be modified.
 */
export const updateUsedWellplate = <ThrowOnError extends boolean = true>(
    options: Options<UpdateUsedWellplateData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdateUsedWellplateError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/wellplates/{wellplate_id}/used",
        ...options,
    });
};

/**
 * Set Wellplate Ready Endpoint
 */
export const setWellplateReady = <ThrowOnError extends boolean = true>(
    options: Options<SetWellplateReadyData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetWellplateReadyError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/wellplates/{wellplate_id}:ready",
        ...options,
    });
};

/**
 * Set Wellplate Exported Endpoint
 */
export const setWellplateExported = <ThrowOnError extends boolean = true>(
    options: Options<SetWellplateExportedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetWellplateExportedError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/wellplates/exported",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Set Wellplate Active Endpoint
 */
export const reopenWellplate = <ThrowOnError extends boolean = true>(
    options: Options<ReopenWellplateData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, ReopenWellplateError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/wellplates/{wellplate_id}:open",
        ...options,
    });
};

/**
 * Set Wellplate Closed Endpoint
 * Close a wellplate.
 */
export const setWellplateClosed = <ThrowOnError extends boolean = true>(
    options: Options<SetWellplateClosedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetWellplateClosedError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/wellplates/{wellplate_id}:closed",
        ...options,
    });
};

/**
 * Invalidate Wellplate Position Endpoint
 * Invalidate a wellplate position.
 */
export const invalidateWellplatePosition = <ThrowOnError extends boolean = true>(
    options: Options<InvalidateWellplatePositionData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, InvalidateWellplatePositionError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/wellplates/{wellplate_id}/{wellplate_position}",
        ...options,
    });
};

/**
 * Get Picker Options Endpoint
 * Get the options for the wellplate picker.
 */
export const getWellplatePickerOptions = <ThrowOnError extends boolean = true>(
    options: Options<GetWellplatePickerOptionsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<
        GetWellplatePickerOptionsResponse,
        GetWellplatePickerOptionsError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/wellplates/{wellplate_id}/picker_options",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Work Request Class Details Endpoint
 * Get dialog seed for work request class details
 */
export const getWorkRequestClassDetails = <ThrowOnError extends boolean = true>(
    options?: Options<GetWorkRequestClassDetailsData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).get<
        GetWorkRequestClassDetailsResponse,
        GetWorkRequestClassDetailsError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/work_request_classes/details",
        ...options,
    });
};

/**
 * Create Work Request Class Endpoint
 * Create a new work request class.
 */
export const createWorkRequestClass = <ThrowOnError extends boolean = true>(
    options: Options<CreateWorkRequestClassData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<
        CreateWorkRequestClassResponse,
        CreateWorkRequestClassError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/work_request_classes",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Delete Work Request Class Endpoint
 * Delete a work request class.
 */
export const deleteWorkRequestClass = <ThrowOnError extends boolean = true>(
    options: Options<DeleteWorkRequestClassData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, DeleteWorkRequestClassError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/work_request_classes/{work_request_class_id}",
        ...options,
    });
};

/**
 * Update Work Request Class Endpoint
 * Update a work request class.
 */
export const updateWorkRequestClass = <ThrowOnError extends boolean = true>(
    options: Options<UpdateWorkRequestClassData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, UpdateWorkRequestClassError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/work_request_classes/{work_request_class_id}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Deactivate Work Request Class Endpoint
 * Deactivate a work request class.
 */
export const deactivateWorkRequestClass = <ThrowOnError extends boolean = true>(
    options: Options<DeactivateWorkRequestClassData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, DeactivateWorkRequestClassError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/work_request_classes/{work_request_class_id}/inactive",
        ...options,
    });
};

/**
 * Activate Work Request Class Endpoint
 * Activate a work request class.
 */
export const activateWorkRequestClass = <ThrowOnError extends boolean = true>(
    options: Options<ActivateWorkRequestClassData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, ActivateWorkRequestClassError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/work_request_classes/{work_request_class_id}/active",
        ...options,
    });
};

/**
 * Update Work Request Statuses
 * Update the work request statuses.
 */
export const updateWorkRequestStatuses = <ThrowOnError extends boolean = true>(
    options: Options<UpdateWorkRequestStatusesData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, UpdateWorkRequestStatusesError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/work_request_statuses",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Add To Request Selection Endpoint
 * Add a subject to the request selection.
 */
export const addToRequestSelection = <ThrowOnError extends boolean = true>(
    options?: Options<AddToRequestSelectionData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).put<unknown, AddToRequestSelectionError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/work_requests/add_to_request_selection",
        ...options,
    });
};

/**
 * Validate Global Work Request Selection
 * Validate animals/pups/cages in global selection for work request
 *
 * Return a warning and error messages for animals/pups and for cages, if necessary.
 */
export const validateGlobalWorkRequestSelection = <ThrowOnError extends boolean = true>(
    options: Options<ValidateGlobalWorkRequestSelectionData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<
        ValidateGlobalWorkRequestSelectionResponse,
        ValidateGlobalWorkRequestSelectionError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/work_requests/validate_global_select",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Work Request Additional Fields
 * Get the additional input fields for a work request class.
 */
export const getWorkRequestAdditionalFields = <ThrowOnError extends boolean = true>(
    options: Options<GetWorkRequestAdditionalFieldsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetWorkRequestAdditionalFieldsResponse,
        GetWorkRequestAdditionalFieldsError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/work_requests/additional_fields",
        ...options,
    });
};

/**
 * Get New Work Request Dialog Seed Endpoint
 * Get dialog seed for the new work request dialog.
 *
 * :param preselect_wr_class_id: Optional. The work request class to be preselected in the new work request.
 *
 * :param require_wr_behavior: Optional. The work request behavior to be shown in the new work request.
 * Defaults to all work request behaviors.
 */
export const getNewWorkRequestDialogSeed = <ThrowOnError extends boolean = true>(
    options?: Options<GetNewWorkRequestDialogSeedData, ThrowOnError>,
) => {
    return (options?.client ?? _heyApiClient).post<
        GetNewWorkRequestDialogSeedResponse,
        GetNewWorkRequestDialogSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/work_requests/new/seed",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Create Work Request Endpoint
 * Create a new work request.
 */
export const createWorkRequest = <ThrowOnError extends boolean = true>(
    options: Options<CreateWorkRequestData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).post<unknown, CreateWorkRequestError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/work_requests",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Work Request Details Endpoint
 * Get dialog seed for work request details
 */
export const getWorkRequestDetails = <ThrowOnError extends boolean = true>(
    options: Options<GetWorkRequestDetailsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetWorkRequestDetailsResponse,
        GetWorkRequestDetailsError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/work_requests/details",
        ...options,
    });
};

/**
 * Set Work Request Due Date Endpoint
 * Set the due date for a work request.
 */
export const setWorkRequestDueDate = <ThrowOnError extends boolean = true>(
    options: Options<SetWorkRequestDueDateData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetWorkRequestDueDateError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/work_requests/{work_request_id}/due_date",
        ...options,
    });
};

/**
 * Set Work Request Approved Endpoint
 * Set the work request as approved.
 */
export const setWorkRequestApproved = <ThrowOnError extends boolean = true>(
    options: Options<SetWorkRequestApprovedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetWorkRequestApprovedError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/work_requests/{work_request_id}/approve",
        ...options,
    });
};

/**
 * Set Work Request Rejected Endpoint
 * Set the work request as rejected.
 */
export const setWorkRequestRejected = <ThrowOnError extends boolean = true>(
    options: Options<SetWorkRequestRejectedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetWorkRequestRejectedError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/work_requests/{work_request_id}/reject",
        ...options,
    });
};

/**
 * Perform Work Request Move Cage Endpoint
 * Perform a work request with 'move_cage' behavior.
 */
export const performWorkRequestMoveCage = <ThrowOnError extends boolean = true>(
    options: Options<PerformWorkRequestMoveCageData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, PerformWorkRequestMoveCageError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/work_requests/{work_request_id}/perform_move_cage",
        ...options,
    });
};

/**
 * Set Work Request Additional Fields Endpoint
 * Save the additional fields for a work request.
 */
export const setWorkRequestAdditionalFields = <ThrowOnError extends boolean = true>(
    options: Options<SetWorkRequestAdditionalFieldsData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetWorkRequestAdditionalFieldsError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/work_requests/{work_request_id}/additional_fields",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options?.headers,
        },
    });
};

/**
 * Get Work Request Class Dialog Seed Endpoint
 * Get details for the work request SetClass-Dialog.
 */
export const getWorkRequestClassDialogSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetWorkRequestClassDialogSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetWorkRequestClassDialogSeedResponse,
        GetWorkRequestClassDialogSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/work_requests/{work_request_id}/class_dialog",
        ...options,
    });
};

/**
 * Set Work Request Class Endpoint
 * Set the class for a work request.
 */
export const setWorkRequestClass = <ThrowOnError extends boolean = true>(
    options: Options<SetWorkRequestClassData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetWorkRequestClassError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/work_requests/{work_request_id}/class",
        ...options,
    });
};

/**
 * Get Work Request Location Dialog Seed Endpoint
 * Get details for the work request SetLocation-Dialog.
 */
export const getWorkRequestLocationDialogSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetWorkRequestLocationDialogSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetWorkRequestLocationDialogSeedResponse,
        GetWorkRequestLocationDialogSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/work_requests/{work_request_id}/location_dialog",
        ...options,
    });
};

/**
 * Set Work Request Location Endpoint
 * Set the location for a work request.
 */
export const setWorkRequestLocation = <ThrowOnError extends boolean = true>(
    options: Options<SetWorkRequestLocationData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetWorkRequestLocationError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/work_requests/{work_request_id}/location",
        ...options,
    });
};

/**
 * Get Work Request Priority Dialog Seed Endpoint
 * Get details for the work request SetPriority-Dialog.
 */
export const getWorkRequestPriorityDialogSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetWorkRequestPriorityDialogSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetWorkRequestPriorityDialogSeedResponse,
        GetWorkRequestPriorityDialogSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/work_requests/{work_request_id}/priority_dialog",
        ...options,
    });
};

/**
 * Set Work Request Priority Endpoint
 * Set the priority for a work request.
 */
export const setWorkRequestPriority = <ThrowOnError extends boolean = true>(
    options: Options<SetWorkRequestPriorityData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetWorkRequestPriorityError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/work_requests/{work_request_id}/priority",
        ...options,
    });
};

/**
 * Get Work Request Project
 * Get assigned project id from work request
 */
export const getWorkRequestProject = <ThrowOnError extends boolean = true>(
    options: Options<GetWorkRequestProjectData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetWorkRequestProjectResponse,
        GetWorkRequestProjectError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/work_requests/{request_id}/project",
        ...options,
    });
};

/**
 * Set Work Request Project
 * Set project id for work request
 */
export const setWorkRequestProject = <ThrowOnError extends boolean = true>(
    options: Options<SetWorkRequestProjectData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetWorkRequestProjectError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/work_requests/{request_id}/project",
        ...options,
    });
};

/**
 * Get Work Request Responsible Dialog Seed Endpoint
 * Get details for the work request SetResponsible-Dialog.
 */
export const getWorkRequestResponsibleDialogSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetWorkRequestResponsibleDialogSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetWorkRequestResponsibleDialogSeedResponse,
        GetWorkRequestResponsibleDialogSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/work_requests/{work_request_id}/responsible_dialog",
        ...options,
    });
};

/**
 * Set Work Request Responsible Endpoint
 * Set the responsible for a work request.
 */
export const setWorkRequestResponsible = <ThrowOnError extends boolean = true>(
    options: Options<SetWorkRequestResponsibleData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetWorkRequestResponsibleError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/work_requests/{work_request_id}/responsible",
        ...options,
    });
};

/**
 * Get Work Request Status Dialog Seed Endpoint
 * Get details for the work request SetStatus-Dialog.
 */
export const getWorkRequestStatusDialogSeed = <ThrowOnError extends boolean = true>(
    options: Options<GetWorkRequestStatusDialogSeedData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetWorkRequestStatusDialogSeedResponse,
        GetWorkRequestStatusDialogSeedError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/work_requests/{work_request_id}/status_dialog",
        ...options,
    });
};

/**
 * Set Work Request Status Endpoint
 * Set the status for a work request.
 */
export const setWorkRequestStatus = <ThrowOnError extends boolean = true>(
    options: Options<SetWorkRequestStatusData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, SetWorkRequestStatusError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/work_requests/{work_request_id}/status",
        ...options,
    });
};

/**
 * Add Animals To Work Request Endpoint
 * Add animals/pups from selection to a work request.
 */
export const addAnimalsToWorkRequest = <ThrowOnError extends boolean = true>(
    options: Options<AddAnimalsToWorkRequestData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, AddAnimalsToWorkRequestError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/work_requests/{work_request_id}/add_animals",
        ...options,
    });
};

/**
 * Add Cages To Work Request Endpoint
 * Add cages from selection to a work request.
 */
export const addCagesToWorkRequest = <ThrowOnError extends boolean = true>(
    options: Options<AddCagesToWorkRequestData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, AddCagesToWorkRequestError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/work_requests/{work_request_id}/add_cages",
        ...options,
    });
};

/**
 * Add Tanks To Work Request Endpoint
 * Add tankss from selection to a work request.
 */
export const addTanksToWorkRequest = <ThrowOnError extends boolean = true>(
    options: Options<AddTanksToWorkRequestData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, AddTanksToWorkRequestError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/work_requests/{work_request_id}/add_tanks",
        ...options,
    });
};

/**
 * Remove Animal From Work Request Endpoint
 * Remove an animal from a work request.
 */
export const removeAnimalFromWorkRequest = <ThrowOnError extends boolean = true>(
    options: Options<RemoveAnimalFromWorkRequestData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, RemoveAnimalFromWorkRequestError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/work_requests/{work_request_id}/animals/{animal_id}",
        ...options,
    });
};

/**
 * Remove Pup From Work Request Endpoint
 * Remove a pup from a work request.
 */
export const removePupFromWorkRequest = <ThrowOnError extends boolean = true>(
    options: Options<RemovePupFromWorkRequestData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, RemovePupFromWorkRequestError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/work_requests/{work_request_id}/pups/{pup_id}",
        ...options,
    });
};

/**
 * Remove Cage From Work Request Endpoint
 * Remove a cage from a work request.
 */
export const removeCageFromWorkRequest = <ThrowOnError extends boolean = true>(
    options: Options<RemoveCageFromWorkRequestData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, RemoveCageFromWorkRequestError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/work_requests/{work_request_id}/cages/{cage_id}",
        ...options,
    });
};

/**
 * Remove Tank From Work Request Endpoint
 * Remove a tank from a work request.
 */
export const removeTankFromWorkRequest = <ThrowOnError extends boolean = true>(
    options: Options<RemoveTankFromWorkRequestData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).delete<unknown, RemoveTankFromWorkRequestError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/work_requests/{work_request_id}/tanks/{tank_id}",
        ...options,
    });
};

/**
 * Highlight Workrequest Cages
 * Highlight cages in a work request.
 */
export const highlightWorkrequestCages = <ThrowOnError extends boolean = true>(
    options: Options<HighlightWorkrequestCagesData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).put<unknown, HighlightWorkrequestCagesError, ThrowOnError>({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/work_requests/{work_request_id}/highlight",
        ...options,
    });
};

/**
 * Get Work Request Class Planned Procedures
 * Get the planned procedures for a work request class.
 */
export const getWorkRequestClassPlannedProcedures = <ThrowOnError extends boolean = true>(
    options: Options<GetWorkRequestClassPlannedProceduresData, ThrowOnError>,
) => {
    return (options.client ?? _heyApiClient).get<
        GetWorkRequestClassPlannedProceduresResponse,
        GetWorkRequestClassPlannedProceduresError,
        ThrowOnError
    >({
        security: [
            {
                scheme: "bearer",
                type: "http",
            },
        ],
        url: "/work_requests/work_request_class/planned_procedures",
        ...options,
    });
};
